import React, { Component } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Image,
  InputGroup
} from "react-bootstrap";
import Files from "react-files";
import { Link, withRouter, Prompt, Redirect } from "react-router-dom";
import { CreateProjectLocation } from "./CreateProjectLocation";
import { DatePicker } from "../../component/DatePicker";
import IndiaMap from "../../assets/india-map.png";
import IndiaEmblem from "../../assets/india-emblem.png";
import GreenField from "../../assets/green-field.png";
import BrownField from "../../assets/brown-field.png";
import IconPlus from "../../assets/icon-plus.svg";
import IconSave from "../../assets/icon-save.png";
import IconDelete from "../../assets/icon-delete.svg";
import cabinet_milestones_btn from "../../assets/cabinet_milestones_btn.svg";
import queryString from "query-string";
import {
  createProjectAction,
  getValidateCinAction,
  getSchemesListAction,
  getSubSectorListAction,
  getProjectPageInfoAction,
  getCostDistanceAction,
  getGroupCategoryIdAction,
  editProjectAction,
  isDuplicateProjectAction,
  getAutoCompleteListAction,
  getAutoCompleteListUserAction,
  getDistrictListForLocation,
  getGroupsByCategoryAction,
  getBucketsWithMilestonesBySectorAction,
  getResponsibleAuthorityForMilestonesAction,
  createMilestoneAction,
  saveNewMilestoneAction,
  deleteNewMilestoneAction,
  editProjectMilestonesAction,
  checkIssueBeforeDeletion,
  checkIssueBeforeDisable,
  bucketDisableIssueCheck,
  getProjectDetailByIdAction,
  getGroupRolesForUser,
  getCircleListForLocation
} from "../../actions/createProject.action";
import {
  _updateDraftedMilestones,
  changeProjectStatus
} from "../../actions/projectDetail.action";
import {
  uploadFileAction,
  removeFileAction,
  getIssuesCategoryListAction,
  getProjectList,
  getSectorBasedOnSponsoringDepartment,
  getDistrictList,
  getDivisionList,
  uploadFileTitleAction
} from "../../actions/common.action";
import { setProjectDataAction } from "../../actions/formData.action";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import {
  get,
  debounce,
  isString,
  find,
  isEmpty,
  isFunction,
  sortBy
} from "lodash";
import {
  onlyNumbers,
  onlyForCostNumbers,
  numberWithDecimal
} from "../../validation";
import {
  FormDataForImage,
  dateFormat,
  clearDebounce,
  isValidArray,
  transformProjectCategoryId,
  GROUP_KEYS,
  scrollToPosition,
  setLocalstorage,
  editDataOfAddIssue,
  projectFormLabel,
  normalizeId
} from "../../helper";
import {
  modifyDataForPost,
  PROJECT_STATUS,
  defaultState,
  getSelectedOptionImage,
  modifyDataForDraftProject,
  modifyDataForIIGDraftProject,
  getSelectedStatePmgConstituted,
  getSelectedStateProjectName,
  setIncomingDataForMilestone,
  setOutgoingDataForMilestone,
  editMilestoneDependency
} from "./helper";
import {
  STATUS,
  IMAGE_FORMATS,
  DOCUMENT_FORMATS,
  PATHS,
  ERROR_MSG,
  IIG_PATHS,
  FILE_SIZE_LIMIT
} from "../../constant";
import { LoaderPage } from "../../component/Loader";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { toast } from "react-toastify";
import DisplayByPermission from "../../component/DisplayByPermission";
import { clearProjectDataAction } from "../../actions/formData.action";
import { validateDuplicatedIssue, getLocalstorage } from "../../helper";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { AutoSuggestSelect } from "../../component/AutoSuggestSelect";
import { Status } from "./sections/status";
import PermissionHOC from "../PermissionHOC";
import TooltipComponent from "../../component/TooltipComponent";
import { getDraftedProjectDetails } from "../../actions/projectDetail.action";
import PragatiReviewDates from "./pragatiReviewDates";
import SecretaryReviewDate from "./secretaryReviewDate";
import ModalVerifyIIGProject from "./ModalVerifyIIGProject";
import ModalRejectIIGProject from "./ModalRejectIIGProject";
import moment from "moment";
import OtherPP from "./OtherPP";
import Bucket from "./Milestones/Buckets";
import {
  integer_to_roman,
  _getMinMaxDates
} from "./Milestones/milestone.helper";
import { iigBaseUrl } from "../../globalConfig";
import { CreateProjectExtension } from "./CreateProjectExtension";
import { successToastStyle, errorToastStyle } from "../../customToast";

import {
  getSponsoringAgency,
  getProjectDetail,
  postCostDistributionData,
  getCostDistributionData,
  updateCostDistributionData
} from "../../services/apiServices";
import {
  getStateDistrictAndDepartmentCreateProject,
  _getDraftedProjectDetails
} from "../../services/apiServices";
import request from "../../services/requestService";
import CreateProjectCircle from "./CreateProjectCircle";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
// import CabinetMilestonesTable from "./Milestones/CabinetMilestonesTable";
const NUMERIC_KEYS = [
  "cost",
  "fdi",
  "distance",
  "revisedCost",
  "projectImplementationDirectEmployment",
  "projectImplementationInDirectEmployment",
  "centralCost",
  "stateCost",
  "populationBenefitted",
  "fundReleaseCost",
  "centralProjectShare",
  "stateProjectShare"
];

const CABINET_MILESTONE_COST_BASED_GROUP_IDS = [
  36,
  37,
  47,
  166,
  "36",
  "37",
  "47",
  "166"
];
const STATE_DEPARTMENT_KEYS = [];
export class CreateProjectForm extends Component {
  state = defaultState();
  underMaintenance = false;
  callTitleApi = null;
  autoSuggestApi = null;
  maxNameFieldLength = 185;
  // stateWiseData = [];
  callForEditMilestones = async (value, projectPPList) => {
    let {
      getBucketsWithMilestonesBySectorAction,
      getResponsibleAuthorityForMilestonesAction,
      sponsoredByCategory,
      _sectorId,
      _implementationMode
    } = this.props;

    let resp = await getBucketsWithMilestonesBySectorAction(+value);
    getResponsibleAuthorityForMilestonesAction();

    if (resp) {
      let _data = setIncomingDataForMilestone(
        resp && resp.data,
        null,
        projectPPList
      );
      const updatedData = [872, 879].includes(_sectorId) ? _data : _data;
      const updated_Data =
        sponsoredByCategory == "STATE" || _implementationMode == "PRIVATE" // <-- add PRIVATE check
          ? updatedData.filter(item => item.bucketName !== "Cabinet Milestone")
          : updatedData;
      updated_Data.map(item => {
        if (item.bucketName === "Cabinet Milestone") {
          // console.log(item)
          item.milestoneTableDataCOS[0].phaseName = null;
        }
      });
      // this.setState({
      //   bucketMilestoneCOS: updated_Data || [],
      //   selectedBucketId: 1
      // });
      this.setState({
        bucketMilestoneCOS:
          this.setCabinetMilestonePhaseIndex(updated_Data) || [],
        selectedBucketId: 1
      });
    }
  };
  cabinetBucketHasData = item => {
    var milestoneDataCOS = [];

    if (
      item &&
      item.milestoneTableDataCOS &&
      Array.isArray(item.milestoneTableDataCOS)
    ) {
      item.milestoneTableDataCOS.forEach(function(table) {
        if (table.milestoneDataCOS && Array.isArray(table.milestoneDataCOS)) {
          milestoneDataCOS = milestoneDataCOS.concat(table.milestoneDataCOS);
        }
      });
    }

    return milestoneDataCOS.some(function(milestone) {
      return (
        milestone.originalScheduledStartDate != null ||
        milestone.revisedScheduledStartDate != null ||
        milestone.originalScheduledFinishDate != null ||
        milestone.revisedScheduledFinishDate != null ||
        milestone.responsibleAuthorityId != null ||
        milestone.responsibleAuthorityName != null ||
        milestone.dependencyType != null ||
        milestone.reasonForDelay != null ||
        milestone.dependentOnId != null ||
        milestone.dependentOnName != null
      );
    });
  };
  // Checks whether any milestone inside the Cabinet Milestone bucket
  // actually has data entered (dates, completion, responsible authority, etc.)
  hasCabinetMilestoneData = cabinetBucket => {
    if (!cabinetBucket || !isValidArray(cabinetBucket.milestoneTableDataCOS)) {
      return false;
    }
    return cabinetBucket.milestoneTableDataCOS.some(
      table =>
        isValidArray(table.milestoneDataCOS) &&
        table.milestoneDataCOS.some(
          ms =>
            !!ms.originalScheduledStartDate ||
            !!ms.revisedScheduledStartDate ||
            !!ms.originalScheduledFinishDate ||
            !!ms.revisedScheduledFinishDate ||
            !!ms.completed ||
            !!ms.responsibleAuthorityId ||
            !!ms.otherResponsibleAuthority ||
            !!ms.reasonForDelay
        )
    );
  };

  isCostBasedCabinetMinistry = groupId => {
    return CABINET_MILESTONE_COST_BASED_GROUP_IDS.includes(groupId);
  };
  isCabinetMilestoneMandatoryExempt = () => {
    const { groupId } = this.state;
    // Cabinet Milestone stays cost-gated (mandatory) ONLY for the 4 specified
    // ministries. Every other ministry is exempt regardless of Project Cost.
    return !this.isCostBasedCabinetMinistry(groupId);
  };

  isCabinetMilestoneMandatoryExemptEdit = () => {
    const { groupId } = this.props;
    return !this.isCostBasedCabinetMinistry(groupId);
  };
  setCabinetMilestonePhaseIndex = (bucketMilestoneCOS = []) => {
    if (!isValidArray(bucketMilestoneCOS)) return bucketMilestoneCOS;

    const cabinetBucket = bucketMilestoneCOS.find(
      item => item.bucketName === "Cabinet Milestone"
    );

    if (cabinetBucket && isValidArray(cabinetBucket.milestoneTableDataCOS)) {
      cabinetBucket.milestoneTableDataCOS.forEach(table => {
        if (isValidArray(table.milestoneDataCOS)) {
          table.milestoneDataCOS.forEach(milestone => {
            milestone.phaseIndex = 1;
          });
        }
      });
    }

    return bucketMilestoneCOS;
  };
  ZIndex = value => {
    // this.setState({ ZIndex: value });
    document.documentElement.style.setProperty("--disable-btn-z", value);
  };
  // call apis
  componentDidMount = async () => {
    const {
      getProjectPageInfoDispatch,
      getIssuesCategoryListAction,
      previewData,
      isEdit: propsIsEdit,
      projectId: propsProjectId,
      getDraftedProjectDetails,
      location,
      getBucketsWithMilestonesBySectorAction,
      getResponsibleAuthorityForMilestonesAction,
      bucketMilestoneCOS,
      openMilestoneEdit,
      _sectorId,
      // _cost,
      _subSectorId,
      projectPPList,
      getProjectDetailByIdDispatch,
      isIIGProject: propsIsIIGProject,
      permission,
      iigProjectReferenceId,
      _implementationMode,
      sponsoredByCategory
    } = this.props;
    const isIIGDraftProject = location.pathname === "/iig-project-detail";
    const isEdit = propsIsEdit || isIIGProject;
    const isIIGProject = propsIsIIGProject || isIIGDraftProject;
    const userCanOnlyCreateCentralProject =
      !isEdit &&
      get(permission, "createCentralProject") &&
      !get(permission, "createStateProject");
    const userCanOnlyCreateStateProject =
      !isEdit &&
      get(permission, "createStateProject") &&
      !get(permission, "createCentralProject");

    if (userCanOnlyCreateCentralProject) {
      this.setState({
        userCanOnlyCreateCentralProject,
        projectCategoryId: GROUP_KEYS.CENTRAL
      });
    }
    if (userCanOnlyCreateStateProject) {
      this.setState({
        userCanOnlyCreateStateProject,
        projectCategoryId: GROUP_KEYS.STATE
      });
    }
    const userInfo = getLocalstorage("user");
    getGroupRolesForUser(userInfo.groupId)(response => {
      this.setState({
        userGroupInfo: response.payLoadData
      });
    });

    const projectId =
      propsProjectId ||
      (isIIGDraftProject && queryString.parse(location.search).projectId);
    let id = _subSectorId ? _subSectorId : _sectorId;
    // let _draftedProject1 = getLocalstorage("draftedProject");
    if (openMilestoneEdit && bucketMilestoneCOS && bucketMilestoneCOS.length) {
      let resp = await getBucketsWithMilestonesBySectorAction(id);
      getResponsibleAuthorityForMilestonesAction();
      let getUpdatedMilestones = editMilestoneDependency(
        bucketMilestoneCOS,
        projectPPList
      );
      if (
        sponsoredByCategory == "CENTRAL" &&
        _implementationMode != "PRIVATE"
      ) {
        const cabinetBucket = bucketMilestoneCOS.find(
          item => item.bucketName === "Cabinet Milestone"
        );
        const isCabinetInvalid =
          !cabinetBucket || cabinetBucket.disabled === true;
        const condition =
          bucketMilestoneCOS.every(item => item.disabled === true) ||
          isCabinetInvalid;
        const hasCabinetMilestone = getUpdatedMilestones.some(
          item => item.bucketName === "Cabinet Milestone"
        );

        // FIX: removed the duplicate `let resp = await getBucketsWithMilestonesBySectorAction(id);`
        // that used to be here — `resp` from above is reused instead.

        if (resp && condition) {
          let _data = setIncomingDataForMilestone(
            resp && resp.data,
            null,
            projectPPList
          );

          const updatedData1 = _data.map(item => {
            if (item.bucketName === "Cabinet Milestone") {
              return item;
            }
            const matchedItem = getUpdatedMilestones.find(
              obj => obj.bucketId === item.bucketId
            );
            return matchedItem || item;
          });
          updatedData1.map(item => {
            if (item.bucketName === "Cabinet Milestone") {
              item.milestoneTableDataCOS[0].phaseName = null;
            }
          });

          // FIX: always keep dates + Cabinet Milestone together — updatedData1
          // already merges getUpdatedMilestones (dates) onto _data (template,
          // which includes Cabinet Milestone), so no need to conditionally
          // strip it out or fall back to the undated `_data`.
          this.setState({
            bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex(
              updatedData1
            ),
            selectedBucketId: 1
          });
        } else if (!hasCabinetMilestone) {
          let _data = setIncomingDataForMilestone(
            resp && resp.data,
            null,
            projectPPList
          );
          const cabinetMilestone = _data.find(
            item => item.bucketName === "Cabinet Milestone"
          );

          if (cabinetMilestone) {
            cabinetMilestone.milestoneTableDataCOS[0].phaseName = null;
            getUpdatedMilestones.push(cabinetMilestone);
          }

          // this.setState({
          //   bucketMilestoneCOS: getUpdatedMilestones,
          //   selectedBucketId: 1
          // });
          this.setState({
            bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex(
              getUpdatedMilestones
            ),
            selectedBucketId: 1
          });
        } else {
          this.setState({
            bucketMilestoneCOS: getUpdatedMilestones,
            selectedBucketId: 1
          });
        }
      } else {
        const updatedData =
          _implementationMode == "PRIVATE"
            ? getUpdatedMilestones.filter(
                item => item.bucketName !== "Cabinet Milestone"
              )
            : getUpdatedMilestones;

        updatedData.map(item => {
          if (item.bucketName === "Cabinet Milestone") {
            // console.log(item)
            item.milestoneTableDataCOS[0].phaseName = null;
          }
        });
        // this.setState({
        //   bucketMilestoneCOS: updatedData,
        //   selectedBucketId: 1
        // });
        this.setState({
          bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex(updatedData),
          selectedBucketId: 1
        });
      }
    } else if (
      openMilestoneEdit &&
      bucketMilestoneCOS &&
      !bucketMilestoneCOS.length
    ) {
      this.callForEditMilestones(id, projectPPList);
    }
    let _draftedProject = getLocalstorage("draftedProject");
    if (
      ((location && location.state) || _draftedProject) &&
      !previewData &&
      !isIIGProject &&
      !openMilestoneEdit
    ) {
      let draftedProject;
      if (location && location.state) {
        draftedProject = location.state.draftedProject;
      }
      let _draftedProject = getLocalstorage("draftedProject");
      if (draftedProject || _draftedProject) {
        let resp = await getBucketsWithMilestonesBySectorAction(id);
        // let _data = setIncomingDataForMilestone(
        //   resp && resp.data,
        //   null,
        //   projectPPList
        // );
        getDraftedProjectDetails().then(async resp => {
          const draftprojId = resp && resp.data && resp.data.project.id;
          const draftLocation =
            resp &&
            resp.data &&
            resp.data.project &&
            resp.data.project.locations;
          this.setState({
            draftProjectId: draftprojId,
            draftLocation: draftLocation
          });
          const getCostData = request(
            getCostDistributionData({ projectId: draftprojId, active: true })
          );
          getCostData.then(resp => {
            this.setState({ stateWiseData: resp.data.data });
          });

          let draftedData =
            resp &&
            resp.data &&
            resp.data.project &&
            modifyDataForDraftProject(resp.data.project);

          let draftedIssueData =
            resp &&
            resp.data &&
            resp.data.issues &&
            editDataOfAddIssue({ issueCOList: resp.data.issues });

          // --- NEW: ensure Cabinet Milestone exists for CENTRAL / non-PRIVATE drafts ---
          const draftProject = resp && resp.data && resp.data.project;
          const draftSectorId =
            get(draftedData, "subSectorId") || get(draftedData, "sectorId");
          const isCentralSponsored =
            get(draftProject, "projectCategory") === "CENTRAL";
          const draftImplMode = get(draftProject, "implMode");
          const existingMilestones =
            (draftedData && draftedData.bucketMilestoneCOS) || [];
          const hasCabinetMilestone = existingMilestones.some(
            item => item.bucketName === "Cabinet Milestone"
          );
          if (
            draftedData &&
            draftSectorId &&
            isCentralSponsored &&
            draftImplMode !== "PRIVATE" &&
            !hasCabinetMilestone
          ) {
            const bucketResp = await getBucketsWithMilestonesBySectorAction(
              draftSectorId
            );
            const fullMilestoneData = setIncomingDataForMilestone(
              bucketResp && bucketResp.data,
              null,
              projectPPList
            );
            const cabinetMilestone = fullMilestoneData.find(
              item => item.bucketName === "Cabinet Milestone"
            );

            if (cabinetMilestone) {
              if (
                cabinetMilestone.milestoneTableDataCOS &&
                cabinetMilestone.milestoneTableDataCOS[0]
              ) {
                cabinetMilestone.milestoneTableDataCOS[0].phaseName = null;
                const previousCreatedBy = get(
                  draftProject,
                  "previousCreatedBy"
                );
                cabinetMilestone.milestoneTableDataCOS[0].phaseProponentId = get(
                  previousCreatedBy,
                  "id",
                  null
                );
                cabinetMilestone.milestoneTableDataCOS[0].phaseProponent = previousCreatedBy
                  ? { id: previousCreatedBy.id, name: previousCreatedBy.name }
                  : null;
              }

              // force disabled=true on initial load, regardless of what the API returned
              cabinetMilestone.disabled = false;

              // draftedData.bucketMilestoneCOS = [
              //   ...existingMilestones,
              //   cabinetMilestone
              // ];
              draftedData.bucketMilestoneCOS = this.setCabinetMilestonePhaseIndex(
                [...existingMilestones, cabinetMilestone]
              );
            }
          }
          // --- end NEW ---
          draftedData &&
            this.setState(
              {
                ...this.state,
                ...draftedData,
                issueCOList: draftedIssueData,
                selectedBucketId: 1,
                dataUnsaved: true
              },
              () => {
                this.setState({
                  issueCOList: draftedIssueData
                });
                this.getDepartmentList(get(draftedData, "sponsoredBy.id"));
                this.getGroupCategoryId().then(resp => {
                  if (get(draftedData, "sponsoredBy.id") && resp) {
                    this.getMinCost(get(draftedData, "sponsoredBy.id"));
                    this.getProjectTitle(get(draftedData, "sponsoredBy.id"));
                    if (this.state.cost) {
                      let _error = this.getErrorMsg(
                        this.state.cost + "",
                        "cost"
                      );
                      this.setState({ error: _error }, () => {
                        if (this.state.revisedCost) {
                          let error = this.getErrorMsg(
                            this.state.revisedCost + "",
                            "revisedCost"
                          );
                          this.setState({
                            error
                          });
                        }
                      });
                    } else {
                      if (this.state.revisedCost) {
                        let error = this.getErrorMsg(
                          this.state.revisedCost + "",
                          "revisedCost"
                        );
                        this.setState({
                          error
                        });
                      }
                    }
                  }
                });

                // Set the project draft data in the state
                this.setState({
                  ...draftedData
                });

                if (get(draftedData, "schemeId")) {
                  this.setState(
                    {
                      schemeId: get(draftedData, "schemeId")
                    },
                    () => {
                      this.getCostAndDistance({
                        sectorId: get(draftedData, "sectorId")
                      });
                    }
                  );
                }
                if (get(draftedData, "subSectorId")) {
                  this.getSubSectors(
                    {
                      sectorId: get(draftedData, "sectorId")
                    },
                    {
                      subSectorId: get(draftedData, "subSectorId")
                    },
                    { resetMilestones: false }
                  );
                }

                if (
                  get(draftedData, "subSectorId") ||
                  get(draftedData, "sectorId")
                ) {
                  let id = get(draftedData, "subSectorId")
                    ? get(draftedData, "subSectorId")
                    : get(draftedData, "sectorId");
                  getBucketsWithMilestonesBySectorAction(id);
                  getResponsibleAuthorityForMilestonesAction();
                }

                if (
                  get(draftedData, "schemeId") &&
                  get(draftedData, "subSectorId")
                ) {
                  this.getCostAndDistance({
                    sectorId: get(draftedData, "subSectorId")
                  });
                }
                if (get(draftedData, "sponsoredBy.parentId")) {
                  this.onSelectState();
                }
                if (
                  get(draftedData, "otherBankName") !== null &&
                  get(draftedData, "otherBankName") !== ""
                ) {
                  this.setState({
                    isOtherSelected: true
                  });
                }
                if (this.state.cin) {
                  this.validateCIN();
                }
              }
            );
        });
      }
    }

    if (isIIGProject) {
      this.setState({
        error: {
          projectImplementationSanctionDate: {
            error: false
          }
        }
      });
    }
    !isIIGProject &&
      previewData &&
      this.setState(
        {
          ...this.state,
          ...previewData,
          dataUnsaved: true,
          previewClicked: false
        },
        () => {
          if (isEdit) {
            this.setState({
              pli: this.props.pli ? true : false
            });

            this.getDepartmentList(get(previewData, "sponsoredBy.id"));
            this.getGroupCategoryId().then(resp => {
              if (get(previewData, "sponsoredBy.id") && resp) {
                this.getMinCost(get(previewData, "sponsoredBy.id"));
                this.getProjectTitle(get(previewData, "sponsoredBy.id"));
              }
            });
            this.getSubSectors(
              {
                sectorId: get(previewData, "sectorId")
              },
              {
                subSectorId: get(previewData, "subSectorId"),
                schemeId: get(previewData, "schemeId")
              },
              { resetMilestones: false }
            );

            if (
              get(previewData, "subSectorId") ||
              get(previewData, "sectorId")
            ) {
              let id = get(previewData, "subSectorId")
                ? get(previewData, "subSectorId")
                : get(previewData, "sectorId");
              getBucketsWithMilestonesBySectorAction(id);
              getResponsibleAuthorityForMilestonesAction();
            }

            if (
              get(previewData, "schemeId") &&
              get(previewData, "subSectorId")
            ) {
              this.getCostAndDistance({
                sectorId: get(previewData, "subSectorId")
              });
            }
            if (get(previewData, "sponsoredBy.parentId")) {
              this.onSelectState();
            }
            if (get(previewData, "otherPP") !== null) {
              this.setState({
                previousOtherPP: get(previewData, "otherPP")
              });
            }
            if (get(previewData, "implementationMode") !== null) {
              this.setState({
                implementationMode: get(previewData, "implementationMode")
              });
            }
            if (
              get(previewData, "otherBankName") !== null &&
              get(previewData, "otherBankName") !== ""
            ) {
              this.setState({
                isOtherSelected: true
              });
            }
          }
        }
      );
    getProjectPageInfoDispatch(undefined, isEdit, projectId);
    getIssuesCategoryListAction();
    !openMilestoneEdit && scrollToPosition({ top: 0 });
    if (isIIGProject || iigProjectReferenceId) {
      const iigProjectId = queryString.parse(location.search);
      getProjectDetailByIdDispatch(undefined, +iigProjectId.projectId).then(
        resp => {
          if (resp) {
            let iigDraftProject = modifyDataForIIGDraftProject(resp.data);
            this.setState(
              {
                ...defaultState(),
                ...iigDraftProject,
                ...previewData,
                bucketMilestoneCOS: this.state.bucketMilestoneCOS
              },
              () => {
                if (get(this.state, "subSectorId") !== null) {
                  this.getSubSectors(
                    { sectorId: get(this.state, "sectorId") },
                    { subSectorId: get(this.state, "subSectorId") },
                    { resetMilestones: false }
                  );
                }
                this.getGroupCategoryId();
                this.onSelectCentral({ groupId: get(this.state, "groupId") });
              }
            );
          }
        }
      );
    }
    if (!projectId && previewData != null) {
      this.setState({ locations: previewData.locations });
    }
    const editresponse = await request(getProjectDetail(projectId));

    if (editresponse.data.data == null) {
    } else {
      if (editresponse.data.data.sponsoredBy.id == 78) {
        const transformedArray = editresponse.data.data.locations.map(item => {
          const districtIds = item.districtIdName.map(d => d.id);
          const circleIds = item.circleIdName.map(c => c.id);

          return {
            ...item,
            districtId: districtIds,
            circleId: circleIds,
            id: item.stateId
          };
        });
        this.setState({ locations: transformedArray });
        const res = await getSchemesListAction(undefined, { sectorId: "" });
        this.setState({ arSchemesList: res.data });
        const response = await request(getSponsoringAgency());
        this.setState({ sponsoringAgencyList: response.data.data });
        const districtResponse = await request(
          getStateDistrictAndDepartmentCreateProject(78)
        );
        this.setState({ sponsoringDeptARdata: districtResponse.data.data });
      }
    }
    const draftres = await request(_getDraftedProjectDetails());

    if (draftres.data.data == null) {
    } else if (draftres.data.data.project.sponsoredBy == null) {
    } else {
      if (
        draftres.data.data.project.sponsoredBy.id == 78 &&
        draftres.data.data.project.status == "DRAFT"
      ) {
        //this.setState({ groupId: value });
        // const res = await getSchemesListAction(undefined, { sectorId: "872" });
        const transformedArray = draftres.data.data.project.locations.map(
          item => {
            const districtIds = item.districtIdName.map(d => d.id);
            const circleIds = item.circleIdName.map(c => c.id);

            return {
              ...item,
              districtId: districtIds,
              circleId: circleIds,
              id: item.stateId
            };
          }
        );
        this.setState({ locations: transformedArray });
        const res = await getSchemesListAction(undefined, { sectorId: "" });
        this.setState({ arSchemesList: res.data });
        const response = await request(getSponsoringAgency());
        this.setState({ sponsoringAgencyList: response.data.data });
        const districtResponse = await request(
          getStateDistrictAndDepartmentCreateProject(78)
        );
        this.setState({ sponsoringDeptARdata: districtResponse.data.data });
      } else {
        //this.setState({ groupId: "" });
      }
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.stateWiseData !== this.state.stateWiseData) {
      this.setState({
        stateWiseData: this.state.stateWiseData
      });
    }
  }
  handleDistrictError = flag => {
    this.setState({ districtErrormessage: flag });
  };
  handleStateError = flag => {
    this.setState({ stateErrormessage: flag });
  };
  getMinCost = id => {
    let { groupCategoryList, groupId } = this.state;
    // let selectedOption = groupCategoryList.find(item => item.id === id);
    this.setState({
      stateMinimumCost: 0.01
    });
  };
  handleCostAPerror() {
    toast.error(
      <p className="toast-text-alignment">Minimum Project Cost: ₹50 Cr.</p>,
      errorToastStyle
    );
  }
  getProjectTitle = id => {
    let { groupCategoryList } = this.state;

    let selectedOption = groupCategoryList.find(item => item.id === id);
    let projectTitle =
      selectedOption && selectedOption.projectFormDTO.projectName;

    this.setState({
      projectNameTitle: projectTitle || "Project Name"
    });
  };

  onChange = (value, key) => {
    const {
      error,
      groupId,
      bucketMilestoneCOS,
      cost,
      projectCategoryId,
      sectorId,
      revisedCost,
      implementationMode
    } = this.state;
    const { projectData } = this.props;
    const obj = {};

    // cin info is null
    if (key === "cin") {
      obj["cinInfo"] = null;
    }

    if (key == "cost" && value <= 50 && groupId == 77) {
      this.setState({ projectCosterror: true });
    }

    if (projectCategoryId == "STATE") {
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item =>
          item.bucketName === "Cabinet Milestone"
            ? {
                ...item,
                disabled: true,
                disableReason: "Cabinet Milestone is disabled"
              }
            : item
        )
      }));
    }

    if (
      key === "implementationMode" &&
      value == "PRIVATE" &&
      projectCategoryId == "CENTRAL"
    ) {
      // this.setState(prevState => ({
      //   bucketMilestoneCOS: prevState.bucketMilestoneCOS.filter(
      //     item => item.bucketName !== "Cabinet Milestone"
      //   )
      // }));
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item =>
          item.bucketName === "Cabinet Milestone"
            ? {
                ...item,
                disabled: true,
                disableReason: "Cabinet Milestone is disabled"
              }
            : item
        )
      }));
    } else if (
      projectCategoryId === "CENTRAL" &&
      ["cost", "revisedCost", "implementationMode"].includes(key)
    ) {
      // effective values after this particular change is applied
      const effectiveImplementationMode =
        key === "implementationMode" ? value : implementationMode;
      const effectiveCost = key === "cost" ? value : cost;
      const effectiveRevisedCost = key === "revisedCost" ? value : revisedCost;

      const isEmpty = v => v === null || v === undefined || v === "";

      // Use revisedCost if present, otherwise fall back to cost
      const effectiveCostForCheck = !isEmpty(effectiveRevisedCost)
        ? effectiveRevisedCost
        : effectiveCost;
      const isCostGatedMinistry = this.isCostBasedCabinetMinistry(groupId);
      const shouldDisable =
        !this.state.displayCabinetMilestones &&
        (effectiveImplementationMode === "PRIVATE" ||
          (isCostGatedMinistry &&
            (isEmpty(effectiveCostForCheck) ||
              Number(effectiveCostForCheck) < 1000)));

      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item => {
          if (item.bucketName !== "Cabinet Milestone") return item;

          if (shouldDisable) {
            return {
              ...item,
              disabled: true,
              disableReason: "Cabinet Milestone is disabled"
            };
          }

          const { disableReason, ...rest } = item;
          return { ...rest, disabled: false };
        })
      }));
    }
    // ---- end consolidated block ----

    if (key == "revisedCost" && value <= 50 && groupId == 77) {
      this.setState({ projectrevisedCosterror: true });
    }

    if (key == "geoCoordinates" && value != "" && groupId == 78) {
      this.setState({ geoCordinateError: "" });
    }

    if (value == "CENTRAL" && key == "projectCategoryId") {
      this.setState({
        projectCosterror: false,
        projectrevisedCosterror: false
      });
    }

    // on change of start state, set date to null
    if (key === "projectImplementationStartState") {
      obj["projectImplementationStartDate"] = null;
    }

    if (key == "implementationMode" && value == "- Select Mode -") {
      // this.setState({implementationMode:null})
      //delete error["implementationMode"];
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          implementationMode: {
            error: true,
            message: "This field is required"
          }
        }
      }));
    }

    if (key == "implementationMode" && value != "- Select Mode -") {
      delete error["implementationMode"];
    }

    if (key == "pragatiCycleDate") {
      delete error["pragatiCycleDate"];
    }
    if (key === "projectImplementationAnticipatedDate") {
      this.updateParentStateError("projectImplementationAnticipatedDate", {});
    }

    if (key === "projectImplementationStartDate") {
      this.updateParentStateError("projectImplementationStartDate", {});
    }

    if (key === "projectCategoryId") {
      this.setState({
        districtList: [],
        sponsoringDeptARdata: [],
        sponsoringDepartmentId: "",
        locations: []
      });
    }

    if (key === "projectImplementationSanctionDate") {
      this.updateParentStateError("projectImplementationSanctionDate", {});
    }

    if (key === "projectCategoryId") {
      obj["groupId"] = null;
      delete error["groupId"];
      this.setState({
        cost: "",
        revisedCost: "",
        centralCost: "",
        stateCost: ""
      });

      if (value === "CENTRAL" && projectData.length === 0) {
        this.setState({
          projectNameTitle: "Project Name",
          uniqueSectorlist: {},
          bucketMilestoneCOS: []
        });
      }
      delete error["cost"];
      delete error["revisedCost"];
      delete error["centralCost"];
      delete error["stateCost"];
      delete error["fundReleaseCost"];
      delete error["executingAgency"];
      delete error["schemeForAr"];
    }

    if (key === "description") {
      if (value.length > 32767) {
        value = value.slice(0, 32767);
      }
    }

    if (key === "name") {
      if (value.length > this.maxNameFieldLength) {
        value = value.slice(0, this.maxNameFieldLength);
      }
    }

    this.setState(
      {
        [key]: this.getCurrentValueByType(value, key),
        dataUnsaved: true,
        ...obj
      },
      () => {
        // call the project id
        if (key === "projectCategoryId") {
          this.getGroupCategoryId();
        }
      }
    );
  };

  onBlur = (value, key) => {
    const { isEdit } = this.props;
    const valueAfterRemoveSpace = this.removeSpace(value);
    const currentValue = this.getCurrentValueByType(valueAfterRemoveSpace, key);
    const error = this.getErrorMsg(currentValue, key);
    let params = {};
    const isSuperAdmin =
      this.props !== null &&
      this.props.pageDetail !== null &&
      this.props.pageDetail !== undefined &&
      this.props.pageDetail.superAdmin;
    if (key == "geoCoordinates" && value == "" && this.state.groupId == 78) {
      this.setState({ geoCordinateError: "This field is required." });
    }
    if (key == "cost" && value >= 50 && this.state.groupId == 77) {
      this.setState({ projectCosterror: false });
    }
    if (key == "cost" && value == "" && isSuperAdmin) {
      this.setState({ projectCosterror: false });
    }
    if (key == "revisedCost" && value == "") {
      this.setState({ projectrevisedCosterror: false });
    }
    if (key == "revisedCost" && value >= 50 && this.state.groupId == 77) {
      this.setState({ projectrevisedCosterror: false });
    }
    if (
      key === "projectImplementationStartState" &&
      value === "COMPLETED" &&
      this.state.groupId != 37 &&
      isEdit == undefined
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "commissioned",
        data: "",
        percentage: 100
      };
    }
    if (
      key === "projectImplementationStartState" &&
      value === "COMPLETED" &&
      this.state.groupId != 37 &&
      isEdit == true
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "commissioned",
        data: "",
        percentage: 100
      };
    }
    if (
      key === "projectImplementationStartState" &&
      value === "COMPLETED" &&
      this.state.groupId == 37 &&
      isEdit == undefined
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "",
        data: "",
        percentage: 100,
        error: undefined
      };
    }
    if (
      key === "projectImplementationStartState" &&
      value === "UNDER_IMPLEMENTATION" &&
      isEdit == undefined
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "underConstruction",
        data: "",
        percentage: ""
      };
    }
    if (
      key === "projectImplementationStartState" &&
      value === "UNDER_IMPLEMENTATION" &&
      isEdit == true
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "underConstruction",
        data: "",
        percentage: "",
        financialPercentage: "",
        physicalProgressAsOf: ""
      };
    }
    if (
      this.state.projectCompletionDTO.status === "provisionallyCommissioned" &&
      isEdit == true
    ) {
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "provisionallyCommissioned",
        data: "",
        percentage: "",
        financialPercentage: "",
        physicalProgressAsOf: ""
      };
    }

    if (key === "projectImplementationStartState" && isEdit == undefined) {
      if (value === "IMPLEMENTATION_NOT_STARTED") {
        params["projectCompletionDTO"] = {
          status: "noImplementation",
          data: "",
          financialPercentage: ""
        };
      }
    }
    if (key === "projectImplementationStartState" && isEdit == true) {
      if (value === "IMPLEMENTATION_NOT_STARTED") {
        params["projectCompletionDTO"] = {
          status: "noImplementation",
          data: "",
          financialPercentage: "",
          physicalProgressAsOf: ""
        };
        //console.log(params["projectCompletionDTO"])
      }
    }
    if (
      key === "projectImplementationStartState" ||
      key === "projectImplementationClassification"
    ) {
      params["dataUnsaved"] = true;
    }
    if (
      key === "projectImplementationStartState" &&
      value === "COMPLETED" &&
      this.state.groupId == 37 &&
      isEdit == true
    ) {
      //console.log("success")
      params["revisedTargetCompletionDate"] = null;
      params["projectCompletionDTO"] = {
        status: "",
        data: "",
        percentage: 100
      };
      //console.log(params["projectCompletionDTO"])
    }
    this.setState({
      [key]: valueAfterRemoveSpace,
      ...params,
      error: {
        ...error,
        date: {},
        percentage: {},
        financialPercentage: {},
        progressAsof: {}
      }
    });
    //console.log(error)
  };

  onSelect = async (value, key, options = []) => {
    const { previewData } = this.props;
    this.setState({ isApiLoading: true });
    let selectedStatePmgConstitutedFlag = getSelectedStatePmgConstituted(
      value,
      options
    );
    if (selectedStatePmgConstitutedFlag) {
      const districtResponse = await request(
        getStateDistrictAndDepartmentCreateProject(value)
      );
      setTimeout(() => {
        this.setState({
          isApiLoading: false,
          sponsoringDeptARdata: districtResponse.data.data,
          displayBendept: true,
          projectCosterror: false,
          projectrevisedCosterror: false,
          districtList: [],
          sponsoringDepartmentId: ""
        });
      }, 1500);
      this.state.error.revisedCost = { error: false, message: false };
    } else {
      this.setState({ isApiLoading: false });
    }
    const {
      projectCategoryId,
      userID,
      groupCategoryList,
      arSchemesList,
      sponsoringAgencyList,
      implementationMode,
      cost,
      bucketMilestoneCOS,
      revisedCost
    } = this.state;

    if (projectCategoryId == "STATE") {
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item =>
          item.bucketName === "Cabinet Milestone"
            ? {
                ...item,
                disabled: true,
                disableReason: "Cabinet Milestone is disabled"
              }
            : item
        )
      }));
    }
    if (
      this.isCostBasedCabinetMinistry(this.state.groupId) &&
      ((cost < 1000 && projectCategoryId == "CENTRAL") ||
        ((cost == null || cost == "") && projectCategoryId == "CENTRAL"))
    ) {
      // console.log("successsssssss");
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item =>
          item.bucketName === "Cabinet Milestone"
            ? {
                ...item,
                disabled: true,
                disableReason: "Cabinet Milestone is disabled"
              }
            : item
        )
      }));
    }
    if (
      (previewData == null && cost >= 1000 && projectCategoryId == "CENTRAL") ||
      (previewData == null &&
        projectCategoryId == "CENTRAL" &&
        value != "PRIVATE")
    ) {
      // console.log("successsssssss");
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item => {
          if (item.bucketName === "Cabinet Milestone") {
            const { disableReason, ...rest } = item;

            return {
              ...rest,
              disabled: false
            };
          }

          return item;
        })
      }));
    }
    if (value == 78 && selectedStatePmgConstitutedFlag) {
      this.setState({ locations: [] });
      const { previewData } = this.props;
      if (previewData != null) {
        this.setState({
          schemeForAr: previewData.schemeForAr,
          centralCost: previewData.centralCost,
          stateCost: previewData.stateCost
        });
      }
      // const res = await getSchemesListAction(undefined, { sectorId: "872" });
      const res = await getSchemesListAction(undefined, { sectorId: "" });
      this.setState({ arSchemesList: res.data });
      const response = await request(getSponsoringAgency());
      this.setState({ sponsoringAgencyList: response.data.data });
    } else {
      //this.setState({ groupId: "" });
    }
    if (value != 78 && selectedStatePmgConstitutedFlag) {
      // const { previewData } = this.props;
      // if (previewData != null) {
      //   previewData.centralCost = null;
      //   previewData.stateCost = null;
      // }

      this.setState({
        schemeForAr: "",
        locations: [],
        centralCost: null,
        stateCost: null,
        cost: "",
        revisedCost: "",
        groupId: value,
        geoCordinateError: ""
      });
      this.state.error.centralCost = { error: false, message: false };
    }
    const {
      getBucketsWithMilestonesBySectorAction,
      getResponsibleAuthorityForMilestonesAction
    } = this.props;
    const error = this.getErrorMsg(value, key);
    let selectedOptionImageUrl = "";
    let selectedStatePmgConstituted = true;
    let selectedStateProjectName;
    if (
      (key === "groupId" && projectCategoryId === GROUP_KEYS.STATE) ||
      value == 78
    ) {
      selectedStateProjectName = getSelectedStateProjectName(value, options);
      selectedOptionImageUrl = getSelectedOptionImage(value, options);
      this.setState({ selectedOptionImageUrl });
      selectedStatePmgConstituted = getSelectedStatePmgConstituted(
        value,
        options
      );
      this.setState({
        cost: "",
        revisedCost: "",
        projectNameTitle: selectedStateProjectName,
        geoCoordinates: "",
        //centralCost: null,
        //stateCost: null,
        fundReleaseCost: null,
        populationBenefitted: ""
      });
      delete error["cost"];
      //delete error["revisedCost"];
      //delete error["centralCost"];
      delete error["stateCost"];
      delete error["fundReleaseCost"];
      delete error["executingAgency"];
    }
    if (key === "implementationMode" && value !== "PRIVATE") {
      this.setState({
        pli: false
      });
    }
    if (key === "groupId") {
      this.onSponsoringDepartmentSelect(value);
      const matchingGroup = groupCategoryList.find(
        groupId =>
          groupId.id == value &&
          groupId.hasCustomSector &&
          groupId.category === "STATE"
      );

      if (matchingGroup) {
        this.setState({
          subSectorList: [],
          sectorId: null,
          subSectorId: null,
          bucketMilestoneCOS: []
        });
      }
    }
    if (key === "sponsoringDepartmentId") {
      const { groupId } = this.state;
      if (groupId == 37) {
        this.onSelectSponsoringDept(key, value);
      }
    }
    if (value === "" || selectedStatePmgConstituted) {
      this.setState(
        {
          [key]: value,
          dataUnsaved: true,
          error
        },
        () => {
          this.onSelectCentral(key);
          this.onSelectDepartment(key);
          this.getCostDistanceAndSchemes(key);
        }
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">State PMG not constituted yet</p>,
        errorToastStyle
      );
    }
    if (key === "subSectorId") {
      let resp = await getBucketsWithMilestonesBySectorAction(+value);
      getResponsibleAuthorityForMilestonesAction();

      if (resp) {
        let _data = setIncomingDataForMilestone(resp && resp.data, userID);
        // console.log("sucess",_data)
        const updatedData = _data.map((item, index) => ({
          ...item,
          disabled: index === _data.length - 1 ? true : item.disabled,
          disableReason: "Cabinet Milestone is disabled"
        }));
        updatedData.map(item => {
          if (item.bucketName === "Cabinet Milestone") {
            // console.log(item)
            item.milestoneTableDataCOS[0].phaseName = null;
          }
        });
        this.setState({
          bucketMilestoneCOS: updatedData,
          selectedBucketId: 1
        });
      }
    }
  };

  // only show numbers
  getCurrentValueByType = (value = "", key) => {
    let modifiedValue = value;
    switch (key) {
      case "fdi":
        break;

      case "cost":
      case "stateCost":
      case "centralCost":
      case "revisedCost":
      case "fundReleaseCost":
        this.getErrorMsg(modifiedValue, key);
        return onlyForCostNumbers(modifiedValue);

      default:
        break;
    }

    return NUMERIC_KEYS.indexOf(key) !== -1
      ? onlyNumbers(modifiedValue)
      : value;
  };

  // remove trim space
  removeSpace = value => {
    return value && value.trim ? value.trim() : value;
  };

  // get Error msg
  getErrorMsg = (value, key) => {
    const { error, stateMinimumCost, groupId, stateMinimumCostAP } = this.state;
    const { pageDetail, permission } = this.props;
    const userInfo = getLocalstorage("user");
    let errorObj = {};
    switch (key) {
      case "cin":
        get(pageDetail, "cin") &&
          (errorObj = {
            error: true,
            message: !value ? "This field is required." : "Please Validate"
          });
        break;
      case "cost":
      case "revisedCost":
        if (
          get(pageDetail, "superAdmin") ||
          (groupId === "226" || groupId === 226)
        ) {
          break;
        }
        errorObj.error =
          (isString(value) && +value < stateMinimumCost) || false;
        errorObj.message =
          (isString(value) &&
            +value < stateMinimumCost &&
            `Minimum ${stateMinimumCost} Cr. order is required`) ||
          false;
        if (key === "revisedCost" && !value) {
          errorObj.error = false;
        }
        break;

      case "district":
        errorObj.error = !value;
        errorObj.message = (!value && "This field is required.") || "";
        break;

      case "percentage":
        errorObj.error = !value || value >= 100;
        errorObj.message = !value
          ? "This field is required."
          : (value >= 100 || value < 0) &&
            "Must be less than 100% or mark project status as Completed.";
        break;

      case "financialPercentage":
        errorObj.error = !value || value >= 100;
        errorObj.message = (value >= 100 && "Must be less than 100%.") || "";
        break;

      case "sponsoringDepartmentId":
        // errorObj.error = false;
        // errorObj.message = "";
        errorObj.error =
          !value &&
          get(permission, "createStateProject") &&
          this.state.projectCategoryId == "STATE";
        errorObj.message =
          (get(permission, "createStateProject") &&
            this.state.projectCategoryId == "STATE" &&
            !value &&
            "This field is required.") ||
          "";
        break;
      case "divisionId":
        errorObj.error = false;
        errorObj.message = "";
        break;
      case "fundReleaseCost":
        errorObj.error = !value;
        errorObj.message = (!value && "This field is required.") || "";
        break;
      case "executingAgency":
        errorObj.error = !value;
        errorObj.message = (!value && "This field is required.") || "";
        break;
      case "name":
        errorObj.error =
          !value ||
          (this.state.projectCategoryId != "STATE" &&
            /[\u0900-\u097F]/.test(value));
        errorObj.message = !value
          ? "This field is required."
          : /[\u0900-\u097F]/.test(value)
          ? "Only English language is supported"
          : "";
        break;
      case "description":
        errorObj.error =
          !value ||
          (this.state.projectCategoryId != "STATE" &&
            /[\u0900-\u097F]/.test(value));
        errorObj.message = !value
          ? "This field is required."
          : /[\u0900-\u097F]/.test(value)
          ? "Only English language is supported"
          : "";
        break;
      default:
        errorObj.error = !value;
        errorObj.message = !value && "This field is required.";
        break;
    }

    return {
      ...error,
      [key]: errorObj
    };
  };

  // call apis
  getCostDistanceAndSchemes = key => {
    const { sectorId, subSectorId } = this.state;
    switch (key) {
      case "sectorId":
        this.getSubSectors({ sectorId });
        break;

      case "subSectorId":
        this.getCostAndDistance({ sectorId: subSectorId });
        break;

      default:
        break;
    }
  };
  OtherPPBlur = value => {
    this.setState({ otherppError: value });
  };
  proponentBlur = value => {
    const {
      defaultSelected,
      options,
      error,
      userValidateError,
      status,
      userID
    } = this.state;
    const { isEdit } = this.props;
    const userInfo = getLocalstorage("user");
    const isStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
    const errorMessage = "Invalid User";
    // === Check for exact match with userID or name ===
    const hasExactMatch = options.some(
      option => option.userID === value || option.name === value
    );

    const defaultSelectedHasParentheses =
      defaultSelected.includes("(") && defaultSelected.includes(")");
    if (
      (userValidateError === true && isEdit) ||
      (userValidateError === true && status == undefined) ||
      (userValidateError === true && status == "DRAFT") ||
      (userValidateError === true && status == "CRIP_DRAFT") ||
      (value &&
        !hasExactMatch &&
        !defaultSelectedHasParentheses &&
        !isEdit &&
        // status != "IIG_DRAFT") ||
        status != "CRIP_DRAFT") ||
      (userID == null && isEdit) ||
      // (userID == null && status == "IIG_DRAFT") ||
      userID == undefined
    ) {
      //console.log(value && !hasExactMatch && !defaultSelectedHasParentheses && !isEdit);

      this.setState({
        error: {
          ...this.state.error,
          defaultSelected: {
            error: true,
            message:
              (userID == null && value == "") || (userID != null && value == "")
                ? "This field is required."
                : errorMessage
          }
        },
        redBorder: true,
        inValidUser: errorMessage,
        userValidateError: true
      });
    } else if (typeof userID === "object" && userID != null) {
      const validFullFormat =
        isStatePMG || isStateDepartment
          ? `${userID.name} (${userID.organization})`
          : `${userID.name} (${userID.userID})`;
      const validNameOnly = `${userID.name}`;
      if (
        defaultSelected !== validFullFormat &&
        defaultSelected !== validNameOnly
      ) {
        this.setState({
          error: {
            ...this.state.error,
            defaultSelected: {
              error: true,
              message: errorMessage
            }
          },
          redBorder: true,
          inValidUser: errorMessage,
          userValidateError: true
        });
      } else {
        this.setState({ inValidUser: "" });
      }
    } else {
      // === Clear error if valid
      const updatedError = { ...error };
      if (updatedError.defaultSelected) {
        delete updatedError.defaultSelected;
      }

      this.setState({
        error: updatedError,
        redBorder: false,
        inValidUser: ""
      });
    }
  };

  getGroupCategoryId = async () => {
    let { projectCategoryId, error } = this.state;
    const { getGroupsByCategoryActionDispatch } = this.props;
    this.setState({
      isApiLoading: true,
      groupCategoryList: [],
      error: {
        ...error,
        projectCategoryId: {
          error: !this.state.projectCategoryId
        }
      }
    });
    if (projectCategoryId === "PMG") {
      projectCategoryId = GROUP_KEYS.CENTRAL;
    }
    let response;
    const getCategoryPayload = () => {
      let groupCategoryPayload = {};
      if (projectCategoryId === "CENTRAL") {
        groupCategoryPayload.category = [projectCategoryId, "PMG"];
      } else {
        groupCategoryPayload.category = [projectCategoryId];
      }
      return groupCategoryPayload;
    };
    if (projectCategoryId) {
      response = await getGroupsByCategoryActionDispatch(
        undefined,
        getCategoryPayload()
      );
      if (response) {
        const { data, message, status } = response;
        const industrialKey = {};
        projectCategoryId === GROUP_KEYS.PMG &&
          (industrialKey["groupId"] = data[0]["id"]);
        if (status) {
          this.setState({
            ...industrialKey,
            groupCategoryList: data,
            isApiLoading: false
          });
          return data;
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
          this.setState({ isApiLoading: false, groupCategoryList: [] });
        }
      } else {
        this.setState({ isApiLoading: false, groupCategoryList: [] });
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } else {
      this.setState({ isApiLoading: false, groupCategoryList: [] });
    }
  };

  getSubSectors = async (param, id, { resetMilestones = true } = {}) => {
    const {
      getBucketsWithMilestonesBySectorAction,
      getResponsibleAuthorityForMilestonesAction,
      previewData
    } = this.props;
    if (this.state.implementationMode === "PRIVATE") {
      this.setState(prevState => ({
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.filter(
          item => item.bucketName !== "Cabinet Milestone"
        )
      }));
    }
    this.setState({ isApiLoading: true });
    const response = await getSubSectorListAction(undefined, param);
    getResponsibleAuthorityForMilestonesAction();

    id = id || {};
    const state = {
      subSectorList: [],
      subSectorId: null,
      costAndDistance: [],
      ...id
    };

    if (response) {
      const data = get(response, "data", []);
      if (data) {
        this.setState({
          ...state,
          subSectorList: data,
          isApiLoading: false
        });
        this.getCostAndDistance(param);

        if (data.length) {
          if (resetMilestones) {
            // Only clear stale cabinet-milestone data on a genuine
            // user-driven sector change — not on initial resume flows
            // (draft / preview / IIG) that already loaded milestone data.
            this.setState({
              bucketMilestoneCOS: [],
              selectedBucketId: null
            });
          }
        } else {
          const resp = await getBucketsWithMilestonesBySectorAction(
            param && +param.sectorId
          );
          if (resp) {
            const _data = setIncomingDataForMilestone(
              resp && resp.data,
              this.state.userID
            );
            // FIX: don't let a re-fetch on sector change reintroduce Cabinet Milestone for PRIVATE
            const filteredData =
              this.state.implementationMode === "PRIVATE"
                ? _data.filter(item => item.bucketName !== "Cabinet Milestone")
                : _data;
            const updatedData = filteredData.map((item, index) => ({
              ...item
            }));

            updatedData.forEach(item => {
              if (item.bucketName === "Cabinet Milestone") {
                item.milestoneTableDataCOS = [
                  { ...item.milestoneTableDataCOS[0], phaseName: null },
                  ...item.milestoneTableDataCOS.slice(1)
                ];
              }
            });

            this.setState({
              bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex(
                previewData == null ? updatedData : filteredData
              ),
              selectedBucketId: 1
            });
          }
        }
      } else {
        this.setState({ ...state, isApiLoading: false });
      }
    } else {
      this.setState({ ...state, isApiLoading: false });
    }
  };
  getCostAndDistance = async param => {
    this.setState({ isApiLoading: true });
    Promise.all([
      await getSchemesListAction(undefined, param),
      await getCostDistanceAction(undefined, param)
    ])
      .then(resp => {
        const [scheme, cost] = resp;
        this.setState({
          schemesList: get(scheme, "data", []),
          costAndDistance: get(cost, "data", []),
          isApiLoading: false
        });
      })
      .catch(e => {
        this.setState({ isApiLoading: true });
        toast.error(
          <p className="toast-text-alignment">{e.message}</p>,
          errorToastStyle
        );
      });
  };

  //
  validateCIN = async () => {
    const { cin, error } = this.state;
    const { getValidateCinDispatch } = this.props;
    this.setState({ isApiLoading: true });
    try {
      const response = await getValidateCinDispatch(undefined, {
        cinNumber: cin
      });
      if (response) {
        const extractData = get(response, "data", {});
        const { status, message, data } = extractData;
        const error = this.getErrorMsg(cin, "cin");
        if (status) {
          error.cin = { error: false };
          this.setState({
            cinInfo: data,
            error,
            isApiLoading: false
          });
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
        } else {
          error.cin = { error: true };
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
          this.setState({
            cinInfo: null,
            error,
            isApiLoading: false
          });
        }
      }
    } catch (e) {
      error.cin = { error: true };
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
      this.setState({
        cinInfo: null,
        error: error,
        isApiLoading: false
      });
    }
  };

  onMapImageFilesChange = async file => {
    const { uploadFileDispatch } = this.props;
    const { mapImageFiles } = this.state;
    try {
      if (!this.inValidFile) {
        const attachmentPayload = FormDataForImage(file, "file");
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          if (status) {
            let errorObj = this.state.error;
            delete errorObj["mapImageFiles"];
            this.setState({
              mapImageFiles: [
                ...mapImageFiles,
                { ...data, extension: file[0].extension }
              ],
              dataUnsaved: true,
              error: errorObj
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.mapImageInvalidFile = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onMapImageFilesError = () => {
    toast.error("Not a valid file type", errorToastStyle);
    this.mapImageInvalidFile = true;
  };

  onProjectExtensionFilesChange = async file => {
    const { uploadFileDispatch } = this.props;
    const { projectExtensionFiles } = this.state;
    try {
      if (!this.projectExtensionValidFiles) {
        const attachmentPayload = FormDataForImage(file, "file");
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          if (status) {
            this.setState({
              projectExtensionFiles: [
                ...projectExtensionFiles,
                { ...data, extension: file[0].extension }
              ],
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.projectExtensionValidFiles = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onProjectExtensionFilesError = file => {
    if (file && file.code === 1) {
      toast.error(
        <p className="toast-text-alignment">Not a valid file type</p>,
        errorToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">
          The file exceeds the maximum size limit of 10 MB
        </p>,
        errorToastStyle
      );
    }
    this.projectExtensionValidFiles = true;
  };

  /**
   *  For upload files
   * @param files
   * @returns {Promise<void>}
   */
  onFilesChange = async file => {
    const { uploadFileDispatch } = this.props;
    const { files } = this.state;
    try {
      if (!this.inValidFile) {
        const attachmentPayload = FormDataForImage(file, "file");
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          if (status) {
            this.setState({
              files: [...files, { ...data, extension: file[0].extension }],
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.inValidFile = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onFilesError = file => {
    if (file && file.message) {
      toast.error(
        <p className="toast-text-alignment">
          The file exceeds the maximum size limit of 10 MB
        </p>,
        errorToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">Not a valid file type</p>,
        errorToastStyle
      );
    }
    this.inValidFile = true;
  };

  /**
   *
   * @param key => key looking into props
   * @param title =>  title of the option tag
   * @param updateKey => key we want to update in state
   * @returns {*}
   */
  createTemplatesFromPageDetail = (
    key,
    title,
    updateKey,
    isDisabled = false
  ) => {
    const { pageDetail, isEdit } = this.props;
    const { uniqueSectorlist, projectCategoryId } = this.state;
    if (
      key === "sector" &&
      Array.isArray(uniqueSectorlist) &&
      uniqueSectorlist.length > 0
    ) {
      return this.templates(
        uniqueSectorlist,
        title,
        updateKey,
        false,
        isDisabled
      );
    }
    const { [key]: templateValue } = pageDetail || {};
    if (key === "sector") {
      let filteredTemplateValue = Array.isArray(templateValue)
        ? templateValue.filter(sector => isEdit || sector.isDefault)
        : templateValue;
      if (
        (projectCategoryId === "CENTRAL" &&
          !isEdit &&
          templateValue != undefined) ||
        (projectCategoryId == null && Array.isArray(templateValue))
      ) {
        filteredTemplateValue =
          filteredTemplateValue &&
          filteredTemplateValue.filter(item => item.name !== "Other");
      } else if (
        projectCategoryId === "CENTRAL" &&
        isEdit &&
        templateValue != undefined
      ) {
        filteredTemplateValue = filteredTemplateValue.filter(
          item => item.name !== "Other"
        );
      } else if (Array.isArray(templateValue) && projectCategoryId == "STATE") {
        const otherIndex = filteredTemplateValue.findIndex(
          item => item.name === "Other"
        );

        // If found, remove it and push to the end
        if (otherIndex !== -1) {
          const [other] = filteredTemplateValue.splice(otherIndex, 1);
          filteredTemplateValue.push(other);
        }
      }

      //  console.log(filteredTemplateValue)
      return this.templates(
        filteredTemplateValue,
        title,
        updateKey,
        false,
        isDisabled
      );
    }
    return this.templates(templateValue, title, updateKey, false, isDisabled);
  };

  createTemplateFromState = (key, title, updateKey, editWithState = false) => {
    const { [key]: templateValue } = this.state;
    return this.templates(templateValue, title, updateKey, editWithState);
  };

  templates = (
    options = [],
    title,
    key,
    editWithState = false,
    isImplementationModeDisabled = false
  ) => {
    const {
      error: { [key]: error },
      [key]: currentValue,
      editSector,
      sectorWarningGiven = false,
      isIIGProjectEdit,
      iigPayload,
      subSectorList,
      iigProjectReferenceId,
      groupId,
      projectCreatedFrom,
      sponsoringDepartmentId
    } = this.state;
    const { isEdit, projectData } = this.props;
    const { status, iigMappingdetails } = this.state;
    // const isIIGDraft = status === "IIG_DRAFT";
    const isIIGDraft = status === "CRIP_DRAFT";
    const hasIIGProjectReferenceId = iigProjectReferenceId !== null;
    const userInfo = getLocalstorage("user");
    const isStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const targetDate = this.state.createdDate;
    const dateAfterCrip = new Date("2026-07-08").getTime();

    const isSuperAdmin =
      this.props !== null &&
      this.props.pageDetail !== null &&
      this.props.pageDetail !== undefined &&
      this.props.pageDetail.superAdmin;

    var newsector =
      this.state.uniqueSectorlist && this.state.uniqueSectorlist.length == 0
        ? options.filter(
            (arr, index, self) =>
              index ===
              self.findIndex(t => t.name == arr.name && t.isDefault == true)
          )
        : options.filter(
            (arr, index, self) =>
              index === self.findIndex(t => t.name == arr.name)
          );

    const optionsTemplate = options.map(value => {
      return (
        <option
          key={value.id || value}
          data-test={key + "-item"}
          value={value.id || value}
        >
          {get(value, "name", "") || value}
        </option>
      );
    });
    const optionsTemplate2 = newsector.map(value => {
      return (
        <option
          key={value.id || value}
          data-test={key + "-item"}
          value={value.id || value}
        >
          {get(value, "name", "") || value}
        </option>
      );
    });

    let isDisabled = false;
    if (
      // if project is IIG Draft and key is present in the array,
      // then disable the field
      (isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId) &&
      ["groupId", "implementationMode"].includes(key) &&
      this.state.originalSponsoredById !== undefined
    ) {
      isDisabled = true;
    }

    if (
      (isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId) &&
      this.state.implementationMode !== null &&
      isImplementationModeDisabled
    ) {
      isDisabled = true;
    }
    return (
      <div>
        <Form.Control
          data-test={key}
          as="select"
          className={`${
            key === "sponsoringDepartmentId" &&
            projectData &&
            projectData.data &&
            (projectData.data.sponsoringDepartment == null ||
              projectData.data.sponsoringDepartment == "" ||
              projectData.data.sponsoringDepartment == undefined)
              ? ""
              : editWithState &&
                !(key === "sponsoringDepartmentId" && isStatePMG)
              ? "disabled"
              : ""
          }`}
          key={key}
          value={currentValue || ""}
          onChange={e => {
            if (
              !isIIGDraft &&
              ((getLocalstorage("draftedProject") &&
                title === "Select Sector" &&
                !isEdit) ||
                (isEdit &&
                  editSector &&
                  ((key === "subSectorId" && !sectorWarningGiven) ||
                    key === "sectorId")))
            ) {
              this.openSectorChangeConfirmationAlert(
                e.target.value,
                key,
                options
              );
            } else {
              this.onSelect(e.target.value, key, options);
            }
          }}
          isInvalid={
            groupId == 78 && key == "implementationMode"
              ? false
              : get(error, "error")
          }
          disabled={
            !options == null ||
            isDisabled ||
            projectCreatedFrom == "UP" ||
            (!editSector &&
              isEdit &&
              !isSuperAdmin &&
              !isStatePMG &&
              (key === "subSectorId" || key === "sectorId"))
          }
        >
          <option data-test={key + "-item"} selected value="">
            - {title} -
          </option>
          {key == "sectorId" ? <>{optionsTemplate2}</> : <>{optionsTemplate}</>}
        </Form.Control>
        {!hasIIGProjectReferenceId && (
          <Form.Control.Feedback type="invalid">
            {get(error, "message")}
          </Form.Control.Feedback>
        )}
        {key === "sectorId" && hasIIGProjectReferenceId && (
          <>
            <p className="remaining-char iig-sector-id">
              Sector from{" "}
              {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}:&nbsp;
              {iigMappingdetails.sector || "N/A"}
              {subSectorList.length === 0 &&
                (isIIGDraft ||
                  isIIGProjectEdit ||
                  hasIIGProjectReferenceId) && (
                  <>
                    <span className="ml-5">
                      Subsector from{" "}
                      {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}
                      :&nbsp;
                    </span>
                    {iigMappingdetails.subSector || "N/A"}
                  </>
                )}
            </p>
          </>
        )}
        {key === "subSectorId" &&
          (isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId) && (
            <p className="remaining-char iig-sector-id">
              Subsector from{" "}
              {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}
              :&nbsp;
              {iigMappingdetails.subSector || "N/A"}
            </p>
          )}
      </div>
    );
  };

  createProjectMapImageFilesTemplate = () => {
    const { mapImageFiles } = this.state;
    return mapImageFiles.map((value, index) => {
      return (
        <div className="uploaded-file" data-test="uploaded-file">
          <div
            data-test="remove-file-button"
            className="remove-file"
            onClick={() => {
              this.removeMapImageFile(value, index);
            }}
          />
          <div className="file-detail">
            <div className="upload-icon">{value.name.split(".").pop()}</div>
            <Link to="">{value.name}</Link>
          </div>
        </div>
      );
    });
  };

  createProjectExtensionFilesTemplate = () => {
    const { projectExtensionFiles } = this.state;
    return projectExtensionFiles.map((value, index) => {
      return (
        <div
          className="uploaded-file uploaded-geo-coordinates-attachment"
          data-test="uploaded-file"
        >
          <div
            data-test="remove-file-button"
            className="remove-file"
            onClick={() => {
              this.removeProjectExtensionFile(value, index);
            }}
          />
          <div className="file-detail">
            <div className="upload-icon">{value.name.split(".").pop()}</div>
            <Link to="">{value.name}</Link>
          </div>
        </div>
      );
    });
  };

  removeProjectExtensionFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { projectExtensionFiles } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          projectExtensionFiles.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ projectExtensionFiles });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  displayCabinetMilestones = async () => {
    const { bucketMilestoneCOS } = this.state;
    const displayCabinetMilestones = !this.state.displayCabinetMilestones;

    const cabinetBucketExists = bucketMilestoneCOS.some(
      item => item.bucketName === "Cabinet Milestone"
    );

    // FIX: if the Cabinet Milestone bucket was previously removed entirely
    // (e.g. user clicked Update without adding cabinet milestone data, so it
    // got stripped from bucketMilestoneCOS), turning the toggle back ON needs
    // to re-fetch and re-insert the bucket instead of trying to .map() over
    // an array that no longer contains it.
    if (displayCabinetMilestones && !cabinetBucketExists) {
      const {
        getBucketsWithMilestonesBySectorAction,
        projectPPList,
        _sectorId,
        _subSectorId
      } = this.props;
      const { sectorId, subSectorId } = this.state;

      const idForFetch = _subSectorId || subSectorId || _sectorId || sectorId;

      if (!idForFetch) {
        // nothing to fetch against, just flip the flag
        this.setState({ displayCabinetMilestones });
        return;
      }

      this.setState({ isApiLoading: true });
      const resp = await getBucketsWithMilestonesBySectorAction(+idForFetch);
      this.setState({ isApiLoading: false });

      if (resp) {
        const _data = setIncomingDataForMilestone(
          resp && resp.data,
          null,
          projectPPList
        );
        const cabinetMilestone = _data.find(
          item => item.bucketName === "Cabinet Milestone"
        );

        if (cabinetMilestone) {
          if (
            cabinetMilestone.milestoneTableDataCOS &&
            cabinetMilestone.milestoneTableDataCOS[0]
          ) {
            cabinetMilestone.milestoneTableDataCOS[0].phaseName = null;
          }
          // user is actively turning it on, so enable it and drop any stale reason
          cabinetMilestone.disabled = false;
          delete cabinetMilestone.disableReason;

          this.setState(prevState => ({
            displayCabinetMilestones,
            bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex([
              ...prevState.bucketMilestoneCOS,
              cabinetMilestone
            ])
          }));
          return;
        }
      }

      // fetch failed or no Cabinet Milestone bucket returned — still flip the flag
      this.setState({ displayCabinetMilestones });
      return;
    }

    // Normal path: bucket already exists in bucketMilestoneCOS, just toggle disabled
    this.setState(prevState => {
      return {
        displayCabinetMilestones,
        bucketMilestoneCOS: prevState.bucketMilestoneCOS.map(item => {
          if (item.bucketName === "Cabinet Milestone") {
            const disabled = !displayCabinetMilestones;

            return {
              ...item,
              disabled,
              ...(disabled && {
                disableReason: "Cabinet Milestone is disabled"
              })
            };
          }

          return item;
        })
      };
    });
  };
  removeMapImageFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { mapImageFiles } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          mapImageFiles.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ mapImageFiles });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  /**
   * files upload
   * @returns {*[]}
   */
  createFileTemplate = () => {
    const { files, iigProjectReferenceId } = this.state;
    return files.map((value, index) => {
      return (
        <div className="uploaded-file">
          {!iigProjectReferenceId && (
            <div
              className="remove-file"
              onClick={() => {
                this.removeFile(value, index);
              }}
            />
          )}
          <div className="file-detail">
            <div className="upload-icon">{value.name.split(".").pop()}</div>
            <Link to="">{this.truncateFileName(value.name)}</Link>
          </div>
          <Form.Control
            type="text"
            placeholder="Add Title"
            value={(value && value.title) || ""}
            onChange={e => {
              this.onChangeImageTitle(e.target.value, index);
            }}
            onBlur={e => {
              this.createImageTitle(e.target.value, index);
            }}
            disabled={iigProjectReferenceId}
          />
        </div>
      );
    });
  };

  truncateFileName(name, maxLength = 20) {
    if (!name) return "";

    const dotIndex = name.lastIndexOf(".");
    const baseName = dotIndex !== -1 ? name.slice(0, dotIndex) : name;

    if (baseName.length > maxLength) {
      return baseName.slice(0, maxLength) + "...";
    }

    return name;
  }

  removeFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { files } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          files.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ files });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onChangeImageTitle = (value, index) => {
    const { files } = this.state;

    files[index].title = value;
    this.setState({ files: [...files] });
  };

  createImageTitle = (value, index) => {
    const { files } = this.state;
    const { id } = files[index];
    try {
      if (value) {
        clearDebounce(this.callTitleApi);
        this.callTitleApi = debounce(async () => {
          const response = await uploadFileTitleAction(undefined, {
            fid: id,
            title: value
          });
          if (response) {
            const message = get(response, "message", "");
            const status = get(response, "status", false);
            if (status) {
              files[index] && (files[index].title = value);
              this.setState({ files: [...files] });
            } else {
              toast.error(
                <p className="toast-text-alignment">{message}</p>,
                errorToastStyle
              );
            }
          }
        }, 500);
        this.callTitleApi();
      }
    } catch (err) {
      toast.error(
        <p className="toast-text-alignment">{err.message}</p>,
        errorToastStyle
      );
    }
  };

  /*       End of remove files                  */

  /*       START OF BANK TEMPLATE           */

  onChangeBankTemplate = (value, remove = false) => {
    const { projectBankInfoBanks: banks } = this.state;
    let isExist, bankIndex, isOtherSelected;
    for (let index = 0; index <= banks.length - 1; index += 1) {
      if (banks[index].id === value.id) {
        bankIndex = index;
        isExist = true;
        break;
      }
    }

    !isExist ? banks.push(value) : banks.splice(bankIndex, 1);

    if (!isExist && value.id === 51) {
      this._scrollRef.scrollTop = 1600;
      this.extraMargin = "remove-extra";
    }

    if ((isExist && value.id === 51) || (remove && value.id === 51)) {
      this.setState({
        otherBankName: ""
      });
      this.extraMargin = "";
    }

    if (banks && banks.length && find(banks, ["id", 51])) {
      isOtherSelected = true;
    }

    this.setState({
      projectBankInfoBanks: [...banks],
      isOtherSelected: isOtherSelected,
      dataUnsaved: true
    });
  };

  createBankTemplate = (bank = []) => {
    // bankListState is for banksList from state
    const {
      projectBankInfoBanks: selectedBanks,
      isOtherSelected,
      otherBankName,
      error
    } = this.state;

    const { otherBankName: otherBankNameErr } = error;

    return bank.map(value => {
      const selectedBank = selectedBanks.find(currentBank => {
        return currentBank.id === value.id;
      });
      return (
        <React.Fragment>
          <Form.Check
            className={`form-checkbox
          ${selectedBank && selectedBank.id === value.id && "checked"}`}
            key={value.name}
            style={{
              display: value.visibility
            }}
          >
            <Form.Check.Input type="checkbox" name="bank" />
            <Form.Check.Label
              onClick={e => {
                e.stopPropagation();
                this.onChangeBankTemplate(value);
              }}
            >
              <p data-test="label-bank-name" className="d-inline">
                {value.name}
              </p>
            </Form.Check.Label>
          </Form.Check>
          {isOtherSelected && value.id === 51 ? (
            <Form.Group className="other-bank-wrapper">
              <Form.Control
                type="text"
                placeholder="Enter Bank Name"
                className={"other-bank"}
                autofocus="autofocus"
                onChange={e => {
                  this.onChange(e.target.value, "otherBankName");
                }}
                value={otherBankName}
                isInvalid={get(otherBankNameErr, "error")}
                onBlur={e => this.onBlur(e.target.value, "otherBankName")}
              />
              <Form.Control.Feedback type="invalid">
                {get(otherBankNameErr, "message")}
              </Form.Control.Feedback>
            </Form.Group>
          ) : null}
        </React.Fragment>
      );
    });
  };

  activeBanksTemplate = () => {
    const { projectBankInfoBanks: banks, otherBankName } = this.state;
    let countingBanks = banks.filter(item => {
      if (item.id !== 51) {
        return item;
      } else if (
        item.id === 51 &&
        (otherBankName !== "" &&
          otherBankName !== undefined &&
          otherBankName !== null)
      ) {
        return item;
      }
    });
    let count = countingBanks.length;
    const template = (banks || []).map(value => {
      return (
        <React.Fragment>
          {value.id === 51 &&
          (otherBankName === "" ||
            otherBankName === undefined ||
            otherBankName === null) ? null : (
            <div>
              <span data-test="selected-bank-name">
                {value.id === 51 ? otherBankName : value.name}
                <span
                  data-test="close-button"
                  className="close"
                  onClick={() => {
                    this.onChangeBankTemplate(value, true);
                  }}
                >
                  X
                </span>
              </span>
            </div>
          )}
        </React.Fragment>
      );
    });
    if (count >= 1) {
      return (
        <div
          data-test="selected-bank-list-container"
          className="field-mscb-selected"
        >
          <p>Selected ({count})</p>
          {template}
        </div>
      );
    }
  };

  onSearchBanks = e => {
    const {
      pageDetail: { bank }
    } = this.props;
    const { value } = e.target;
    const replaceText = value.trim().replace(/[^a-zA-Z]/, "");
    const search = RegExp(replaceText, "i");
    const filteredBanks = (bank || []).map(value => {
      return (value.visibility = search.test(value.name) ? "" : "none");
    });
    this.setState({
      bank: filteredBanks
    });
  };

  /*          End of bank template              */

  buildIndexWisePayloads = dataObj => {
    if (!dataObj || typeof dataObj !== "object") return [];

    return Object.entries(dataObj)
      .filter(([_, rows]) => Array.isArray(rows) && rows.length > 0)
      .map(([index, rows]) => ({
        index: Number(index),
        payload: rows
      }));
  };

  onSubmit = _status => {
    const {
      history,
      createProjectDispatch,
      clearProjectDataDispatch
    } = this.props;
    const { bucketMilestoneCOS } = this.state;

    let _bucketMilestoneCOSForPost = bucketMilestoneCOS;

    if (isValidArray(bucketMilestoneCOS)) {
      if (this.isCabinetMilestoneMandatoryExempt()) {
        var otherBucketsDisabled = bucketMilestoneCOS
          .filter(function(item) {
            return item.bucketName !== "Cabinet Milestone";
          })
          .every(function(item) {
            return item.disabled === true;
          });

        _bucketMilestoneCOSForPost = bucketMilestoneCOS.filter(function(item) {
          // Keep all other buckets
          if (item.bucketName !== "Cabinet Milestone") {
            return true;
          }

          // Don't remove Cabinet Milestone if other buckets
          // are not all disabled
          if (!otherBucketsDisabled) {
            return true;
          }

          var milestoneDataCOS = [];

          if (
            item.milestoneTableDataCOS &&
            Array.isArray(item.milestoneTableDataCOS)
          ) {
            item.milestoneTableDataCOS.forEach(function(table) {
              if (
                table.milestoneDataCOS &&
                Array.isArray(table.milestoneDataCOS)
              ) {
                milestoneDataCOS = milestoneDataCOS.concat(
                  table.milestoneDataCOS
                );
              }
            });
          }

          // Check whether ANY Cabinet Milestone contains data
          var hasCabinetMilestoneData = milestoneDataCOS.some(function(
            milestone
          ) {
            return (
              milestone.originalScheduledStartDate != null ||
              milestone.revisedScheduledStartDate != null ||
              milestone.originalScheduledFinishDate != null ||
              milestone.revisedScheduledFinishDate != null ||
              milestone.responsibleAuthorityId != null ||
              milestone.responsibleAuthorityName != null ||
              milestone.dependencyType != null ||
              milestone.reasonForDelay != null ||
              milestone.dependentOnId != null ||
              milestone.dependentOnName != null
            );
          });

          // Keep Cabinet Milestone if any milestone has data
          // Otherwise remove it
          return hasCabinetMilestoneData;
        });
      } else if (_status !== PROJECT_STATUS.DRAFT) {
        var lastBucket = bucketMilestoneCOS[bucketMilestoneCOS.length - 1];

        if (
          lastBucket &&
          lastBucket.bucketName === "Cabinet Milestone" &&
          lastBucket.disabled === true
        ) {
          _bucketMilestoneCOSForPost = bucketMilestoneCOS.slice(0, -1);
        }
      }

      // NEW: Remove Cabinet Milestone bucket entirely if its
      // milestoneTableDataCOS entries all have an empty milestoneDataCOS array
      if (isValidArray(_bucketMilestoneCOSForPost)) {
        _bucketMilestoneCOSForPost = _bucketMilestoneCOSForPost.filter(function(
          item
        ) {
          if (item.bucketName !== "Cabinet Milestone") {
            return true;
          }

          var hasAnyMilestoneData =
            Array.isArray(item.milestoneTableDataCOS) &&
            item.milestoneTableDataCOS.some(function(table) {
              return (
                Array.isArray(table.milestoneDataCOS) &&
                table.milestoneDataCOS.length > 0
              );
            });

          // Remove Cabinet Milestone if no table has any milestone data
          return hasAnyMilestoneData;
        });
      }
    }
    const dataForPost = modifyDataForPost(
      { ...this.state, bucketMilestoneCOS: _bucketMilestoneCOSForPost },
      _status
    );
    const shouldCallCreateCostApi =
      this.state.stateWiseData &&
      typeof this.state.stateWiseData === "object" &&
      !Array.isArray(this.state.stateWiseData) &&
      Object.keys(this.state.stateWiseData).length > 0 &&
      get(this.state, "id") == undefined;
    dataForPost.projectStatus = _status;
    if (get(this.state, "id")) {
      dataForPost.projectId = get(this.state, "id");
    }
    clearProjectDataDispatch();
    if (_status === PROJECT_STATUS.DRAFT || _status === PROJECT_STATUS.UV) {
      const payloads = this.buildIndexWisePayloads(this.state.updated);

      for (const { index, payload } of payloads) {
        request(updateCostDistributionData(payload));
      }
    }
    this.setState(
      {
        isApiLoading: true
      },
      async () => {
        const response = await createProjectDispatch(undefined, dataForPost);
        let projectNameTitle = this.state.projectNameTitle;
        if (response) {
          const { message, status } = response;
          if (shouldCallCreateCostApi && status) {
            const projectId = get(response, "data.projectId");
            const payload = Object.values(this.state.stateWiseData).flat();

            const updated = payload.map((item, ind) => ({
              ...item,
              projectId
            }));

            request(postCostDistributionData(updated));
            this.setState({
              draftProjectId: projectId
            });
          }

          if (status) {
            this.setState(
              {
                ...defaultState(),
                resetForm: true,
                isApiLoading: true
              },
              () => {
                this.setState({
                  resetForm: false
                });
              }
            );
            if (_status === PROJECT_STATUS.DRAFT) {
              toast.success(
                <p className="toast-text-alignment">
                  Project draft saved successfully!
                </p>,
                successToastStyle
              );
              history.push({
                pathname: PATHS.PROJECT_LIST
              });
            } else {
              const userInfo = getLocalstorage("user");
              if (!get(userInfo, "projectCreatedBy")) {
                userInfo.projectCreatedBy = true;
                setLocalstorage("user", userInfo);
              }

              history.push({
                pathname: PATHS.SUCCESS,
                state: {
                  projectId: get(response, "data.projectId"),
                  message,
                  projectNameTitle: projectNameTitle
                }
              });
              toast.success(
                <p className="toast-text-alignment">{message}</p>,
                successToastStyle
              );
            }
          } else {
            toast.error(message);
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
    );
  };
  onEditSubmit = async (status, handleIIGDraft = false) => {
    const {
      editProjectDispatch,
      history,
      isEdit,
      onCloseModel,
      onProjectEdit
    } = this.props;

    const isIIGDraft = this.state.status === "CRIP_DRAFT";
    let { pragatiReviewDates, otherPP, previousOtherPP } = this.state;
    pragatiReviewDates =
      get(this.state, "pragatiReview") === false ? [] : pragatiReviewDates;
    let _pragatiReviewDatesArr =
      pragatiReviewDates && pragatiReviewDates.length
        ? pragatiReviewDates.map(item => {
            if (item || !isEmpty(item)) {
              return moment(item).toISOString();
            } else {
              return undefined;
            }
          })
        : [];

    let pragatiReviewDatesForPost = _pragatiReviewDatesArr.filter(
      item => item !== null && item !== undefined
    );
    let _otherPP =
      otherPP &&
      otherPP.length &&
      otherPP.map((item, index) => {
        let _previousOtherPP;
        if (previousOtherPP && previousOtherPP.length === otherPP.length) {
          _previousOtherPP =
            previousOtherPP && previousOtherPP.length
              ? previousOtherPP[index]
                ? previousOtherPP[index]
                : null
              : null;
        } else {
          _previousOtherPP =
            previousOtherPP &&
            previousOtherPP.length &&
            previousOtherPP.find(pp => item.id === pp.id);
        }

        if (item) {
          return {
            previousUserId: _previousOtherPP ? _previousOtherPP.id : null,
            updatedUserId: item.id
          };
        }
      });

    let filteredOtherPP =
      _otherPP &&
      _otherPP.length &&
      _otherPP.filter(item => item !== undefined);

    const dataForPost = {
      ...modifyDataForPost({ ...this.state, isEdit }),
      projectId: isIIGDraft
        ? get(this.state, "projectId")
        : get(this.state, "id"),
      pragatiReviewDates: pragatiReviewDatesForPost,
      projectStatus: status,
      otherPP: filteredOtherPP || [],
      userID: get(this.state, "previousCreatedBy")
    };
    this.setState({
      isApiLoading: true,
      showAlert: false,
      showSectorChangeAlert: false
    });
    // make API call for edit project
    const response = await editProjectDispatch(undefined, dataForPost);
    if (!isIIGDraft) {
      onCloseModel();
    }
    if (response) {
      const { message, status } = response;
      if (status) {
        if (isIIGDraft) {
          if (handleIIGDraft) {
            this.handleIIGDraftSavedSuccess(handleIIGDraft);
          }
        } else {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState(
            {
              ...defaultState(),
              resetForm: true
            },
            () => {
              this.setState({
                resetForm: false
              });
            }
          );
          if (isEdit) {
            isFunction(onProjectEdit) && onProjectEdit();
            history.push({
              pathname: PATHS.PROJECT_DETAILS,
              search: `?projectId=${get(this.state, "id")}`,
              state: { projectId: get(this.state, "id"), message }
            });
          }
        }
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {message || ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onMilestoneUpdate = status => {
    const {
      editProjectMilestonesAction,
      history,
      projectId,
      initialApiCall
    } = this.props;

    const bucketMilestoneCOS = get(this.state, "bucketMilestoneCOS", []);

    // On "Save as Draft", drop the Cabinet Milestone bucket entirely if the
    // user hasn't entered any data into it — don't send an empty/untouched
    // cabinet bucket to the backend.
    let _bucketMilestoneCOSForPost = bucketMilestoneCOS;
    if (
      status === PROJECT_STATUS.DRAFT_MILESTONE &&
      isValidArray(bucketMilestoneCOS)
    ) {
      const cabinetBucket = bucketMilestoneCOS.find(
        item => item.bucketName === "Cabinet Milestone"
      );
      if (cabinetBucket && !this.hasCabinetMilestoneData(cabinetBucket)) {
        _bucketMilestoneCOSForPost = bucketMilestoneCOS.filter(
          item => item.bucketName !== "Cabinet Milestone"
        );
      }
    }

    const dataForPost = {
      bucketMilestoneCOS:
        setOutgoingDataForMilestone(_bucketMilestoneCOSForPost) || [],
      projectId: projectId,
      projectMilestoneStatus:
        status === PROJECT_STATUS.DRAFT_MILESTONE ? "DRAFT" : "ADDED"
    };
    this.setState(
      {
        isApiLoading: true
      },
      async () => {
        const response = await editProjectMilestonesAction(
          undefined,
          dataForPost
        );
        if (response) {
          const { message, status } = response;
          if (status) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
            initialApiCall();
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth"
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">
                {message || ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
              </p>,
              errorToastStyle
            );
          }
          this.setState({
            isApiLoading: false
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
    );
  };
  validateMilestones = (milestoneArr, updateSharedState = true) => {
    let isValueExists = false;
    let completedDatesExists = false;
    let checkisMilestoneDisabled = false;
    let milestoneValidate = false;
    let checkCostExists = false;
    let checkBucketNameForArea = false;
    let checkAreaExists = false;
    let checkBucketNameForCost = false;
    let isFinishDateGreater = false;
    let isStartDatelesser = false;

    bucketloop: for (let i = 0; i < milestoneArr.length; i++) {
      checkBucketNameForArea =
        milestoneArr[i].bucketType === "COST_AND_DATES_AND_AREA";

      checkBucketNameForCost =
        milestoneArr[i].bucketType === "COST_AND_DATES" ||
        milestoneArr[i].bucketType === "COST_AND_DATES_AND_AREA";

      checkCostExists =
        milestoneArr[i].hasOwnProperty("originalCost") &&
        milestoneArr[i].hasOwnProperty("revisedCost") &&
        milestoneArr[i].originalCost !== "" &&
        milestoneArr[i].revisedCost !== "";

      checkAreaExists =
        milestoneArr[i].hasOwnProperty("originalArea") &&
        milestoneArr[i].hasOwnProperty("revisedArea") &&
        milestoneArr[i].originalArea !== null &&
        milestoneArr[i].revisedArea !== null;

      completedDatesExists =
        milestoneArr[i].hasOwnProperty("originalScheduledFinishDate") &&
        milestoneArr[i].hasOwnProperty("originalScheduledStartDate") &&
        milestoneArr[i].hasOwnProperty("revisedScheduledFinishDate") &&
        milestoneArr[i].hasOwnProperty("revisedScheduledStartDate") &&
        !!milestoneArr[i].originalScheduledFinishDate &&
        !!milestoneArr[i].originalScheduledStartDate &&
        !!milestoneArr[i].revisedScheduledFinishDate &&
        !!milestoneArr[i].revisedScheduledStartDate;

      milestoneValidate = !!completedDatesExists;
      if (!!milestoneArr[i].disabled && i !== milestoneArr.length - 1) {
        milestoneValidate = true;
        continue;
      }
      if (!!milestoneArr[i].disabled && i == milestoneArr.length - 1) {
        milestoneValidate = true;
        break;
      }
      if (!!milestoneArr[i].completed && i !== milestoneArr.length - 1) {
        if (!completedDatesExists) {
          milestoneValidate = false;
          break;
        } else {
          if (checkBucketNameForCost) {
            if (checkCostExists) {
              milestoneValidate = true;
            } else {
              milestoneValidate = false;
              break;
            }
          }
          if (checkBucketNameForArea) {
            if (checkAreaExists) {
              milestoneValidate = true;
            } else {
              milestoneValidate = false;
              break;
            }
          }
          milestoneValidate = true;
          continue;
        }
      }
      if (!!milestoneArr[i].completed && i == milestoneArr.length - 1) {
        if (!completedDatesExists) {
          milestoneValidate = false;
          break;
        } else {
          if (checkBucketNameForCost) {
            if (checkCostExists) {
              milestoneValidate = true;
            } else {
              milestoneValidate = false;
              break;
            }
          }
          if (checkBucketNameForArea) {
            if (checkAreaExists) {
              milestoneValidate = true;
            } else {
              milestoneValidate = false;
              break;
            }
          }
          milestoneValidate = true;
          break;
        }
      }
      for (let j = 0; j < milestoneArr[i].milestoneTableDataCOS.length; j++) {
        let physicalProgressExists =
          milestoneArr[i].milestoneTableDataCOS[j].hasOwnProperty(
            "physicalPercentage"
          ) &&
          milestoneArr[i].milestoneTableDataCOS[j].physicalPercentage !== null;
        let financialProgressExists =
          milestoneArr[i].milestoneTableDataCOS[j].hasOwnProperty(
            "financialPercentage"
          ) &&
          milestoneArr[i].milestoneTableDataCOS[j].financialPercentage !== null;

        //Validation for As Of Date under Milestone Phases
        if (physicalProgressExists || financialProgressExists) {
          let asOfDateExists =
            milestoneArr[i].milestoneTableDataCOS[j].hasOwnProperty(
              "asOfDate"
            ) && milestoneArr[i].milestoneTableDataCOS[j].asOfDate !== null;
          if (asOfDateExists) {
            milestoneValidate = true;
          } else {
            milestoneValidate = false;
            break;
          }
        }
        let milestoneData =
          milestoneArr[i].milestoneTableDataCOS[j].milestoneDataCOS;
        milestoneData = milestoneData.filter(item => item !== undefined);
        for (let k = 0; k < milestoneData.length; k++) {
          if (milestoneData[k].disabled) {
            milestoneValidate = true;
            continue;
          }
          isFinishDateGreater =
            milestoneData[k].originalScheduledFinishDate <
              milestoneData[k].originalScheduledStartDate ||
            milestoneData[k].revisedScheduledFinishDate <
              milestoneData[k].revisedScheduledStartDate
              ? true
              : false;
          isStartDatelesser =
            milestoneData[k].originalScheduledFinishDate >
              milestoneData[k].originalScheduledStartDate ||
            milestoneData[k].revisedScheduledFinishDate >
              milestoneData[k].revisedScheduledStartDate
              ? true
              : false;
          isValueExists =
            !!milestoneData[k].originalScheduledStartDate &&
            !!milestoneData[k].originalScheduledFinishDate &&
            !!milestoneData[k].responsibleAuthorityId &&
            (!!milestoneData[k].responsibleAuthorityName &&
            milestoneData[k].responsibleAuthorityName === "Others"
              ? !!milestoneData[k].otherResponsibleAuthority
              : true) &&
            !!milestoneData[k].dependencyType &&
            ((!!milestoneData[k].dependencyType &&
              milestoneData[k].dependencyType === "INDEPENDENT") ||
            milestoneData.length == 1
              ? true
              : !!milestoneData[k].dependentOnId);
          // console.log(isValueExists, milestoneData, milestoneData[k]);
          checkisMilestoneDisabled = !!milestoneData.disabled;

          if (isFinishDateGreater) {
            milestoneValidate = true;
          }
          if (isStartDatelesser) {
            milestoneValidate = true;
          }

          if (isValueExists && !checkisMilestoneDisabled) {
            milestoneValidate = true;
          } else if (checkisMilestoneDisabled) {
            milestoneValidate = true;
          } else {
            milestoneValidate = false;
            break bucketloop;
          }
        }
      }
    }
    // this.setState({
    //   isMilestoneTableValidated: milestoneValidate
    // });
    // return milestoneValidate;
    if (updateSharedState) {
      this.setState({
        isMilestoneTableValidated: milestoneValidate
      });
    }
    return milestoneValidate;
  };
  onValidateForm = async status => {
    const { previewData, pageDetail, isEdit, history, permission } = this.props;

    const {
      cost,
      name,
      error,
      cin,
      issueCOList,
      subSectorList,
      groupId,
      projectCompletionDTO,
      projectImplementationStartState,
      revisedCost,
      isOtherSelected,
      otherBankName,
      projectImplementationDirectEmployment,
      projectImplementationInDirectEmployment,
      projectNameTitle,
      projectImplementationAnticipatedDate,
      projectImplementationStartDate,
      projectImplementationSanctionDate,
      bucketMilestoneCOS,
      pli,
      iigPayload,
      stateCost,
      centralCost,
      fundReleaseCost,
      executingAgency,
      geoCoordinates,
      sponsoringDepartmentId,
      sponsoringAgency,
      schemeForAr,
      projectCategoryId,
      projectCreatedFrom,
      implementationMode,
      pragatiCycleDate,
      pragatiReviewDates
    } = this.state;
    const isIIGDraft = this.state.status === "CRIP_DRAFT";
    const isMizoramState = groupId === "170" || groupId === 170;
    const errorObj = { ...error };
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    const isStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const isUserCENTRAL = get(userInfo, "groupCategory") === "CENTRAL";
    const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";

    const mandatoryFields = [
      "projectCategoryId",
      "name",
      "description",
      "groupId",
      "sectorId",
      //"implementationMode",
      "locations",
      "projectImplementationClassification"
    ];
    if (
      implementationMode === "- Select Mode -" ||
      implementationMode == null
    ) {
      mandatoryFields.push("implementationMode");
    }
    const projectExtensionValidation = [
      { name: "stateCost", condition: isMizoramState && !stateCost },
      { name: "centralCost", condition: isMizoramState && !centralCost }
    ];

    if (
      get(permission, "createStateProject") &&
      this.state.projectCategoryId == "STATE" &&
      (sponsoringDepartmentId == "" || sponsoringDepartmentId == null) &&
      this.state.sponsoringDeptARdata.length !== 0
    ) {
      mandatoryFields.push("sponsoringDepartmentId");
    }

    const isSuperAdmin =
      this.props !== null &&
      this.props.pageDetail !== null &&
      this.props.pageDetail !== undefined &&
      this.props.pageDetail.superAdmin;
    const isFormTypeNotDefault =
      get(previewData, "formType") !== "DEFAULT" ||
      (get(previewData, "formType") === "DEFAULT" &&
        get(previewData, "status") === "UNDER_VERIFICATION") ||
      (get(previewData, "formType") === "DEFAULT" &&
        get(previewData, "status") === "VERIFIED");
    if (groupId !== "226" && groupId !== 226 && !isSuperAdmin) {
      mandatoryFields.push("cost");
    }
    if (cost == "" && !isSuperAdmin) {
      mandatoryFields.push("cost");
    }
    if (groupId == 170) {
      if (centralCost == "" || centralCost == null) {
        mandatoryFields.push("centralCost");
        if (get(errorObj, "centralCostErr.error")) {
          mandatoryFields.push("centralCostErr");
        }
      }
      if (stateCost == "" || stateCost == null) {
        mandatoryFields.push("stateCost");
        if (get(errorObj, "stateCostShareErr.error")) {
          mandatoryFields.push("stateCostShareErr");
        }
      }
    }
    const effectivePragatiReviewDates =
      get(this.state, "pragatiReview") === false
        ? []
        : get(this.state, "pragatiReviewDates", []);

    const hasNullOrUndefined =
      effectivePragatiReviewDates.length === 0 ||
      effectivePragatiReviewDates.some(d => d == null);
    if (
      hasNullOrUndefined &&
      projectCategoryId == "CENTRAL" &&
      get(this.state, "pragatiReview") &&
      isUserPMG
    ) {
      mandatoryFields.push("pragatiReviewDates");
    }
    if (
      pragatiCycleDate == null &&
      projectCategoryId == "CENTRAL" &&
      get(this.state, "pragatiPipeline") &&
      isUserPMG
    ) {
      mandatoryFields.push("pragatiCycleDate");
    }
    if (projectCategoryId == "CENTRAL" || groupId != 78) {
      // console.log(this.state.locations);
      if (this.state.locations.length == 0) {
        this.setState({ locations: [{}] }, () => {
          this.state.locations.forEach(obj => {
            if (obj.id === undefined) {
              // If not, set it to 0
              obj.id = "";
            }
          });
          this.state.locations.forEach(data => {
            if (data.id === "") {
              mandatoryFields.push("locationsErr");
              this.setState({ stateErrormessage: true });
            }
          });
        });
      } else {
        this.state.locations.forEach(obj => {
          if (obj.id === undefined) {
            // If not, set it to 0
            obj.id = "";
          }
        });
        this.state.locations.forEach(data => {
          if (data.id === "") {
            mandatoryFields.push("locationsErr");
            this.setState({ stateErrormessage: true });
          }
        });
      }
    }
    if (groupId == 78) {
      if (fundReleaseCost == "" || fundReleaseCost == null) {
        mandatoryFields.push("fundReleaseCost");
        if (get(errorObj, "fundReleaseCost.error")) {
          mandatoryFields.push("fundReleaseCost");
        }
      }
      if (executingAgency == "" || executingAgency == null) {
        mandatoryFields.push("executingAgency");
        if (get(errorObj, "executingErr.error")) {
          mandatoryFields.push("executingErr");
        }
      }
      if (centralCost == "" || centralCost == null) {
        mandatoryFields.push("centralCost");
        if (get(errorObj, "centralCostErr.error")) {
          mandatoryFields.push("centralCostErr");
        }
      }
      if (stateCost == "" || stateCost == null) {
        mandatoryFields.push("stateCost");
        if (get(errorObj, "stateCostShareErr.error")) {
          mandatoryFields.push("stateCostShareErr");
        }
      }
      if (sponsoringDepartmentId == "" || sponsoringDepartmentId == null) {
        mandatoryFields.push("sponsoringDepartmentId");
      }
      if (sponsoringAgency == "" || sponsoringAgency == null) {
        mandatoryFields.push("sponsoringAgency");
      }
      if (schemeForAr == "" || schemeForAr == null) {
        mandatoryFields.push("schemeForAr");
        if (get(errorObj, "schemeForArErr.error")) {
          mandatoryFields.push("schemeForArErr");
        }
      }

      const index = mandatoryFields.indexOf("implementationMode");

      // Remove the element at the found index
      if (index !== -1) {
        mandatoryFields.splice(index, 1);
      }
      //console.log(this.state.locations);
      if (this.state.locations.length == 0) {
        this.setState({ locations: [{}] }, () => {
          this.state.locations.forEach(obj => {
            // Check if 'districtId' exists and is not undefined
            if (obj.districtId === undefined) {
              // If not, set it to 0
              obj.districtId = 0;
            }
            if (obj.id === undefined) {
              // If not, set it to 0
              obj.id = "";
            }
          });
          //console.log("success", this.state.locations);
          this.state.locations.forEach(data => {
            //console.log("success",data)
            if (data.districtId === 0) {
              //console.log("success",data)
              mandatoryFields.push("locationsErr");
              this.setState({ districtErrormessage: true });
            }
            if (data.id === "") {
              //console.log("success",data)
              mandatoryFields.push("locationsErr");
              this.setState({ stateErrormessage: true });
            }
          });
        });
      } else {
        this.state.locations.forEach(obj => {
          // Check if 'districtId' exists and is not undefined
          if (obj.districtId === undefined) {
            // If not, set it to 0
            obj.districtId = 0;
          }
          if (obj.id === undefined) {
            // If not, set it to 0
            obj.id = "";
          }
        });
        this.state.locations.forEach(data => {
          if (data.districtId === 0) {
            mandatoryFields.push("locationsErr");
            this.setState({ districtErrormessage: true });
          }
          if (data.id === "") {
            mandatoryFields.push("locationsErr");
            this.setState({ stateErrormessage: true });
          }
        });
      }
      if (geoCoordinates == "" || geoCoordinates == undefined) {
        this.setState({ geoCordinateError: "This field is required." });
        mandatoryFields.push("geoCoordinates");
      }
      if (get(errorObj, "costError.error")) {
        mandatoryFields.push("costError");
      }
    }
    !isEdit && !isIIGDraft && mandatoryFields.push("milestoneMandatoryFields");

    if (get(pageDetail, "cin")) {
      mandatoryFields.push("cin");
    }
    if (groupId) {
      let toRemove = "groupId";
      let index = mandatoryFields.indexOf(toRemove);
      mandatoryFields.splice(index, 1);
    }

    if (
      this.state.userCanOnlyCreateCentralProject ||
      this.state.userCanOnlyCreateStateProject
    ) {
      let toRemove = "projectCategoryId";
      let index = mandatoryFields.indexOf(toRemove);
      mandatoryFields.splice(index, 1);
    }

    if (isOtherSelected) {
      mandatoryFields.push("otherBankName");
    }

    if (!pli && projectImplementationStartState === "UNDER_IMPLEMENTATION") {
      mandatoryFields.push("projectCompletionDTO");
      if (
        projectCompletionDTO &&
        (projectCompletionDTO.status === "provisionallyCommissioned" ||
          projectCompletionDTO.status === "PROVISIONALLY COMMISSIONED")
      ) {
        isEdit
          ? isFormTypeNotDefault && mandatoryFields.push("progressAsof")
          : mandatoryFields.push("progressAsof");
      }
    }
    if (isUserPMG == false) {
      this.setState({ projectstageerror: "This field is required." });
      if (
        projectCompletionDTO &&
        (projectCompletionDTO.status === "projectPhysicallyCompleted" ||
          projectCompletionDTO.status === "Physically Completed/CC Under Issue")
      ) {
        this.setState({ projectstageerror: "" });
      } else if (projectCompletionDTO.status === "commissioned") {
        this.setState({ projectstageerror: "" });
      }
    }
    if (
      (!pli && projectImplementationStartState === "COMPLETED") ||
      isEdit == true
    ) {
      //console.log(isEdit)
      mandatoryFields.push("projectCompletionDTO");
      //console.log(isFormTypeNotDefault)

      if (
        projectCompletionDTO &&
        (projectCompletionDTO.status === "projectPhysicallyCompleted" ||
          projectCompletionDTO.status === "Physically Completed/CC Under Issue")
      ) {
        isEdit
          ? isFormTypeNotDefault && mandatoryFields.push("progressAsof")
          : mandatoryFields.push("progressAsof");
        this.setState({ projectstageerror: "" });
      } else if (projectCompletionDTO.status === "commissioned") {
        this.setState({ projectstageerror: "" });
      }
    }
    if (
      !pli &&
      (projectImplementationStartState == "UNDER_IMPLEMENTATION" &&
        (projectCompletionDTO.percentage === "" ||
          projectCompletionDTO.percentage === null))
    ) {
      invalidForm = true;
      errorObj["percentage"] = {
        error: true,
        message: "This field is required"
      };

      mandatoryFields.push("percentage");
    } else {
      delete errorObj["percentage"];
    }
    if (
      projectCompletionDTO.percentage < 0 ||
      projectCompletionDTO.percentage > 100
    ) {
      errorObj["percentage"] = {
        error: true,
        message: "Must be less than 100% or mark project status as Completed."
      };
      mandatoryFields.push("percentage");
    }
    if (
      projectCompletionDTO.percentage == 100 &&
      projectImplementationStartState !== "COMPLETED"
    ) {
      errorObj["percentage"] = {
        error: true,
        message: "Must be less than 100% or mark project status as Completed."
      };
      mandatoryFields.push("percentage");
    }

    if (
      !pli &&
      projectImplementationStartState !== "IMPLEMENTATION_NOT_STARTED"
    ) {
      isEdit
        ? isFormTypeNotDefault && mandatoryFields.push("date")
        : mandatoryFields.push("date");
    }

    // Here is the validation of the prject extensions fields
    projectExtensionValidation.forEach(projectField => {
      if (projectField.condition) {
        mandatoryFields.push(projectField.name);
      }
    });

    if (
      get(permission, "createStateProject") &&
      this.state.projectCategoryId == "STATE" &&
      (!sponsoringDepartmentId ||
        sponsoringDepartmentId == "" ||
        sponsoringDepartmentId == null)
    ) {
      mandatoryFields.push("sponsoringDepartmentId");
    }

    if (
      !isIIGDraft &&
      !pli &&
      !isEdit &&
      projectImplementationStartState !== "COMPLETED"
    ) {
      //mandatoryFields.push("projectImplementationStartDate");
      if (isEdit) {
        if (
          (isFormTypeNotDefault &&
            !get(previewData, "projectImplementationAnticipatedDate")) ||
          (get(previewData, "formType") === "DEFAULT" &&
            get(previewData, "status") === "UNDER_VERIFICATION")
        ) {
          if (!isSuperAdmin) {
            mandatoryFields.push("projectImplementationAnticipatedDate");
          }
        }
      } else {
        if (!isSuperAdmin) {
          mandatoryFields.push("projectImplementationAnticipatedDate");
        }
      }
    }

    if (!isSuperAdmin && !pli) {
      mandatoryFields.push("projectImplementationAnticipatedDate");
    }

    if (
      (projectImplementationStartState === "COMPLETED" &&
        !isSuperAdmin &&
        !pli &&
        !isEdit &&
        !isIIGDraft) ||
      isFormTypeNotDefault
    ) {
      //console.log("mandatroy", mandatoryFields);
      mandatoryFields.push("projectImplementationStartDate");
    }
    let isPmg = true;
    if (isEdit && isPmg && this.props.superAdminPMGUserAdmin) {
      let toRemove = "projectImplementationStartDate";
      let index = mandatoryFields.indexOf(toRemove);
      //console.log("index", index);
      mandatoryFields.splice(index, 1);
    }

    if ((!isEdit || (!isUserPMG && !isStatePMG)) && !isIIGDraft) {
      mandatoryFields.push("projectImplementationSanctionDate");
    }

    if (revisedCost) {
      mandatoryFields.push("revisedCost");
    }

    if (isValidArray(subSectorList)) {
      mandatoryFields.push("subSectorId");
    }

    if (isValidArray(errorObj.issueCOListError)) {
      mandatoryFields.push("issueCOListError");
    }
    let isMilestoneDataValidated = false;
    if (!isEmpty(bucketMilestoneCOS) && !isEdit) {
      const cabinetBuckets = bucketMilestoneCOS.filter(
        item => item.bucketName === "Cabinet Milestone"
      );
      const isCabinetExempt = this.isCabinetMilestoneMandatoryExempt();
      const cabinetHasData = cabinetBuckets.some(this.cabinetBucketHasData);

      // Cabinet Milestone must be validated as mandatory whenever:
      // - the ministry is one of the 4 cost-gated ones (not exempt), OR
      // - it's exempt, but the user has already entered some data in it
      //   (partial data is never allowed to silently pass through)
      const includeCabinetInValidation = !isCabinetExempt || cabinetHasData;

      const milestonesForValidation = includeCabinetInValidation
        ? bucketMilestoneCOS
        : bucketMilestoneCOS.filter(
            item => item.bucketName !== "Cabinet Milestone"
          );

      isMilestoneDataValidated = isValidArray(milestonesForValidation)
        ? this.validateMilestones(milestonesForValidation)
        : true;
    }

    let invalidForm = false;

    if (
      !isEdit &&
      !isIIGDraft &&
      !isEmpty(bucketMilestoneCOS) &&
      !isMilestoneDataValidated
    ) {
      invalidForm = true;
      errorObj["milestoneMandatoryFields"] = {
        error: true,
        message: "Mandatory fields are missing"
      };
    } else {
      delete errorObj["milestoneMandatoryFields"];
    }

    if (status !== PROJECT_STATUS.DRAFT) {
      //console.log(status)
      if (
        (groupId === "226" || groupId === 226) &&
        ((cost < 200 || (revisedCost !== "" && revisedCost < 200)) &&
          +projectImplementationDirectEmployment +
            +projectImplementationInDirectEmployment <
            1000) &&
        !get(pageDetail, "superAdmin")
      ) {
        invalidForm = true;
      } else if (
        errorObj.financialPercentage &&
        errorObj.financialPercentage.error
      ) {
        invalidForm = true;
      } else {
        mandatoryFields.forEach(fieldKey => {
          let value = get(errorObj, fieldKey);

          if (!value) {
            switch (fieldKey) {
              case "cin":
                errorObj[fieldKey] = {
                  error: true,
                  message: !cin ? "This field is required." : "Please validate"
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "locations":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey].push({
                  error: true,
                  message: "This field is required."
                });
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationAnticipatedDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationAnticipatedDate,
                  message: !projectImplementationAnticipatedDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationStartDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationStartDate,
                  message: !projectImplementationStartDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationSanctionDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationSanctionDate,
                  message: !projectImplementationSanctionDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "date":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey] =
                  !projectCompletionDTO ||
                  (projectCompletionDTO && !projectCompletionDTO.date)
                    ? { error: true, message: "This field is required." }
                    : { error: false };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "progressAsof":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey] =
                  !projectCompletionDTO ||
                  (projectCompletionDTO &&
                    !projectCompletionDTO.physicalProgressAsOf)
                    ? { error: true, message: "This field is required." }
                    : { error: false };
                if (errorObj[fieldKey]["error"]) {
                  //console.log(errorObj)
                  invalidForm = true;
                }
                return errorObj[fieldKey];
              case "milestoneMandatoryFields":
                errorObj[fieldKey] = {
                  error: !isMilestoneDataValidated,
                  message: !isMilestoneDataValidated
                    ? "Mandatory fields are missing"
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "pragatiReviewDates":
                errorObj[fieldKey] = {
                  error: true,
                  message: "This field is required."
                };
                invalidForm = true;
                return errorObj[fieldKey];

              default:
                invalidForm = true;

                return (errorObj[fieldKey] = {
                  error: true,
                  message: "This field is required."
                });
            }
          } else {
            switch (fieldKey) {
              case "otherBankName":
                errorObj[fieldKey] = {
                  error: !!(otherBankName === "" || otherBankName === null),
                  message: !!(otherBankName === "" || otherBankName === null)
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationAnticipatedDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationAnticipatedDate,
                  message: !projectImplementationAnticipatedDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationStartDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationStartDate,
                  message: !projectImplementationStartDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  //console.log(errorObj[fieldKey])
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectImplementationSanctionDate":
                errorObj[fieldKey] = {
                  error: !projectImplementationSanctionDate,
                  message: !projectImplementationSanctionDate
                    ? "This field is required."
                    : ""
                };
                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "locations":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                return errorObj[fieldKey].forEach(value => {
                  if (value.error) {
                    invalidForm = true;
                  }
                });
              case "date":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey] =
                  !projectCompletionDTO ||
                  (projectCompletionDTO && !projectCompletionDTO.date)
                    ? { error: true, message: "This field is required." }
                    : { error: false };
                if (errorObj[fieldKey]["error"]) {
                  //console.log(errorObj[fieldKey])
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "progressAsof":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey] =
                  !projectCompletionDTO ||
                  (projectCompletionDTO &&
                    !projectCompletionDTO.physicalProgressAsOf)
                    ? { error: true, message: "This field is required." }
                    : { error: false };
                if (errorObj[fieldKey]["error"]) {
                  //console.log(errorObj[fieldKey])
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "projectCompletionDTO":
                errorObj[fieldKey] = errorObj[fieldKey] || [];
                errorObj[fieldKey] =
                  !projectCompletionDTO ||
                  (projectCompletionDTO && !projectCompletionDTO.status)
                    ? { error: true }
                    : { error: false };
                if (errorObj[fieldKey]["error"]) {
                  //console.log(errorObj[fieldKey])
                  invalidForm = true;
                }
                return errorObj[fieldKey];

              case "issueCOListError":
                let issueList = get(errorObj, "issueCOListError");
                errorObj["issuesError"] = issueList.map(value => {
                  if (value.error) {
                    invalidForm = true;
                  }
                  return value;
                });
                return errorObj[fieldKey];

              case "milestoneMandatoryFields":
                errorObj[fieldKey] = {
                  error: !isMilestoneDataValidated,
                  message: !isMilestoneDataValidated
                    ? "Mandatory fields are missing"
                    : ""
                };
                //console.log("errorObj[fieldKey]", errorObj[fieldKey]);

                if (errorObj[fieldKey]["error"]) {
                  invalidForm = true;
                }
                return errorObj[fieldKey];
              case "pragatiReviewDates":
                errorObj[fieldKey] = {
                  error: true,
                  message: "This field is required."
                };
                invalidForm = true;
                return errorObj[fieldKey];

              default:
                if (!invalidForm) {
                  invalidForm = get(value, "error");
                }
                return;
            }
          }
        });
      }

      // check for map image file
      if (
        this.state.mapImageFiles.length === 0 &&
        groupId != 78 &&
        groupId != 203 &&
        projectCreatedFrom != "UP" &&
        ((!isEdit && !isIIGDraft) || (isEdit && !isUserPMG))
      ) {
        invalidForm = true;
        errorObj["mapImageFiles"] = {
          error: true,
          message: "Map image file is mandatory"
        };
      } else {
        delete errorObj["mapImageFiles"];
      }
    }
    const {
      userValidateError,
      defaultSelected,
      inValidUser,
      userID,
      updatedCreatedById,
      otherppError
    } = this.state;
    const proponenetGroupID = get(userInfo, "groupId");
    let isProponentMandatory = false;

    // === Condition 1: defaultSelected is empty and role is one of the PMG types
    if (
      (defaultSelected === "" && isUserPMG) ||
      (defaultSelected === "" && isStatePMG) ||
      (defaultSelected === "" && isUserCENTRAL) ||
      (defaultSelected === "" &&
        isStateDepartment &&
        proponenetGroupID == sponsoringDepartmentId)
    ) {
      isProponentMandatory = true;
    } else {
      // === Condition 2: defaultSelected does not match expected format from userID object
      if (typeof userID === "object" && userID != null) {
        const validFullFormat =
          isStatePMG || isStateDepartment
            ? `${userID.name} (${userID.organization})`
            : `${userID.name} (${userID.userID})`;
        const validNameOnly = `${userID.name}`;

        if (
          defaultSelected !== validFullFormat &&
          defaultSelected !== validNameOnly
        ) {
          isProponentMandatory = true;
        }
      } else if (typeof updatedCreatedById === "object") {
        // === Condition 3: defaultSelected does not match updatedCreatedById name
        // console.log("success",defaultSelected);
        // console.log("success",updatedCreatedById);
        if (defaultSelected !== `${updatedCreatedById.name}`) {
          isProponentMandatory = true;
        }
      }
    }

    // === Condition 4: userValidateError is explicitly true
    if (userValidateError === true) {
      isProponentMandatory = true;
    }

    // === Show error if Invalid User message OR userValidateError triggered
    if (inValidUser === "Invalid User" || userValidateError === true) {
      this.setState({ redBorder: "invalid" });
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          defaultSelected: {
            error: true,
            message: "Invalid User"
          }
        }
      }));
    }

    if (isProponentMandatory) {
      this.setState({ redBorder: true });
      invalidForm = true;
      errorObj["defaultSelected"] = {
        error: true,
        message: "This field is required."
      };
    } else {
      delete errorObj["defaultSelected"];
    }
    if (otherppError) {
      invalidForm = true;
    }
    if (!invalidForm) {
      this.setState({
        error: errorObj,
        invalidForm: invalidForm
      });
      if (isIIGDraft && status === "verifyIIGDraft") {
        await this.handleModalShowOnVerifyClick();
      } else if (isIIGDraft) {
        if (status === "Preview") {
          history.push({
            pathname: PATHS.PREVIEW,
            isEdit: isEdit
          });
          this.setFormDataInRedux();
        } else {
          // save as draft function
          this.openConfirmationAlert("CRIP_DRAFT");
        }
      } else {
        const isDuplicateIssue = validateDuplicatedIssue(issueCOList);
        if (get(isDuplicateIssue, "error")) {
          toast.error(
            <p className="toast-text-alignment">
              {get(isDuplicateIssue, "message")}
            </p>,
            errorToastStyle
          );
        } else {
          if (status === "Preview") {
            history.push({
              pathname: PATHS.PREVIEW,
              isEdit: isEdit
            });
            this.setFormDataInRedux();
          } else {
            const params = {
              sponsoringGroupId: +groupId || 0,
              name: name,
              cost: +cost
            };
            previewData && (params["projectId"] = get(previewData, "id"));
            this.setState({ isApiLoading: true });
            const isProjectDuplicateResp = await isDuplicateProjectAction(
              undefined,
              params
            );

            if (isProjectDuplicateResp) {
              this.setState({ isApiLoading: false });
              if (
                !get(isProjectDuplicateResp, "data") &&
                get(isProjectDuplicateResp, "status")
              ) {
                this.openConfirmationAlert(status);
              } else {
                if (!name || name === "") {
                  toast.error(
                    <p className="toast-text-alignment">
                      Please enter the {projectNameTitle}.
                    </p>,
                    errorToastStyle
                  );
                } else {
                  toast.error(
                    <p className="toast-text-alignment">
                      Project is already created.
                    </p>,
                    errorToastStyle
                  );
                }
              }
            }
          }
        }
      }
    } else {
      this.setState({
        error: errorObj,
        invalidForm: invalidForm
      });
      if (
        (groupId === "226" || groupId === 226) &&
        ((cost < 200 || (revisedCost !== "" && revisedCost < 200)) &&
          +projectImplementationDirectEmployment +
            +projectImplementationInDirectEmployment <
            1000) &&
        !get(pageDetail, "superAdmin")
      ) {
        toast.error(
          <p className="toast-text-alignment">
            Either Project cost to be greater than 200 Cr. or Total Employment
            Generation to be greater than 1000
          </p>,
          errorToastStyle
        );
      } else if (
        errorObj.financialPercentage &&
        errorObj.financialPercentage.error
      ) {
        toast.error(
          <p className="toast-text-alignment">
            Financial Progress % field{" "}
            {errorObj.financialPercentage.message.toLowerCase()}
          </p>,
          errorToastStyle
        );
      } else if (
        (projectCompletionDTO.percentage < 0 ||
          projectCompletionDTO.percentage >= 100) &&
        projectImplementationStartState !== "COMPLETED"
      ) {
        toast.error(
          <p className="toast-text-alignment">
            Physical progress should be more than equal to 0 or less than 100
          </p>,
          errorToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {otherppError ? ERROR_MSG.OTHER_PP_INVALID : ERROR_MSG.INVALID_FORM}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  onSubmitPopUp = () => {
    const { isEdit, openMilestoneEdit } = this.props;
    const { projectStatus, status } = this.state;
    const isIIGDraft = status === "CRIP_DRAFT";
    openMilestoneEdit
      ? this.onMilestoneUpdate(projectStatus)
      : isEdit || isIIGDraft
      ? this.onEditSubmit(projectStatus, true)
      : this.onSubmit(projectStatus);
  };

  updateParentState = (key, value) => {
    this.setState({
      [key]: value,
      dataUnsaved: true
    });
  };

  updateParentStateError = (key, value) => {
    this.setState(prevState => {
      return {
        error: {
          ...prevState.error,
          [key]: value
        }
      };
    });
  };

  resetAddIssue = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value,
        issuesError: value
      }
    }));
  };

  setFormDataInRedux = () => {
    const { setProjectDataDispatch } = this.props;
    setProjectDataDispatch(this.state);
  };

  openConfirmationAlert = projectStatus => {
    this.setState(prevState => ({
      projectStatus,
      showAlert: !prevState.showAlert
    }));
  };

  openSectorChangeConfirmationAlert = (value, key, options) => {
    let sectorTempObj = { value, key, options };
    this.setState(prevState => ({
      sectorTempObj: sectorTempObj,
      showSectorChangeAlert: !prevState.showSectorChangeAlert
    }));
    if (key === "sectorId") {
      this.setState({
        sectorWarningGiven: true
      });
    }
  };

  onAutoSuggestChange = value => {
    const { bucketMilestoneCOS, error } = this.state;
    const userInfo = getLocalstorage("user");
    const updatedError = { ...error };
    delete updatedError["defaultSelected"];
    this.setState({
      autoSuggestApiLoading: STATUS.LOADING,
      defaultSelected: value.searchedText,
      options: [],
      error: updatedError,
      redBorder: false
    });
    if (value.searchedText === "") {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          defaultSelected: {
            error: true,
            message: "This field is required."
          }
        },
        redBorder: true
      }));
      this.setState(
        {
          userID: null
        },
        () => {
          if (isValidArray(bucketMilestoneCOS)) {
            bucketMilestoneCOS.map(bucket => {
              bucket.milestoneTableDataCOS.map(table => {
                table.phaseProponent = {};
                table.phaseProponentId = get(userInfo, "id", null);
                table.phaseProponent.id = get(userInfo, "id", null);
                table.phaseProponent.name = get(userInfo, "name", null);
              });
            });
          }
        }
      );
    }
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(async () => {
      const resp = await getAutoCompleteListAction(
        undefined,
        value.searchedText
      );
      if (resp) {
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            options: get(resp, "data"),
            autoSuggestApiLoading: STATUS.SUCCESS,
            userValidateError: false
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            options: [],
            userValidateError: true,
            autoSuggestApiLoading: STATUS.SUCCESS
          });
        }
      }
    }, 1000);
    this.autoSuggestApi();
  };
  onAutoSuggestChangeUsers = value => {
    const { bucketMilestoneCOS, error } = this.state;
    const userInfo = getLocalstorage("user");
    const updatedError = { ...error };
    delete updatedError["defaultSelected"];
    this.setState({
      autoSuggestApiLoading: STATUS.LOADING,
      defaultSelected: value.searchedText,
      options: [],
      error: updatedError,
      redBorder: false
    });
    if (value.searchedText === "") {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          defaultSelected: {
            error: true,
            message: "This field is required."
          }
        },
        redBorder: true
      }));
      this.setState(
        {
          userID: null
        },
        () => {
          if (isValidArray(bucketMilestoneCOS)) {
            bucketMilestoneCOS.map(bucket => {
              bucket.milestoneTableDataCOS.map(table => {
                table.phaseProponent = {};
                table.phaseProponentId = get(userInfo, "id", null);
                table.phaseProponent.id = get(userInfo, "id", null);
                table.phaseProponent.name = get(userInfo, "name", null);
              });
            });
          }
        }
      );
    }
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(async () => {
      const resp = await getAutoCompleteListUserAction(
        undefined,
        value.searchedText
      );
      if (resp) {
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            options: get(resp, "data"),
            autoSuggestApiLoading: STATUS.SUCCESS,
            userValidateError: false
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            options: [],
            autoSuggestApiLoading: STATUS.SUCCESS,
            userValidateError: true
          });
        }
      }
    }, 1000);
    this.autoSuggestApi();
  };

  onOptionClick = value => {
    const userInfo = getLocalstorage("user");
    const { bucketMilestoneCOS, error, defaultSelected } = this.state;
    const updatedError = { ...error };
    delete updatedError["defaultSelected"];
    this.setState(
      {
        userID: value,
        options: [],
        dataUnsaved: true,
        defaultSelected: `${value.name} (${value.userID})`,
        error: updatedError,
        redBorder: false,
        userValidateError: false
      },
      () => {
        this.proponentBlur(defaultSelected);
        if (isValidArray(bucketMilestoneCOS)) {
          bucketMilestoneCOS.map(bucket => {
            bucket.milestoneTableDataCOS.map(table => {
              table.phaseProponent = {};
              table.phaseProponentId = value.id || get(userInfo, "id", null);
              table.phaseProponent.id = value.id || get(userInfo, "id", null);
              table.phaseProponent.name =
                value.name || get(userInfo, "name", null);
            });
          });
        }
      }
    );
  };
  onOptionClickForStatePMG = value => {
    const userInfo = getLocalstorage("user");
    const { bucketMilestoneCOS, error, defaultSelected } = this.state;
    const updatedError = { ...error };
    delete updatedError["defaultSelected"];
    this.setState(
      {
        userID: value,
        options: [],
        dataUnsaved: true,
        defaultSelected: `${value.name} (${value.organization})`,
        error: updatedError,
        redBorder: false,
        userValidateError: false
      },
      () => {
        this.proponentBlur(defaultSelected);
        if (isValidArray(bucketMilestoneCOS)) {
          bucketMilestoneCOS.map(bucket => {
            bucket.milestoneTableDataCOS.map(table => {
              table.phaseProponent = {};
              table.phaseProponentId = value.id || get(userInfo, "id", null);
              table.phaseProponent.id = value.id || get(userInfo, "id", null);
              table.phaseProponent.name =
                value.name || get(userInfo, "name", null);
            });
          });
        }
      }
    );
  };
  getSponsoringStateDepartmentList = async groupId => {
    // const resp = await getDistrictList(undefined, groupId);
    const resp = await request(
      getStateDistrictAndDepartmentCreateProject(groupId)
    );
    if (resp) {
      const { data, status } = resp;
      if (status && isValidArray(get(data, "data"))) {
        this.setState({
          districtList: get(data, "data"),
          dataUnsaved: true
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">No data found of districts</p>,
          errorToastStyle
        );
      }
    }
  };

  onSelectState = async () => {
    const { projectCategoryId, groupId } = this.state;
    try {
      if (projectCategoryId === "STATE" && groupId) {
        this.getSponsoringStateDepartmentList(groupId);
      }
    } catch (err) {
      //console.log("Error of select district -", err.message);
    }
  };

  onSelectDepartment = async key => {
    const { projectCategoryId, groupId } = this.state;
    const isSponsoringDepartment = STATE_DEPARTMENT_KEYS.includes(groupId);
    try {
      if (
        projectCategoryId === "STATE" &&
        isSponsoringDepartment &&
        key === "groupId"
      ) {
        this.getSponsoringStateDepartmentList(groupId);
      }
    } catch (err) {
      //console.log("Error of select district -", err.message);
    }
  };
  onSelectSponsoringDept = async (key, value) => {
    try {
      const resp = await getDivisionList(undefined, value);
      const { data, status } = resp;
      if (status) {
        this.setState({
          divisionList: get(data, "data"),
          divisionId: null
          // divisionList: ["a", "b", "c"],
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">No data found of divisions</p>,
          errorToastStyle
        );
      }
    } catch (error) {
      //console.log("Error of select district -", error.message);
    }
  };

  onSelectCentral = async key => {
    const { projectCategoryId, groupId, iigProjectReferenceId } = this.state;
    try {
      if (
        (projectCategoryId === "CENTRAL" && groupId && key === "groupId") ||
        iigProjectReferenceId !== null
      ) {
        const resp = await getDistrictList(undefined, groupId);
        if (resp && iigProjectReferenceId === null) {
          const { data, status } = resp;
          if (status) {
            this.setState({
              districtList: get(data, "data"),
              dataUnsaved: true,
              sponsoringDepartmentId: null,
              divisionList: [],
              divisionId: null
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">
                No data found of districts
              </p>,
              errorToastStyle
            );
          }
        } else {
          const { data, status } = resp;
          if (status) {
            this.setState({
              districtList: get(data, "data")
            });
          }
        }
      }
    } catch (err) {
      //console.log("Error of select district -", err.message);
    }
  };

  onSponsoringDepartmentSelect = async groupId => {
    try {
      const response = await getSectorBasedOnSponsoringDepartment(
        undefined,
        groupId
      );
      if (response) {
        const { data, status } = response;
        if (status && isValidArray(get(data, "data"))) {
          this.setState({
            uniqueSectorlist: get(data, "data")
          });
        } else {
          this.setState({
            uniqueSectorlist: {}
          });
        }
      }
    } catch (error) {
      //console.log("Error sending GroupId to the backend:", error.message);
    }
  };

  getDepartmentList = async id => {
    const { projectCategoryId } = this.state;
    try {
      if (projectCategoryId === "CENTRAL" && id) {
        const resp = await getDistrictList(undefined, id);
        if (resp) {
          const { data, status } = resp;
          if (status) {
            this.setState({
              districtList: get(data, "data"),
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">
                No data found of districts
              </p>,
              errorToastStyle
            );
          }
        }
      }
    } catch (err) {
      //console.log("Error of select district -", err.message);
    }
  };

  onSelectStatus = projectCompletionDTO => {
    this.setState({ projectstageerror: "" });
    if (
      projectCompletionDTO.status == "projectPhysicallyCompleted" ||
      projectCompletionDTO.status == "commissioned" ||
      projectCompletionDTO.status === "COMMISSIONED" ||
      projectCompletionDTO.status == "PHYSICALLY COMPLETED/CC UNDER ISSUE"
    ) {
      projectCompletionDTO.percentage = 100;
    }
    if (
      projectCompletionDTO.status == "projectPhysicallyCompleted" ||
      projectCompletionDTO.status == "PHYSICALLY COMPLETED/CC UNDER ISSUE"
    ) {
      this.setState({ revisedtargetfielddisplay: true });
    } else {
      this.setState({ revisedtargetfielddisplay: false });
    }
    this.setState(prevState => ({
      projectCompletionDTO,
      targetCompletionDate: null,
      dataUnsaved: true,
      error: {
        ...prevState.error,
        projectCompletionDTO: { error: false }
      }
    }));
  };

  onStateWisePhaseChange = index => {
    const {
      history,
      createProjectDispatch,
      clearProjectDataDispatch
    } = this.props;
    this.setState(prev => {
      const updated = { ...prev.updated };
      delete updated[index];
      return { updated };
    });
    const dataForPost = {
      ...modifyDataForPost({ ...this.state }),
      projectId: get(this.state, "projectId")
        ? get(this.state, "projectId")
        : get(this.state, "id"),
      projectStatus: "DRAFT"
    };

    clearProjectDataDispatch();
    this.setState(
      {
        isApiLoading: true
      },
      async () => {
        const response = await createProjectDispatch(undefined, dataForPost);
        let projectNameTitle = this.state.projectNameTitle;
        if (response) {
          const { message, status } = response;

          if (status) {
            this.setState({
              resetForm: false,
              isApiLoading: false
            });
          } else {
            toast.error(message);
          }
        }
      }
    );
  };

  onBucketChanges = (
    value,
    key,
    selectedBucketId,
    milestoneId,
    milestoneName,
    tableIndex,
    isTableChange
  ) => {
    let { bucketMilestoneCOS, userID } = this.state;
    let {
      openMilestoneEdit,
      deleteNewMilestoneAction,
      projectPPList,
      sponsoredByCategory
    } = this.props;
    let _bucketMilestoneCOS = JSON.parse(JSON.stringify(bucketMilestoneCOS));
    const lastBucket = _bucketMilestoneCOS[_bucketMilestoneCOS.length - 1];

    if (
      lastBucket &&
      lastBucket.bucketName === "Cabinet Milestone" &&
      key != "disableReason"
    ) {
      // Keep only the first object if there are multiple
      if (lastBucket.milestoneTableDataCOS.length > 1) {
        lastBucket.milestoneTableDataCOS = lastBucket.milestoneTableDataCOS.slice(
          0,
          1
        );
      }

      // Update phaseName
      lastBucket.milestoneTableDataCOS.forEach((item, index) => {
        if ("phaseName" in item) item.phaseName = null;
        if ("phaseOriginalCost" in item) item.phaseOriginalCost = null;
        if ("phaseRevisedCost" in item) item.phaseRevisedCost = null;
        if ("physicalPercentage" in item) item.physicalPercentage = null;
        if ("financialPercentage" in item) item.financialPercentage = null;
        if ("asOfDate" in item) item.asOfDate = null;
      });
    }
    let _selectedBucketId = selectedBucketId || value;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";

    if (key === "addphase") {
      _bucketMilestoneCOS &&
        _bucketMilestoneCOS.forEach(item => {
          let _newMilestonDataCOS = [];
          let _newMilestoneObj = {};
          let prevMilestoneTableDataCOS = item.milestoneTableDataCOS;
          let _milestones =
            this.props.getBucketsWithMilestonesBySectorData &&
            this.props.getBucketsWithMilestonesBySectorData.data.filter(
              x => x.bucket.id === item.bucketId
            );
          !!_milestones[0] &&
            !!_milestones[0].milestones &&
            _milestones[0].milestones.map(w => {
              if (w.predefined === true) {
                _newMilestoneObj = {
                  completed: false,
                  disabled: false,
                  milestone: {
                    id: w.id,
                    name: w.name,
                    predefined: w.predefined
                  }
                };
                if (!isUserPMG) {
                  _newMilestoneObj.editMilestonePermission = true;
                }
                _newMilestonDataCOS.push(_newMilestoneObj);
              }
            });

          const getPhaseName = i => {
            let _phaseName = "";
            _bucketMilestoneCOS.forEach(bucket => {
              let phaseName =
                bucket.milestoneTableDataCOS &&
                bucket.milestoneTableDataCOS.length &&
                bucket.milestoneTableDataCOS[i] &&
                bucket.milestoneTableDataCOS[i].phaseName;
              _phaseName = _phaseName === "" ? phaseName : _phaseName;
            });
            return _phaseName;
          };

          //Project Proponent
          const getProjectProponent = i => {
            let _phaseProponentId =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "id", null)) ||
              get(userID, "id", null) ||
              get(userInfo, "id", null);

            let _phaseProponent = {};
            _phaseProponent.id =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "id", null)) ||
              get(userID, "id", null) ||
              get(userInfo, "id", null);
            _phaseProponent.name =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "name", null)) ||
              get(userID, "name", null) ||
              get(userInfo, "name", null);

            _bucketMilestoneCOS.forEach(bucket => {
              let phaseProponentId =
                (bucket.milestoneTableDataCOS &&
                  bucket.milestoneTableDataCOS.length &&
                  bucket.milestoneTableDataCOS[i] &&
                  bucket.milestoneTableDataCOS[i].phaseProponentId) ||
                null;
              _phaseProponentId = phaseProponentId || _phaseProponentId;
            });
            return { _phaseProponentId, _phaseProponent };
          };

          let _length =
            prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.length;
          let obj = {
            milestoneDataCOS: [..._newMilestonDataCOS],
            phaseProponentId: getProjectProponent(_length)._phaseProponentId,
            phaseProponent: getProjectProponent(_length)._phaseProponent,
            milestoneTable: {
              name: `Phase (${integer_to_roman(_length + 1)})`
            },
            phaseName: getPhaseName(_length),
            tableIndex: _length
          };
          prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.push(obj);
          return item;
        });

      this.setState({
        bucketMilestoneCOS: _bucketMilestoneCOS
      });
    }

    if (key === "deletePhase") {
      let updated =
        _bucketMilestoneCOS &&
        _bucketMilestoneCOS.map(item => {
          let prevMilestoneTableDataCOS = [...item.milestoneTableDataCOS];
          let remainingPhases = prevMilestoneTableDataCOS.slice(value + 1);
          prevMilestoneTableDataCOS.splice(value);
          let updatedMilestoneTables = remainingPhases.map(rp => {
            rp.milestoneTable.name = `Phase (${integer_to_roman(
              rp.tableIndex
            )})`;
            rp.tableIndex--;
            return rp;
          });
          let newMilestoneTableDataCOS = prevMilestoneTableDataCOS.concat(
            updatedMilestoneTables
          );
          item.milestoneTableDataCOS = newMilestoneTableDataCOS;
          return item;
        });
      let _milestones =
        this.props.getBucketsWithMilestonesBySectorData &&
        this.props.getBucketsWithMilestonesBySectorData.data.filter(
          x => x.bucket.id === selectedBucketId
        );
      let getPhaseIndex =
        !!_milestones &&
        _milestones[0].milestones.findIndex(
          _item => _item.phaseIndex == tableIndex
        );
      if (
        !!_milestones &&
        _milestones[0].newMilestoneData.hasOwnProperty(tableIndex) &&
        _milestones[0].newMilestoneData[tableIndex].hasOwnProperty(0)
      ) {
        deleteNewMilestoneAction({
          milestoneID: _milestones[0].newMilestoneData[tableIndex][0].id,
          bucketID: selectedBucketId,
          phaseIndex: tableIndex,
          type: "phase"
        });
      }
      this.setState({ bucketMilestoneCOS: updated });
    }

    let bucketExists = !!(
      _bucketMilestoneCOS &&
      _bucketMilestoneCOS.length &&
      _bucketMilestoneCOS.find(item => item.bucketId === _selectedBucketId)
    );

    let selectedBucketObj = _bucketMilestoneCOS.find(
      item => item.bucketId === _selectedBucketId
    );

    let _milestoneTableDataCOS =
      (selectedBucketObj && selectedBucketObj.milestoneTableDataCOS) || [];

    const getPhaseName = i => {
      let _phaseName = "";
      _bucketMilestoneCOS.forEach(bucket => {
        let phaseName =
          (bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length &&
            bucket.milestoneTableDataCOS[i] &&
            bucket.milestoneTableDataCOS[i].phaseName) ||
          "";
        _phaseName = _phaseName === "" ? phaseName : _phaseName;
      });
      return _phaseName;
    };

    //Add Progress Percentages and As of date on Bucket enable
    const getProgressPercentage = i => {
      let _physicalPercentage = null;
      let _financialPercentage = null;
      let _asOfDate = null;
      _bucketMilestoneCOS.forEach(bucket => {
        let _selectedMilestoneTable =
          bucket.milestoneTableDataCOS &&
          bucket.milestoneTableDataCOS.length &&
          bucket.milestoneTableDataCOS[i] &&
          bucket.milestoneTableDataCOS[i];
        let physicalPercentage = get(
          _selectedMilestoneTable,
          "physicalPercentage",
          null
        );
        let financialPercentage = get(
          _selectedMilestoneTable,
          "financialPercentage",
          null
        );
        let asOfDate = get(_selectedMilestoneTable, "asOfDate", null);
        _physicalPercentage =
          _physicalPercentage === null
            ? physicalPercentage
            : _physicalPercentage;
        _financialPercentage =
          _financialPercentage === null
            ? financialPercentage
            : _financialPercentage;
        _asOfDate = _asOfDate === null ? asOfDate : _asOfDate;
      });
      return {
        _physicalPercentage,
        _financialPercentage,
        _asOfDate
      };
    };

    //Add phase cost fields (original and revised)
    const getPhaseCosts = i => {
      let _phaseOriginalCost = null;
      let _phaseRevisedCost = null;
      _bucketMilestoneCOS.forEach(bucket => {
        let _selectedMilestoneTable =
          bucket.milestoneTableDataCOS &&
          bucket.milestoneTableDataCOS.length &&
          bucket.milestoneTableDataCOS[i] &&
          bucket.milestoneTableDataCOS[i];
        let phaseOriginalCost = get(
          _selectedMilestoneTable,
          "phaseOriginalCost",
          null
        );
        let phaseRevisedCost = get(
          _selectedMilestoneTable,
          "phaseRevisedCost",
          null
        );
        _phaseOriginalCost =
          _phaseOriginalCost === null ? phaseOriginalCost : _phaseOriginalCost;

        _phaseRevisedCost =
          _phaseRevisedCost === null ? phaseRevisedCost : _phaseRevisedCost;
      });
      return {
        _phaseOriginalCost,
        _phaseRevisedCost
      };
    };

    //Project Proponent
    const getProjectProponent = i => {
      let _phaseProponentId =
        (isValidArray(projectPPList) && get(projectPPList[0], "id", null)) ||
        get(userID, "id", null) ||
        get(userInfo, "id", null);
      let _phaseProponent = {};
      _phaseProponent.id =
        (isValidArray(projectPPList) && get(projectPPList[0], "id", null)) ||
        get(userID, "id", null) ||
        get(userInfo, "id", null);
      _phaseProponent.name =
        (isValidArray(projectPPList) && get(projectPPList[0], "name", null)) ||
        get(userID, "name", null) ||
        get(userInfo, "name", null);
      _bucketMilestoneCOS.forEach(bucket => {
        let phaseProponentId =
          (bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length &&
            bucket.milestoneTableDataCOS[i] &&
            bucket.milestoneTableDataCOS[i].phaseProponentId) ||
          null;
        _phaseProponentId = phaseProponentId || _phaseProponentId;
      });
      return { _phaseProponentId, _phaseProponent };
    };

    if (key === "bucketId" || key === "disabled" || key === "disableReason") {
      const cabinetBucket = _bucketMilestoneCOS.find(
        item => item.bucketName === "Cabinet Milestone"
      );
      const cabinetBucketId = cabinetBucket ? cabinetBucket.bucketId : null;

      this.setState(prevState => ({
        cabinetBucketIds: [_selectedBucketId, cabinetBucketId].filter(
          (value, index, self) => value != null && self.indexOf(value) === index
        )
      }));

      let bucketObj = { bucketId: _selectedBucketId, completed: false };
      bucketObj.disableReason = key === "disableReason" && value;
      bucketObj.disabled = key === "disableReason" && !!value;
      let _draftedProject = getLocalstorage("draftedProject");
      !bucketExists && _bucketMilestoneCOS.push(bucketObj);
      let maxLength = 1;
      if ((_draftedProject || openMilestoneEdit) && !value) {
        _bucketMilestoneCOS.forEach(bucket => {
          maxLength =
            bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length > maxLength
              ? bucket.milestoneTableDataCOS.length
              : maxLength;
        });

        _bucketMilestoneCOS &&
          _bucketMilestoneCOS.forEach(item => {
            let _newMilestonDataCOS = [];
            let _newMilestoneObj = {};
            let prevMilestoneTableDataCOS = item.milestoneTableDataCOS;
            let _milestones =
              this.props.getBucketsWithMilestonesBySectorData &&
              this.props.getBucketsWithMilestonesBySectorData.data.filter(
                x => x.bucket.id === item.bucketId
              );
            !!_milestones[0] &&
              !!_milestones[0].milestones &&
              _milestones[0].milestones.map(w => {
                _newMilestoneObj = {
                  completed: false,
                  disabled: false,
                  milestone: {
                    id: w.id,
                    name: w.name,
                    predefined: w.predefined
                  }
                };
                _newMilestonDataCOS.push(_newMilestoneObj);
              });

            let _length =
              prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.length;

            for (let i = _length; i < maxLength; i++) {
              let obj = {
                milestoneDataCOS: [..._newMilestonDataCOS],
                milestoneTable: {
                  name: `Phase (${integer_to_roman(i + 1)})`,
                  predefined: true
                },
                phaseName: getPhaseName(i),
                phaseOriginalCost: getPhaseCosts(i)._phaseOriginalCost,
                phaseRevisedCost: getPhaseCosts(i)._phaseRevisedCost,
                physicalPercentage: getProgressPercentage(i)
                  ._physicalPercentage,
                financialPercentage: getProgressPercentage(i)
                  ._financialPercentage,
                asOfDate: getProgressPercentage(i)._asOfDate,
                phaseProponentId: getProjectProponent(i)._phaseProponentId,
                phaseProponent: getProjectProponent(i)._phaseProponent,
                tableIndex: i
              };
              prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.push(obj);
            }
            return item;
          });

        this.setState({
          bucketMilestoneCOS: _bucketMilestoneCOS
        });
      } else if ((_draftedProject || openMilestoneEdit) && value) {
        _milestoneTableDataCOS &&
          _milestoneTableDataCOS.length &&
          _milestoneTableDataCOS.forEach((item, i) => {
            item.phaseName = getPhaseName(i);
            item.phaseOriginalCost = getPhaseCosts(i)._phaseOriginalCost;
            item.phaseRevisedCost = getPhaseCosts(i)._phaseRevisedCost;
            item.physicalPercentage = getProgressPercentage(
              i
            )._physicalPercentage;
            item.financialPercentage = getProgressPercentage(
              i
            )._financialPercentage;
            item.asOfDate = getProgressPercentage(i)._asOfDate;
            item.phaseProponentId = getProjectProponent(i)._phaseProponentId;
            item.phaseProponent = getProjectProponent(i)._phaseProponent;
          });
      }
    }

    let tableExists = !!(
      isTableChange &&
      _milestoneTableDataCOS &&
      _milestoneTableDataCOS.length &&
      _milestoneTableDataCOS.find(item => item.tableIndex === tableIndex)
    );

    let tableObj = {
      milestoneDataCOS: [],
      milestoneTable: {
        name: `Phase (${integer_to_roman(tableIndex + 1)})`
      },
      tableIndex: tableIndex
    };
    isTableChange && !tableExists && _milestoneTableDataCOS.push(tableObj);

    let selectedTableObj =
      isTableChange &&
      _milestoneTableDataCOS.find(item => item.tableIndex === tableIndex);

    let milestoneDataCOS = selectedTableObj
      ? selectedTableObj.milestoneDataCOS
      : [];

    let _milestoneObj = {
      disabled: false,
      completed: false,
      milestone: {
        id: milestoneId,
        name: milestoneName
      }
    };

    if (key === "phaseName") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseName = value;
        }
        return item;
      });
    }

    if (key === "physicalProgress") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data && +value <= 100) {
          data.physicalPercentage = !!value ? +value : null;
          if (!data.physicalPercentage && !data.financialPercentage) {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "financialProgress") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data && +value <= 100) {
          data.financialPercentage = !!value ? +value : null;
          if (!data.financialPercentage && !data.physicalPercentage) {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "asOfDate") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          if (!isNaN(moment(value).valueOf())) {
            data.asOfDate = moment(value).valueOf();
          } else {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "phaseOriginalCost") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseOriginalCost = !!value ? +value : null;
        }
        return item;
      });
    }

    if (key === "phaseRevisedCost") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseRevisedCost = !!value ? +value : null;
        }
        return item;
      });
    }

    if (key === "projectProponent") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseProponentId = !!value
            ? +value.id
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "id", null)
            : get(userInfo, "id", null);
          data.phaseProponent = {};
          data.phaseProponent.id = !!value
            ? +value.id
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "id", null)
            : get(userInfo, "id", null);
          data.phaseProponent.name = !!value
            ? +value.name
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "name", null)
            : get(userInfo, "name", null);
        }
        return item;
      });
    }

    if (key === "completeStatus" && selectedBucketObj) {
      selectedBucketObj.completed = !!(value === "completed");
      if (value === "completed") {
        let getAllDates = _getMinMaxDates(selectedBucketObj);
        const {
          minOriginalScheduledStart,
          minrevisedScheduledStart,
          maxOriginalScheduledFinish,
          maxRevisedScheduledFinish
        } = getAllDates;
        selectedBucketObj.originalScheduledStartDate =
          minOriginalScheduledStart || null;
        selectedBucketObj.revisedScheduledStartDate =
          minrevisedScheduledStart || null;
        selectedBucketObj.originalScheduledFinishDate =
          maxOriginalScheduledFinish || null;
        selectedBucketObj.revisedScheduledFinishDate =
          maxRevisedScheduledFinish || null;
      }
      for (let i = 0; i < selectedBucketObj.milestoneTableDataCOS.length; i++) {
        for (
          let j = 0;
          j <
          selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS.length;
          j++
        ) {
          let currentMilestone =
            selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS[j];
          if (value === "completed" && !currentMilestone.disabled) {
            currentMilestone.completed = true;
          } else {
            currentMilestone.completed = false;
            if (value === "notCompleted" && !isUserPMG) {
              if (
                selectedBucketObj.editBucketPermission !== false &&
                currentMilestone.editMilestonePermission !== false &&
                (!currentMilestone.originalScheduledStartDate ||
                  !currentMilestone.originalScheduledFinishDate)
              ) {
                currentMilestone.editMilestonePermission = true;
              }
            }
          }
        }
      }
    }

    if (key === "disabled" && selectedBucketObj) {
      selectedBucketObj.disabled = value;
    }

    if (key === "disableReason") {
      selectedBucketObj.disableReason = value;
      selectedBucketObj.disabled = !!value;
      if (!value && !isUserPMG) {
        selectedBucketObj.editBucketPermission = true;
      } else {
        selectedBucketObj.editBucketPermission = false;
      }
    }

    if (
      key === "originalScheduledFinishDate" ||
      key === "originalScheduledStartDate" ||
      key === "revisedScheduledFinishDate" ||
      key === "revisedScheduledStartDate"
    ) {
      selectedBucketObj[key] = moment(value).valueOf();
    }

    if (
      key === "originalCost" ||
      key === "revisedCost" ||
      key === "stateCost" ||
      key === "centralCost"
    ) {
      selectedBucketObj[key] = numberWithDecimal(value);
    }

    if (key === "originalArea" || key === "revisedArea") {
      selectedBucketObj[key] = numberWithDecimal(value);
    }

    if (key === "bucketDelayReason") {
      selectedBucketObj[key] = value;
    }

    if (key === "dep_type") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (
          value === "INDEPENDENT" &&
          updatedMilestoneDataCOS[checkMilestoneIndex].hasOwnProperty(
            "dependentOnId"
          )
        ) {
          updatedMilestoneDataCOS[checkMilestoneIndex].dependencyType = value;
          delete updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnId;
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].dependencyType = value;
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.dependencyType = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "dep_on") {
      let updatedMilestoneDataCOS;
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnId = parseInt(
          value.id
        );
        updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnName =
          value.name;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.dependentOnId = parseInt(value.id);
        _milestoneObj.dependentOnName = value.name;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "startOriginal") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .originalScheduledStartDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].originalScheduledStartDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.originalScheduledStartDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "startRevised") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .revisedScheduledStartDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].revisedScheduledStartDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.revisedScheduledStartDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "finishOriginal") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .originalScheduledFinishDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].originalScheduledFinishDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.originalScheduledFinishDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "finishRevised") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .revisedScheduledFinishDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].revisedScheduledFinishDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.revisedScheduledFinishDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "checkMark") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (!value) {
          updatedMilestoneDataCOS[checkMilestoneIndex].completed = value;
          if (
            Object.keys(updatedMilestoneDataCOS[checkMilestoneIndex]).length <=
            1
          ) {
            updatedMilestoneDataCOS.splice(checkMilestoneIndex, 1);
          }
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].completed = value;
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.completed = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "authority") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[
          checkMilestoneIndex
        ].responsibleAuthorityId = parseInt(value.id);
        updatedMilestoneDataCOS[checkMilestoneIndex].responsibleAuthorityName =
          value.name;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.responsibleAuthorityId = parseInt(value.id);
        _milestoneObj.responsibleAuthorityName = value.name;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "addReason") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[checkMilestoneIndex].reasonForDelay =
          value.reason;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.reasonForDelay = value.reason;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "action") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms && ms.milestone && ms.milestone.id === milestoneId
      );
      let selectedBI = _bucketMilestoneCOS.findIndex(
        bk => bk.bucketId === _selectedBucketId
      );
      let selectedTableData =
        !!_bucketMilestoneCOS &&
        !!_bucketMilestoneCOS[selectedBI] &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
        _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
      let updatedMilestoneDataCOS;

      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (!value.isDisabled) {
          updatedMilestoneDataCOS[checkMilestoneIndex].disabled =
            value.isDisabled;
          if (!isUserPMG) {
            let originalScheduledStartDateExists = !!updatedMilestoneDataCOS[
              checkMilestoneIndex
            ].originalScheduledStartDate;
            let originalScheduledFinishDateExists = !!updatedMilestoneDataCOS[
              checkMilestoneIndex
            ].originalScheduledFinishDate;
            if (
              !originalScheduledStartDateExists &&
              !originalScheduledFinishDateExists
            ) {
              updatedMilestoneDataCOS[
                checkMilestoneIndex
              ].editMilestonePermission = true;
            }
          }
          delete updatedMilestoneDataCOS[checkMilestoneIndex].disableReason;
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].disabled =
            value.isDisabled;
          updatedMilestoneDataCOS[checkMilestoneIndex].disableReason =
            value.reason;

          selectedTableData.milestoneDataCOS.find(item => {
            if (item.dependentOnId === milestoneId) {
              item.dependentOnId = null;
              item.dependentOnName = null;
              item.dependentOn = null;
            }
          });
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.disabled = value.isDisabled;
        _milestoneObj.disableReason = value.reason;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        selectedTableData.milestoneDataCOS.find(item => {
          if (item.dependentOnId === milestoneId) {
            item.dependentOnId = null;
            item.dependentOnName = null;
            item.dependentOn = null;
          }
        });
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    // if (key === "deleteRow") {
    //   if (milestoneId != null) {
    //     let selectedBI = _bucketMilestoneCOS.findIndex(
    //       bk => bk.bucketId === _selectedBucketId
    //     );
    //     let selectedTableData =
    //       !!_bucketMilestoneCOS &&
    //       !!_bucketMilestoneCOS[selectedBI] &&
    //       !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
    //       _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
    //     let updatedMilestoneDataCOS = [...selectedTableData.milestoneDataCOS];
    //     let _selectedMilestoneID = updatedMilestoneDataCOS.findIndex(
    //       bk => bk.milestone.id === milestoneId
    //     );
    //     let deletedMilestone = updatedMilestoneDataCOS.splice(
    //       _selectedMilestoneID,
    //       1
    //     );
    //     selectedTableData.milestoneDataCOS.find(item => {
    //       if (item.dependentOnId === deletedMilestone[0].milestone.id) {
    //         item.dependentOnId = null;
    //         item.dependentOnName = null;
    //         item.dependentOn = null;
    //       }
    //     });
    //     selectedTableData.milestoneDataCOS = updatedMilestoneDataCOS;
    //   }
    // }
    if (key === "deleteRow") {
      if (milestoneId != null) {
        const selectedBI = _bucketMilestoneCOS.findIndex(
          bk => bk.bucketId === _selectedBucketId
        );
        const selectedBucket = _bucketMilestoneCOS[selectedBI];
        const tables =
          (selectedBucket && selectedBucket.milestoneTableDataCOS) || [];

        // Find the phase by tableIndex first, fall back to array position
        const selectedTableData =
          tables.find(t => t.tableIndex === tableIndex) || tables[tableIndex];

        if (
          selectedTableData &&
          Array.isArray(selectedTableData.milestoneDataCOS)
        ) {
          const updatedMilestoneDataCOS = [
            ...selectedTableData.milestoneDataCOS
          ];

          // Compare as numbers so "5631" and 5631 both match
          const _selectedMilestoneIdx = updatedMilestoneDataCOS.findIndex(
            bk =>
              bk &&
              bk.milestone &&
              Number(bk.milestone.id) === Number(milestoneId)
          );

          // IMPORTANT: -1 means "not found". Never splice in that case,
          // because splice(-1, 1) removes the LAST record.
          if (_selectedMilestoneIdx !== -1) {
            const deletedMilestone = updatedMilestoneDataCOS.splice(
              _selectedMilestoneIdx,
              1
            )[0];

            // Clear dependencies that pointed to the deleted milestone
            updatedMilestoneDataCOS.forEach(item => {
              if (
                item.dependentOnId != null &&
                Number(item.dependentOnId) ===
                  Number(deletedMilestone.milestone.id)
              ) {
                item.dependentOnId = null;
                item.dependentOnName = null;
                item.dependentOn = null;
              }
            });

            selectedTableData.milestoneDataCOS = updatedMilestoneDataCOS;
          }
          // else: the row is blank/UI-only and has no saved data in this phase,
          // so there is nothing in state to remove
        }
      }
    }
    if (key === "addRow") {
      let selectedBI = _bucketMilestoneCOS.findIndex(
        bk => bk.bucketId === _selectedBucketId
      );
      let selectedMilestoneTableData =
        !!_bucketMilestoneCOS &&
        !!_bucketMilestoneCOS[selectedBI] &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex] &&
        _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
      let updatedMilestoneDataCOS = [
        ...selectedMilestoneTableData.milestoneDataCOS
      ];
      let _newMilestoneObj = {
        completed: false,
        disabled: false,
        milestone: {
          id: milestoneId,
          name: milestoneName
        }
      };
      if (!isUserPMG) {
        _newMilestoneObj.editMilestonePermission = true;
      }
      updatedMilestoneDataCOS.push(_newMilestoneObj);
      selectedMilestoneTableData.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "otherResponsibleAuthority") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[
          checkMilestoneIndex
        ].otherResponsibleAuthority = value;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.otherResponsibleAuthority = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (selectedBucketObj) {
      selectedBucketObj.milestoneTableDataCOS = _milestoneTableDataCOS;
      if (!selectedBucketObj.disabled) delete selectedBucketObj.disableReason;
      if (selectedBucketObj.disabled)
        if (!selectedBucketObj.completed) {
          selectedBucketObj.originalScheduledFinishDate = null;
          selectedBucketObj.originalScheduledStartDate = null;
          selectedBucketObj.revisedScheduledFinishDate = null;
          selectedBucketObj.revisedScheduledStartDate = null;
          selectedBucketObj.originalCost = null;
          selectedBucketObj.revisedCost = null;
          selectedBucketObj.originalArea = null;
          selectedBucketObj.revisedArea = null;
          selectedBucketObj.bucketDelayReason = null;
        }
    }

    //Making all the milestones inside new phase as completed
    let selectedBucketTableLength =
      !isEmpty(selectedBucketObj) &&
      selectedBucketObj.milestoneTableDataCOS.length;
    if (key === "bucketId" && selectedBucketTableLength > 0) {
      for (let i = 0; i < selectedBucketTableLength; i++) {
        for (
          let j = 0;
          j <
          selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS.length;
          j++
        ) {
          let currentMilestone =
            selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS[j];
          if (selectedBucketObj.completed && !currentMilestone.disabled) {
            currentMilestone.completed = true;
          }
        }
      }
    }

    this.setState({
      bucketMilestoneCOS: _bucketMilestoneCOS,
      selectedBucketId: _selectedBucketId,
      dataUnsaved: true
    });
  };
  onBucketChangesCabinet = (
    value,
    key,
    selectedBucketId,
    milestoneId,
    milestoneName,
    tableIndex,
    isTableChange
  ) => {
    let { bucketMilestoneCOS, userID } = this.state;
    let {
      openMilestoneEdit,
      deleteNewMilestoneAction,
      projectPPList
    } = this.props;
    let _bucketMilestoneCOS = JSON.parse(JSON.stringify(bucketMilestoneCOS));
    // let _selectedBucketId = selectedBucketId || value;
    const lastBucket = _bucketMilestoneCOS[_bucketMilestoneCOS.length - 1];

    if (
      lastBucket &&
      lastBucket.bucketName === "Cabinet Milestone" &&
      key != "disableReason"
    ) {
      // Keep only the first object if there are multiple
      if (lastBucket.milestoneTableDataCOS.length > 1) {
        lastBucket.milestoneTableDataCOS = lastBucket.milestoneTableDataCOS.slice(
          0,
          1
        );
      }

      // Update phaseName
      lastBucket.milestoneTableDataCOS.forEach((item, index) => {
        if ("phaseName" in item) item.phaseName = null;
        if ("phaseOriginalCost" in item) item.phaseOriginalCost = null;
        if ("phaseRevisedCost" in item) item.phaseRevisedCost = null;
        if ("physicalPercentage" in item) item.physicalPercentage = null;
        if ("financialPercentage" in item) item.financialPercentage = null;
        if ("asOfDate" in item) item.asOfDate = null;
      });
    }
    // let _selectedBucketId = 8;
    const cabinetBucketMeta = _bucketMilestoneCOS.find(
      item => item.bucketName === "Cabinet Milestone"
    );
    let _selectedBucketId = cabinetBucketMeta
      ? cabinetBucketMeta.bucketId
      : null;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";

    if (key === "addphase") {
      _bucketMilestoneCOS &&
        _bucketMilestoneCOS.forEach(item => {
          let _newMilestonDataCOS = [];
          let _newMilestoneObj = {};
          let prevMilestoneTableDataCOS = item.milestoneTableDataCOS;
          let _milestones =
            this.props.getBucketsWithMilestonesBySectorData &&
            this.props.getBucketsWithMilestonesBySectorData.data.filter(
              x => x.bucket.id === item.bucketId
            );
          !!_milestones[0] &&
            !!_milestones[0].milestones &&
            _milestones[0].milestones.map(w => {
              if (w.predefined === true) {
                _newMilestoneObj = {
                  completed: false,
                  disabled: false,
                  milestone: {
                    id: w.id,
                    name: w.name,
                    predefined: w.predefined
                  }
                };
                if (!isUserPMG) {
                  _newMilestoneObj.editMilestonePermission = true;
                }
                _newMilestonDataCOS.push(_newMilestoneObj);
              }
            });

          const getPhaseName = i => {
            let _phaseName = "";
            _bucketMilestoneCOS.forEach(bucket => {
              let phaseName =
                bucket.milestoneTableDataCOS &&
                bucket.milestoneTableDataCOS.length &&
                bucket.milestoneTableDataCOS[i] &&
                bucket.milestoneTableDataCOS[i].phaseName;
              _phaseName = _phaseName === "" ? phaseName : _phaseName;
            });
            return _phaseName;
          };

          //Project Proponent
          const getProjectProponent = i => {
            let _phaseProponentId =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "id", null)) ||
              get(userID, "id", null) ||
              get(userInfo, "id", null);

            let _phaseProponent = {};
            _phaseProponent.id =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "id", null)) ||
              get(userID, "id", null) ||
              get(userInfo, "id", null);
            _phaseProponent.name =
              (isValidArray(projectPPList) &&
                get(projectPPList[0], "name", null)) ||
              get(userID, "name", null) ||
              get(userInfo, "name", null);

            _bucketMilestoneCOS.forEach(bucket => {
              let phaseProponentId =
                (bucket.milestoneTableDataCOS &&
                  bucket.milestoneTableDataCOS.length &&
                  bucket.milestoneTableDataCOS[i] &&
                  bucket.milestoneTableDataCOS[i].phaseProponentId) ||
                null;
              _phaseProponentId = phaseProponentId || _phaseProponentId;
            });
            return { _phaseProponentId, _phaseProponent };
          };

          let _length =
            prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.length;
          let obj = {
            milestoneDataCOS: [..._newMilestonDataCOS],
            phaseProponentId: getProjectProponent(_length)._phaseProponentId,
            phaseProponent: getProjectProponent(_length)._phaseProponent,
            milestoneTable: {
              name: `Phase (${integer_to_roman(_length + 1)})`
            },
            phaseName: getPhaseName(_length),
            tableIndex: _length
          };
          prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.push(obj);
          return item;
        });

      this.setState({
        bucketMilestoneCOS: _bucketMilestoneCOS
      });
    }

    if (key === "deletePhase") {
      let updated =
        _bucketMilestoneCOS &&
        _bucketMilestoneCOS.map(item => {
          let prevMilestoneTableDataCOS = [...item.milestoneTableDataCOS];
          let remainingPhases = prevMilestoneTableDataCOS.slice(value + 1);
          prevMilestoneTableDataCOS.splice(value);
          let updatedMilestoneTables = remainingPhases.map(rp => {
            rp.milestoneTable.name = `Phase (${integer_to_roman(
              rp.tableIndex
            )})`;
            rp.tableIndex--;
            return rp;
          });
          let newMilestoneTableDataCOS = prevMilestoneTableDataCOS.concat(
            updatedMilestoneTables
          );
          item.milestoneTableDataCOS = newMilestoneTableDataCOS;
          return item;
        });
      let _milestones =
        this.props.getBucketsWithMilestonesBySectorData &&
        this.props.getBucketsWithMilestonesBySectorData.data.filter(
          x => x.bucket.id === cabinetBucketMeta.bucketId
        );
      let getPhaseIndex =
        !!_milestones &&
        _milestones[0].milestones.findIndex(
          _item => _item.phaseIndex == tableIndex
        );
      if (
        !!_milestones &&
        _milestones[0].newMilestoneData.hasOwnProperty(tableIndex) &&
        _milestones[0].newMilestoneData[tableIndex].hasOwnProperty(0)
      ) {
        deleteNewMilestoneAction({
          milestoneID: _milestones[0].newMilestoneData[tableIndex][0].id,
          bucketID: cabinetBucketMeta.bucketId,
          phaseIndex: tableIndex,
          type: "phase"
        });
      }
      this.setState({ bucketMilestoneCOS: updated });
    }

    let bucketExists = !!(
      _bucketMilestoneCOS &&
      _bucketMilestoneCOS.length &&
      _bucketMilestoneCOS.find(item => item.bucketId === _selectedBucketId)
    );

    let selectedBucketObj = _bucketMilestoneCOS.find(
      item => item.bucketId === _selectedBucketId
    );

    let _milestoneTableDataCOS =
      (selectedBucketObj && selectedBucketObj.milestoneTableDataCOS) || [];

    const getPhaseName = i => {
      let _phaseName = "";
      _bucketMilestoneCOS.forEach(bucket => {
        let phaseName =
          (bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length &&
            bucket.milestoneTableDataCOS[i] &&
            bucket.milestoneTableDataCOS[i].phaseName) ||
          "";
        _phaseName = _phaseName === "" ? phaseName : _phaseName;
      });
      return _phaseName;
    };

    //Add Progress Percentages and As of date on Bucket enable
    const getProgressPercentage = i => {
      let _physicalPercentage = null;
      let _financialPercentage = null;
      let _asOfDate = null;
      _bucketMilestoneCOS.forEach(bucket => {
        let _selectedMilestoneTable =
          bucket.milestoneTableDataCOS &&
          bucket.milestoneTableDataCOS.length &&
          bucket.milestoneTableDataCOS[i] &&
          bucket.milestoneTableDataCOS[i];
        let physicalPercentage = get(
          _selectedMilestoneTable,
          "physicalPercentage",
          null
        );
        let financialPercentage = get(
          _selectedMilestoneTable,
          "financialPercentage",
          null
        );
        let asOfDate = get(_selectedMilestoneTable, "asOfDate", null);
        _physicalPercentage =
          _physicalPercentage === null
            ? physicalPercentage
            : _physicalPercentage;
        _financialPercentage =
          _financialPercentage === null
            ? financialPercentage
            : _financialPercentage;
        _asOfDate = _asOfDate === null ? asOfDate : _asOfDate;
      });
      return {
        _physicalPercentage,
        _financialPercentage,
        _asOfDate
      };
    };

    //Add phase cost fields (original and revised)
    const getPhaseCosts = i => {
      let _phaseOriginalCost = null;
      let _phaseRevisedCost = null;
      _bucketMilestoneCOS.forEach(bucket => {
        let _selectedMilestoneTable =
          bucket.milestoneTableDataCOS &&
          bucket.milestoneTableDataCOS.length &&
          bucket.milestoneTableDataCOS[i] &&
          bucket.milestoneTableDataCOS[i];
        let phaseOriginalCost = get(
          _selectedMilestoneTable,
          "phaseOriginalCost",
          null
        );
        let phaseRevisedCost = get(
          _selectedMilestoneTable,
          "phaseRevisedCost",
          null
        );
        _phaseOriginalCost =
          _phaseOriginalCost === null ? phaseOriginalCost : _phaseOriginalCost;

        _phaseRevisedCost =
          _phaseRevisedCost === null ? phaseRevisedCost : _phaseRevisedCost;
      });
      return {
        _phaseOriginalCost,
        _phaseRevisedCost
      };
    };
    //Project Proponent
    const getProjectProponent = i => {
      let _phaseProponentId =
        (isValidArray(projectPPList) && get(projectPPList[0], "id", null)) ||
        get(userID, "id", null) ||
        get(userInfo, "id", null);

      let _phaseProponent = {};
      _phaseProponent.id =
        (isValidArray(projectPPList) && get(projectPPList[0], "id", null)) ||
        get(userID, "id", null) ||
        get(userInfo, "id", null);
      _phaseProponent.name =
        (isValidArray(projectPPList) && get(projectPPList[0], "name", null)) ||
        get(userID, "name", null) ||
        get(userInfo, "name", null);
      _bucketMilestoneCOS.forEach(bucket => {
        let phaseProponentId =
          (bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length &&
            bucket.milestoneTableDataCOS[i] &&
            bucket.milestoneTableDataCOS[i].phaseProponentId) ||
          null;
        _phaseProponentId = phaseProponentId || _phaseProponentId;
      });
      return { _phaseProponentId, _phaseProponent };
    };
    if (
      key === "bucketId" ||
      key === "disabled" ||
      key === "disableReason" ||
      key === "addRow"
    ) {
      let bucketObj = { bucketId: _selectedBucketId, completed: false };
      bucketObj.disableReason = key === "disableReason" && value;
      bucketObj.disabled = key === "disableReason" && !!value;
      let _draftedProject = getLocalstorage("draftedProject");
      !bucketExists && _bucketMilestoneCOS.push(bucketObj);
      let maxLength = 1;
      if ((_draftedProject || openMilestoneEdit) && !value) {
        _bucketMilestoneCOS.forEach(bucket => {
          maxLength =
            bucket.milestoneTableDataCOS &&
            bucket.milestoneTableDataCOS.length > maxLength
              ? bucket.milestoneTableDataCOS.length
              : maxLength;
        });

        _bucketMilestoneCOS &&
          _bucketMilestoneCOS.forEach(item => {
            let _newMilestonDataCOS = [];
            let _newMilestoneObj = {};
            let prevMilestoneTableDataCOS = item.milestoneTableDataCOS;
            let _milestones =
              this.props.getBucketsWithMilestonesBySectorData &&
              this.props.getBucketsWithMilestonesBySectorData.data.filter(
                x => x.bucket.id === item.bucketId
              );
            !!_milestones[0] &&
              !!_milestones[0].milestones &&
              _milestones[0].milestones.map(w => {
                _newMilestoneObj = {
                  completed: false,
                  disabled: false,
                  milestone: {
                    id: w.id,
                    name: w.name,
                    predefined: w.predefined
                  }
                };
                _newMilestonDataCOS.push(_newMilestoneObj);
              });

            let _length =
              prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.length;

            for (let i = _length; i < maxLength; i++) {
              let obj = {
                milestoneDataCOS: [..._newMilestonDataCOS],
                milestoneTable: {
                  name: `Phase (${integer_to_roman(i + 1)})`,
                  predefined: true
                },
                phaseName: getPhaseName(i),
                phaseOriginalCost: getPhaseCosts(i)._phaseOriginalCost,
                phaseRevisedCost: getPhaseCosts(i)._phaseRevisedCost,
                physicalPercentage: getProgressPercentage(i)
                  ._physicalPercentage,
                financialPercentage: getProgressPercentage(i)
                  ._financialPercentage,
                asOfDate: getProgressPercentage(i)._asOfDate,
                phaseProponentId: getProjectProponent(i)._phaseProponentId,
                phaseProponent: getProjectProponent(i)._phaseProponent,
                tableIndex: i
              };
              prevMilestoneTableDataCOS && prevMilestoneTableDataCOS.push(obj);
            }
            return item;
          });

        this.setState({
          bucketMilestoneCOS: _bucketMilestoneCOS
        });
      } else if ((_draftedProject || openMilestoneEdit) && value) {
        _milestoneTableDataCOS &&
          _milestoneTableDataCOS.length &&
          _milestoneTableDataCOS.forEach((item, i) => {
            item.phaseName = getPhaseName(i);
            item.phaseOriginalCost = getPhaseCosts(i)._phaseOriginalCost;
            item.phaseRevisedCost = getPhaseCosts(i)._phaseRevisedCost;
            item.physicalPercentage = getProgressPercentage(
              i
            )._physicalPercentage;
            item.financialPercentage = getProgressPercentage(
              i
            )._financialPercentage;
            item.asOfDate = getProgressPercentage(i)._asOfDate;
            item.phaseProponentId = getProjectProponent(i)._phaseProponentId;
            item.phaseProponent = getProjectProponent(i)._phaseProponent;
          });
      }
    }

    let tableExists = !!(
      isTableChange &&
      _milestoneTableDataCOS &&
      _milestoneTableDataCOS.length &&
      _milestoneTableDataCOS.find(item => item.tableIndex === tableIndex)
    );

    let tableObj = {
      milestoneDataCOS: [],
      milestoneTable: {
        name: `Phase (${integer_to_roman(tableIndex + 1)})`
      },
      tableIndex: tableIndex
    };
    isTableChange && !tableExists && _milestoneTableDataCOS.push(tableObj);

    let selectedTableObj =
      isTableChange &&
      _milestoneTableDataCOS.find(item => item.tableIndex === tableIndex);

    let milestoneDataCOS = selectedTableObj
      ? selectedTableObj.milestoneDataCOS
      : [];

    let _milestoneObj = {
      disabled: false,
      completed: false,
      milestone: {
        id: milestoneId,
        name: milestoneName
      }
    };

    if (key === "phaseName") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseName = value;
        }
        return item;
      });
    }

    if (key === "physicalProgress") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data && +value <= 100) {
          data.physicalPercentage = !!value ? +value : null;
          if (!data.physicalPercentage && !data.financialPercentage) {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "financialProgress") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data && +value <= 100) {
          data.financialPercentage = !!value ? +value : null;
          if (!data.financialPercentage && !data.physicalPercentage) {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "asOfDate") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          if (!isNaN(moment(value).valueOf())) {
            data.asOfDate = moment(value).valueOf();
          } else {
            data.asOfDate = null;
          }
        }
        return item;
      });
    }

    if (key === "phaseOriginalCost") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseOriginalCost = !!value ? +value : null;
        }
        return item;
      });
    }

    if (key === "phaseRevisedCost") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseRevisedCost = !!value ? +value : null;
        }
        return item;
      });
    }

    if (key === "projectProponent") {
      _bucketMilestoneCOS.map(item => {
        let data =
          item.milestoneTableDataCOS && item.milestoneTableDataCOS[tableIndex];
        if (!!data) {
          data.phaseProponentId = !!value
            ? +value.id
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "id", null)
            : get(userInfo, "id", null);
          data.phaseProponent = {};
          data.phaseProponent.id = !!value
            ? +value.id
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "id", null)
            : get(userInfo, "id", null);
          data.phaseProponent.name = !!value
            ? +value.name
            : isValidArray(projectPPList)
            ? get(projectPPList[0], "name", null)
            : get(userInfo, "name", null);
        }
        return item;
      });
    }

    if (key === "completeStatus" && selectedBucketObj) {
      selectedBucketObj.completed = !!(value === "completed");
      if (value === "completed") {
        let getAllDates = _getMinMaxDates(selectedBucketObj);
        const {
          minOriginalScheduledStart,
          minrevisedScheduledStart,
          maxOriginalScheduledFinish,
          maxRevisedScheduledFinish
        } = getAllDates;
        selectedBucketObj.originalScheduledStartDate =
          minOriginalScheduledStart || null;
        selectedBucketObj.revisedScheduledStartDate =
          minrevisedScheduledStart || null;
        selectedBucketObj.originalScheduledFinishDate =
          maxOriginalScheduledFinish || null;
        selectedBucketObj.revisedScheduledFinishDate =
          maxRevisedScheduledFinish || null;
      }
      for (let i = 0; i < selectedBucketObj.milestoneTableDataCOS.length; i++) {
        for (
          let j = 0;
          j <
          selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS.length;
          j++
        ) {
          let currentMilestone =
            selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS[j];
          if (value === "completed" && !currentMilestone.disabled) {
            currentMilestone.completed = true;
          } else {
            currentMilestone.completed = false;
            if (value === "notCompleted" && !isUserPMG) {
              if (
                selectedBucketObj.editBucketPermission !== false &&
                currentMilestone.editMilestonePermission !== false &&
                (!currentMilestone.originalScheduledStartDate ||
                  !currentMilestone.originalScheduledFinishDate)
              ) {
                currentMilestone.editMilestonePermission = true;
              }
            }
          }
        }
      }
    }

    if (key === "disabled" && selectedBucketObj) {
      selectedBucketObj.disabled = value;
    }

    if (key === "disableReason") {
      selectedBucketObj.disableReason = value;
      selectedBucketObj.disabled = !!value;
      if (!value && !isUserPMG) {
        selectedBucketObj.editBucketPermission = true;
      } else {
        selectedBucketObj.editBucketPermission = false;
      }
    }

    if (
      key === "originalScheduledFinishDate" ||
      key === "originalScheduledStartDate" ||
      key === "revisedScheduledFinishDate" ||
      key === "revisedScheduledStartDate"
    ) {
      selectedBucketObj[key] = moment(value).valueOf();
    }

    if (
      key === "originalCost" ||
      key === "revisedCost" ||
      key === "stateCost" ||
      key === "centralCost"
    ) {
      selectedBucketObj[key] = numberWithDecimal(value);
    }

    if (key === "originalArea" || key === "revisedArea") {
      selectedBucketObj[key] = numberWithDecimal(value);
    }

    if (key === "bucketDelayReason") {
      selectedBucketObj[key] = value;
    }

    if (key === "dep_type") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;

      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (
          value === "INDEPENDENT" &&
          updatedMilestoneDataCOS[checkMilestoneIndex].hasOwnProperty(
            "dependentOnId"
          )
        ) {
          updatedMilestoneDataCOS[checkMilestoneIndex].dependencyType = value;
          delete updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnId;
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].dependencyType = value;
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.dependencyType = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "dep_on") {
      let updatedMilestoneDataCOS;
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnId = parseInt(
          value.id
        );
        updatedMilestoneDataCOS[checkMilestoneIndex].dependentOnName =
          value.name;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.dependentOnId = parseInt(value.id);
        _milestoneObj.dependentOnName = value.name;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "startOriginal") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .originalScheduledStartDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].originalScheduledStartDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.originalScheduledStartDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "startRevised") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .revisedScheduledStartDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].revisedScheduledStartDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.revisedScheduledStartDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "finishOriginal") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .originalScheduledFinishDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].originalScheduledFinishDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.originalScheduledFinishDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "finishRevised") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (isNaN(moment(value).valueOf())) {
          delete updatedMilestoneDataCOS[checkMilestoneIndex]
            .revisedScheduledFinishDate;
        } else {
          updatedMilestoneDataCOS[
            checkMilestoneIndex
          ].revisedScheduledFinishDate = moment(value).valueOf();
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.revisedScheduledFinishDate = moment(value).valueOf();
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "checkMark") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (!value) {
          updatedMilestoneDataCOS[checkMilestoneIndex].completed = value;
          if (
            Object.keys(updatedMilestoneDataCOS[checkMilestoneIndex]).length <=
            1
          ) {
            updatedMilestoneDataCOS.splice(checkMilestoneIndex, 1);
          }
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].completed = value;
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.completed = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "authority") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[
          checkMilestoneIndex
        ].responsibleAuthorityId = parseInt(value.id);
        updatedMilestoneDataCOS[checkMilestoneIndex].responsibleAuthorityName =
          value.name;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.responsibleAuthorityId = parseInt(value.id);
        _milestoneObj.responsibleAuthorityName = value.name;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "addReason") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[checkMilestoneIndex].reasonForDelay =
          value.reason;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.reasonForDelay = value.reason;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "action") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms && ms.milestone && ms.milestone.id === milestoneId
      );
      let selectedBI = _bucketMilestoneCOS.findIndex(
        bk => bk.bucketId === _selectedBucketId
      );
      let selectedTableData =
        !!_bucketMilestoneCOS &&
        !!_bucketMilestoneCOS[selectedBI] &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
        _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
      let updatedMilestoneDataCOS;

      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        if (!value.isDisabled) {
          updatedMilestoneDataCOS[checkMilestoneIndex].disabled =
            value.isDisabled;
          if (!isUserPMG) {
            let originalScheduledStartDateExists = !!updatedMilestoneDataCOS[
              checkMilestoneIndex
            ].originalScheduledStartDate;
            let originalScheduledFinishDateExists = !!updatedMilestoneDataCOS[
              checkMilestoneIndex
            ].originalScheduledFinishDate;
            if (
              !originalScheduledStartDateExists &&
              !originalScheduledFinishDateExists
            ) {
              updatedMilestoneDataCOS[
                checkMilestoneIndex
              ].editMilestonePermission = true;
            }
          }
          delete updatedMilestoneDataCOS[checkMilestoneIndex].disableReason;
        } else {
          updatedMilestoneDataCOS[checkMilestoneIndex].disabled =
            value.isDisabled;
          updatedMilestoneDataCOS[checkMilestoneIndex].disableReason =
            value.reason;

          selectedTableData.milestoneDataCOS.find(item => {
            if (item.dependentOnId === milestoneId) {
              item.dependentOnId = null;
              item.dependentOnName = null;
              item.dependentOn = null;
            }
          });
        }
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.disabled = value.isDisabled;
        _milestoneObj.disableReason = value.reason;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        selectedTableData.milestoneDataCOS.find(item => {
          if (item.dependentOnId === milestoneId) {
            item.dependentOnId = null;
            item.dependentOnName = null;
            item.dependentOn = null;
          }
        });
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "deleteRow") {
      if (milestoneId != null) {
        let selectedBI = _bucketMilestoneCOS.findIndex(
          bk => bk.bucketId === _selectedBucketId
        );
        let selectedTableData =
          !!_bucketMilestoneCOS &&
          !!_bucketMilestoneCOS[selectedBI] &&
          !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
          _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
        let updatedMilestoneDataCOS = [...selectedTableData.milestoneDataCOS];
        let _selectedMilestoneID = updatedMilestoneDataCOS.findIndex(
          bk => bk.milestone.id === milestoneId
        );
        let deletedMilestone = updatedMilestoneDataCOS.splice(
          _selectedMilestoneID,
          1
        );
        selectedTableData.milestoneDataCOS.find(item => {
          if (item.dependentOnId === deletedMilestone[0].milestone.id) {
            item.dependentOnId = null;
            item.dependentOnName = null;
            item.dependentOn = null;
          }
        });
        selectedTableData.milestoneDataCOS = updatedMilestoneDataCOS;
      }
    }

    if (key === "addRow") {
      let selectedBI = _bucketMilestoneCOS.findIndex(
        bk => bk.bucketId === _selectedBucketId
      );
      let selectedMilestoneTableData =
        !!_bucketMilestoneCOS &&
        !!_bucketMilestoneCOS[selectedBI] &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS &&
        !!_bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex] &&
        _bucketMilestoneCOS[selectedBI].milestoneTableDataCOS[tableIndex];
      let updatedMilestoneDataCOS = [
        ...selectedMilestoneTableData.milestoneDataCOS
      ];
      let _newMilestoneObj = {
        completed: false,
        disabled: false,
        milestone: {
          id: milestoneId,
          name: milestoneName
        }
      };
      if (!isUserPMG) {
        _newMilestoneObj.editMilestonePermission = true;
      }
      updatedMilestoneDataCOS.push(_newMilestoneObj);
      selectedMilestoneTableData.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (key === "otherResponsibleAuthority") {
      let checkMilestoneIndex = milestoneDataCOS.findIndex(
        ms => ms.milestone.id === milestoneId
      );
      let updatedMilestoneDataCOS;
      if (checkMilestoneIndex !== -1) {
        updatedMilestoneDataCOS = [...milestoneDataCOS];
        updatedMilestoneDataCOS[
          checkMilestoneIndex
        ].otherResponsibleAuthority = value;
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      } else {
        _milestoneObj.otherResponsibleAuthority = value;
        updatedMilestoneDataCOS = [...milestoneDataCOS, _milestoneObj];
        this.setState({
          milestoneDataCOS: updatedMilestoneDataCOS
        });
      }
      selectedTableObj.milestoneDataCOS = updatedMilestoneDataCOS;
    }

    if (selectedBucketObj) {
      selectedBucketObj.milestoneTableDataCOS = _milestoneTableDataCOS;
      if (!selectedBucketObj.disabled) delete selectedBucketObj.disableReason;
      if (selectedBucketObj.disabled)
        if (!selectedBucketObj.completed) {
          selectedBucketObj.originalScheduledFinishDate = null;
          selectedBucketObj.originalScheduledStartDate = null;
          selectedBucketObj.revisedScheduledFinishDate = null;
          selectedBucketObj.revisedScheduledStartDate = null;
          selectedBucketObj.originalCost = null;
          selectedBucketObj.revisedCost = null;
          selectedBucketObj.originalArea = null;
          selectedBucketObj.revisedArea = null;
          selectedBucketObj.bucketDelayReason = null;
        }
    }

    //Making all the milestones inside new phase as completed
    let selectedBucketTableLength =
      !isEmpty(selectedBucketObj) &&
      selectedBucketObj.milestoneTableDataCOS.length;
    if (key === "bucketId" && selectedBucketTableLength > 0) {
      for (let i = 0; i < selectedBucketTableLength; i++) {
        for (
          let j = 0;
          j <
          selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS.length;
          j++
        ) {
          let currentMilestone =
            selectedBucketObj.milestoneTableDataCOS[i].milestoneDataCOS[j];
          if (selectedBucketObj.completed && !currentMilestone.disabled) {
            currentMilestone.completed = true;
          }
        }
      }
    }

    if (key !== "deleteRow") {
      const cabinetMilestone = _bucketMilestoneCOS.find(
        item => item.bucketName === "Cabinet Milestone"
      );
      const hasMilestoneDataCOS =
        cabinetMilestone &&
        cabinetMilestone.milestoneTableDataCOS[0].milestoneDataCOS.length === 0;

      if (hasMilestoneDataCOS) {
        _bucketMilestoneCOS = _bucketMilestoneCOS.filter(
          item => item.bucketName !== "Cabinet Milestone"
        );
      }
    }
    this.setState({
      bucketMilestoneCOS: this.setCabinetMilestonePhaseIndex(
        _bucketMilestoneCOS
      ),
      selectedcabinetbucketId: _selectedBucketId,
      dataUnsaved: true
    });
  };
  handleTableOrder = (tableArr, source, dest, selectedTableIndex) => {
    const {
      selectedBucketId,
      bucketMilestoneCOS,
      selectedTableId
    } = this.state;
    const { getBucketsWithMilestonesBySectorData } = this.props;
    let allMilestones = [];
    let selectedBucketIdx = bucketMilestoneCOS.findIndex(
      item => item.bucketId === selectedBucketId
    );
    let selectedBucketObj = bucketMilestoneCOS.find(
      item => item.bucketId === selectedBucketId
    );
    let milestoneDataFromRedux = sortBy(
      getBucketsWithMilestonesBySectorData.data,
      "bucket.id"
    );
    let milestoneReduxIdx = milestoneDataFromRedux.findIndex(
      item => item.bucket.id === selectedBucketId
    );
    let oldOrder =
      milestoneDataFromRedux[milestoneReduxIdx].newMilestoneData[
        selectedTableIndex
      ];
    if (oldOrder) {
      oldOrder.splice(0, oldOrder.length, ...tableArr);
    }

    selectedBucketObj.milestoneTableDataCOS.map(item => {
      if (item.tableIndex != selectedTableIndex) {
        return;
      }
      allMilestones = item.milestoneDataCOS;
      let [selectedRow] = allMilestones.splice(source, 1);
      allMilestones.splice(dest, 0, selectedRow);
    });
    bucketMilestoneCOS[selectedBucketIdx] = selectedBucketObj;
    this.setState({
      bucketMilestoneCOS: bucketMilestoneCOS
    });
  };
  handleTableOrderCabinet = (tableArr, source, dest, selectedTableIndex) => {
    const {
      selectedBucketId,
      bucketMilestoneCOS,
      selectedTableId
    } = this.state;
    const { getBucketsWithMilestonesBySectorData } = this.props;
    let allMilestones = [];
    // let selectedBucketIdx = bucketMilestoneCOS.findIndex(
    //   item => item.bucketId === 8
    // );
    // let selectedBucketObj = bucketMilestoneCOS.find(
    //   item => item.bucketId === 8
    // );
    // Instead of bucketId === 8 everywhere, resolve it dynamically:
    const cabinetBucket = bucketMilestoneCOS.find(
      item => item.bucketName === "Cabinet Milestone"
    );
    const cabinetBucketId = cabinetBucket && cabinetBucket.bucketId;

    let selectedBucketIdx = bucketMilestoneCOS.findIndex(
      item => item.bucketId === cabinetBucketId
    );
    let selectedBucketObj = bucketMilestoneCOS.find(
      item => item.bucketId === cabinetBucketId
    );
    // same for milestoneDataFromRedux lookups using `item.bucket.id === cabinetBucketId`
    let milestoneDataFromRedux = sortBy(
      getBucketsWithMilestonesBySectorData.data,
      "bucket.id"
    );
    let milestoneReduxIdx = milestoneDataFromRedux.findIndex(
      item => item.bucket.id === cabinetBucketId
    );
    let oldOrder =
      milestoneDataFromRedux[milestoneReduxIdx].newMilestoneData[
        selectedTableIndex
      ];
    if (oldOrder) {
      oldOrder.splice(0, oldOrder.length, ...tableArr);
    }

    selectedBucketObj.milestoneTableDataCOS.map(item => {
      if (item.tableIndex != selectedTableIndex) {
        return;
      }
      allMilestones = item.milestoneDataCOS;
      let [selectedRow] = allMilestones.splice(source, 1);
      allMilestones.splice(dest, 0, selectedRow);
    });
    bucketMilestoneCOS[selectedBucketIdx] = selectedBucketObj;
    this.setState({
      bucketMilestoneCOS: bucketMilestoneCOS
    });
  };
  componentWillUnmount() {
    //console.log("success");
    let { previewClicked } = this.state;
    !previewClicked &&
      this.props.getBucketsWithMilestonesBySectorAction(null, true);
  }

  renderProjectBriefDescriptionField = () => {
    const {
      description,
      status,
      isIIGProjectEdit,
      iigProjectReferenceId,
      groupId,
      projectCreatedFrom,
      error: { description: descrErr }
    } = this.state;
    const isIIGDraft = status === "CRIP_DRAFT";
    const hasIIGProjectReferenceId = iigProjectReferenceId !== null;
    return (
      <Form.Group>
        <Form.Label data-test="label-brief-project-description">
          {projectFormLabel(
            groupId,
            "description",
            "Brief Project Description"
          )}
          <span className="required">*</span>
        </Form.Label>
        <div className="form-field">
          <Form.Control
            data-test="project-description"
            keyName="description"
            as="textarea"
            rows="3"
            placeholder="More about Project"
            className={`${
              /[\u0900-\u097F]/.test(description)
                ? "hindi-text-wrap-comment"
                : ""
            }`}
            onChange={e => {
              this.onChange(e.target.value, "description");
            }}
            onBlur={e => {
              this.onBlur(e.target.value, "description");
            }}
            value={description}
            disabled={
              isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
              // || projectCreatedFrom=="UP"
            }
            isInvalid={get(descrErr, "error")}
          />
          <Form.Control.Feedback type="invalid">
            {get(descrErr, "message")}
          </Form.Control.Feedback>
        </div>
      </Form.Group>
    );
  };

  renderProjectMapField = () => {
    const { isEdit } = this.props;
    const { error, status, groupId, projectCreatedFrom } = this.state;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    const isIIGDraft = status === "CRIP_DRAFT";
    const isUPproject = projectCreatedFrom == "UP";
    return (
      <Form.Group className="field-file multiple-attache-file">
        <Form.Label>
          <div data-test="label-upload-project-map">
            Upload project map
            {((!isEdit && !isIIGDraft) || (isEdit && !isUserPMG)) && (
              <span
                className="required"
                style={{
                  display:
                    groupId == 78 || isUPproject || groupId == 203
                      ? "none"
                      : null
                }}
              >
                *
              </span>
            )}
          </div>
          <p className="field-note">
            Supported image types: .png, .jpg, .jpeg
            <br />
            Max image size: 10MB
          </p>
        </Form.Label>
        <div
          className="d-flex flex-column align-items-start"
          data-test="input-file-wrapper"
        >
          {this.state.mapImageFiles &&
          isValidArray(this.state.mapImageFiles) &&
          this.state.mapImageFiles.length === 1 ? (
            <div className="project-map-file-wrapper uploaded-file-wrapper">
              {this.createProjectMapImageFilesTemplate()}
            </div>
          ) : (
            <Files
              className="add-files add-project-map-file"
              onChange={this.onMapImageFilesChange}
              onError={this.onMapImageFilesError}
              multiple={false}
              accepts={IMAGE_FORMATS}
              maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
              minFileSize={0}
              clickable
              ref={elem => {
                this.mapImageFiles = elem;
              }}
            >
              <div className="d-flex" data-test="upload-project-map">
                <Image src={IconPlus} alt="Plus Icon" />
                <div className="add-file-text ml-2" style={{ marginTop: 2.5 }}>
                  &nbsp;Add image
                </div>
              </div>
            </Files>
          )}
          {((!isEdit && !isIIGDraft) || (isEdit && !isUserPMG)) &&
          get(error, "mapImageFiles.error") ? (
            <div className="mt-2 text-danger">Project map is mandatory!</div>
          ) : (
            <></>
          )}
        </div>
      </Form.Group>
    );
  };

  renderIIGUserDetails() {
    const { iigPayload } = this.state;
    const { isEdit } = this.props;
    const targetDate = this.state.createdDate;
    const dateAfterCrip = new Date("2026-07-08").getTime();
    return (
      iigPayload !== null &&
      Object.values(iigPayload).length !== 0 && (
        <>
          <div className="fieldset-heading">
            <h2>
              {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"} User
              Details
            </h2>
          </div>
          <Form.Group className="form-group">
            <Form.Label data-test="label-user-id">User ID</Form.Label>
            <div className="form-field">
              <Form.Control
                data-test="user-id"
                type="text"
                value={iigPayload.userMeta.userID}
                disabled={true}
              />
            </div>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>
              <span data-test="label-user-name">User Name</span>
            </Form.Label>
            <div className="form-field">
              <Form.Control
                data-test="user-name"
                type="text"
                value={iigPayload.userMeta.userName}
                disabled={true}
              />
            </div>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label data-test="label-contact-details">
              Contact Details
            </Form.Label>
            <div className="form-field">
              <div class="popup-wrapper iig-user iig-user-email">
                <Form.Label data-test="label-email">Email</Form.Label>
                <Form.Control
                  type="text"
                  value={iigPayload.userMeta.email}
                  disabled={true}
                />
              </div>
              <div class="popup-wrapper iig-user iig-user-phone">
                <Form.Label data-test="label-phone">Phone</Form.Label>
                <Form.Control
                  data-test="phone"
                  type="text"
                  value={iigPayload.userMeta.phone}
                  disabled={true}
                />
              </div>
            </div>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label data-test="label-designation">Designation</Form.Label>
            <div className="form-field">
              <Form.Control
                type="text"
                value={iigPayload.userMeta.designation}
                disabled={true}
              />
            </div>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label data-test="label-organization">Organization</Form.Label>
            <div className="form-field">
              <Form.Control
                data-test="organization"
                type="text"
                value={iigPayload.userMeta.organization}
                disabled={true}
              />
            </div>
          </Form.Group>
        </>
      )
    );
  }
  handleIfCommentNotFilled = e => {
    e.preventDefault();
    alert("Please fill the comment");
  };
  handleModalShowOnVerifyClick = async () => {
    this.setState({
      showModalForVerifyingProject: true
    });
  };
  handleRejectShow = async () => {
    this.setState({
      showModalForRejectingProject: true
    });
  };
  handleIIGDraftSavedSuccess = (showToast = true) => {
    const { history } = this.props;
    if (showToast) {
      toast.success(
        <p className="toast-text-alignment">
          Project draft saved successfully!
        </p>,
        successToastStyle
      );
    }
    this.setState(
      {
        dataUnsaved: false
      },
      () => {
        history.push({
          pathname: PATHS.PROJECT_LIST
        });
      }
    );
  };
  verifyIIGDraft = async (attachmentFiles = []) => {
    let { comment } = this.state;
    const response = await changeProjectStatus(undefined, {
      comment: comment,
      projectId: get(this.state, "projectId"),
      projectStatus: "VERIFIED",
      files: attachmentFiles,
      terminatedDate: null
    });
    if (response) {
      const { data, status } = response;
      if (status) {
        this.setState({
          projectStatus: "VERIFIED"
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">{data.message}</p>,
          errorToastStyle
        );
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };
  onRejectAction = async (attachmentFiles = []) => {
    let { comment } = this.state;
    const response = await changeProjectStatus(undefined, {
      comment: comment,
      projectId: get(this.state, "projectId"),
      projectStatus: "REJECTED",
      files: attachmentFiles,
      terminatedDate: null
    });
    if (response) {
      const { data, status } = response;
      if (status) {
        toast.success(
          <p className="toast-text-alignment">Project rejected.</p>,
          successToastStyle
        );
        this.setState({
          projectStatus: "REJECTED"
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">{data.message}</p>,
          errorToastStyle
        );
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };
  onClickOfVerifyButton = async (attachmentFiles = []) => {
    const { history } = this.props;
    const { comment, status } = this.state;
    if (comment === "") {
      this.handleCommentValidation(true);
    } else {
      this.handleCommentValidation(false);
      await this.onEditSubmit(status, false);
      await this.verifyIIGDraft(attachmentFiles);
      toast.success(
        <p className="toast-text-alignment">Project submitted successfully!</p>,
        successToastStyle
      );
      this.setState(
        {
          dataUnsaved: false
        },
        () => {
          history.push({
            pathname: PATHS.PROJECT_LIST
          });
        }
      );
    }
  };
  onClickOfRejectButton = (attachmentFiles = []) => {
    const { history } = this.props;
    const { comment } = this.state;
    if (comment === "") {
      this.handleCommentValidation(true);
    } else {
      this.handleCommentValidation(false);
      this.onRejectAction(attachmentFiles);
      this.setState(
        {
          dataUnsaved: false
        },
        () => {
          history.push({
            pathname: PATHS.PROJECT_LIST
          });
        }
      );
    }
  };
  handleCommentValidation = isInvalid => {
    const { error } = this.state;
    this.setState({
      error: {
        ...error,
        comment: {
          error: isInvalid,
          message: isInvalid ? "Comment is required" : null
        }
      }
    });
  };
  commentValueChange = (value, name) => {
    this.setState({ [name]: value });
  };
  loadModalForVerifiedAction = () => {
    let { comment, error, showModalForVerifyingProject } = this.state;
    return (
      <ModalVerifyIIGProject
        show={showModalForVerifyingProject}
        onHide={() => {
          this.setState({
            showModalForVerifyingProject: false
          });
        }}
        comment={comment}
        onCommentChange={this.commentValueChange}
        onVerify={this.onClickOfVerifyButton}
        error={error}
        createdDate={this.state.createdDate}
      />
    );
  };
  loadModalForRejectAction = () => {
    let { comment, error, showModalForRejectingProject } = this.state;
    return (
      <ModalRejectIIGProject
        show={showModalForRejectingProject}
        onHide={() => {
          this.setState({
            showModalForRejectingProject: false
          });
        }}
        comment={comment}
        onCommentChange={this.commentValueChange}
        onReject={this.onClickOfRejectButton}
        error={error}
        createdDate={this.state.createdDate}
      />
    );
  };
  // Returns true if a single milestone row has any meaningful data entered
  // on it — dates, authority, dependency, reason, completed, or a real
  // disable reason.
  hasMilestoneEnteredData = milestone => {
    if (!milestone) return false;
    return (
      milestone.originalScheduledStartDate != null ||
      milestone.revisedScheduledStartDate != null ||
      milestone.originalScheduledFinishDate != null ||
      milestone.revisedScheduledFinishDate != null ||
      milestone.responsibleAuthorityId != null ||
      milestone.responsibleAuthorityName != null ||
      milestone.otherResponsibleAuthority != null ||
      milestone.dependencyType != null ||
      milestone.reasonForDelay != null ||
      milestone.dependentOnId != null ||
      milestone.dependentOnName != null ||
      milestone.completed === true ||
      (milestone.disabled === true && !!milestone.disableReason)
    );
  };

  // Checks if a Cabinet Milestone bucket is "empty" in the sense that
  // matters for the payload:
  //  - milestoneDataCOS is empty across all tables, OR
  //  - every milestone present is predefined AND untouched (no dates,
  //    authority, dependency, etc. filled in)
  // Custom (non-predefined) milestones always count as "has data" since
  // the user explicitly added them.
  // isCabinetBucketEmptyForPayload = cabinetBucket => {
  //   if (
  //     !cabinetBucket ||
  //     !isValidArray(cabinetBucket.milestoneTableDataCOS)
  //   ) {
  //     return true;
  //   }

  //   let allMilestoneDataCOS = [];
  //   cabinetBucket.milestoneTableDataCOS.forEach(table => {
  //     if (isValidArray(table.milestoneDataCOS)) {
  //       allMilestoneDataCOS = allMilestoneDataCOS.concat(table.milestoneDataCOS);
  //     }
  //   });

  //   // no milestones at all -> empty
  //   if (allMilestoneDataCOS.length === 0) {
  //     return true;
  //   }

  //   // if any milestone is non-predefined, or is predefined but has data
  //   // entered, the bucket is NOT empty
  //   const hasRealData = allMilestoneDataCOS.some(milestone => {
  //     const isPredefined = get(milestone, "milestone.predefined") === true;
  //     if (!isPredefined) return true;
  //     return this.hasMilestoneEnteredData(milestone);
  //   });

  //   return !hasRealData;
  // };

  // Checks whether the Cabinet Milestone bucket has any milestone that
  // should be treated as "user has entered data":
  //  - predefined milestones (sectors 872/879 etc.) only count if the user
  //    actually filled something in on them
  //  - custom milestones (added via "Add Row") count simply by existing,
  //    since adding one is itself an explicit user action
  cabinetBucketHasData = item => {
    var milestoneDataCOS = [];

    if (
      item &&
      item.milestoneTableDataCOS &&
      Array.isArray(item.milestoneTableDataCOS)
    ) {
      item.milestoneTableDataCOS.forEach(function(table) {
        if (table.milestoneDataCOS && Array.isArray(table.milestoneDataCOS)) {
          milestoneDataCOS = milestoneDataCOS.concat(table.milestoneDataCOS);
        }
      });
    }

    return milestoneDataCOS.some(milestone => {
      const isPredefined = get(milestone, "milestone.predefined") === true;

      if (isPredefined) {
        return this.hasMilestoneEnteredData(milestone);
      }

      return true;
    });
  };

  // Strips untouched predefined milestones (id/name only, no data entered)
  // out of the Cabinet Milestone bucket so they never reach validation or
  // the outgoing payload. Custom milestones are always kept, since the user
  // explicitly added them and they must be validated as mandatory.
  stripEmptyPredefinedCabinetMilestones = bucketMilestoneCOS => {
    if (!isValidArray(bucketMilestoneCOS)) return bucketMilestoneCOS;

    return bucketMilestoneCOS.map(bucket => {
      if (bucket.bucketName !== "Cabinet Milestone") return bucket;
      if (!isValidArray(bucket.milestoneTableDataCOS)) return bucket;

      const updatedTables = bucket.milestoneTableDataCOS.map(table => {
        if (!isValidArray(table.milestoneDataCOS)) return table;

        const filteredMilestoneDataCOS = table.milestoneDataCOS.filter(
          milestone => {
            const isPredefined =
              get(milestone, "milestone.predefined") === true;

            // custom milestones are always kept
            if (!isPredefined) return true;

            // predefined milestones are only kept if the user touched them
            return this.hasMilestoneEnteredData(milestone);
          }
        );

        return { ...table, milestoneDataCOS: filteredMilestoneDataCOS };
      });

      return { ...bucket, milestoneTableDataCOS: updatedTables };
    });
  };
  // onUpadateOfMilestone = () => {
  //   const { displayCabinetMilestones, bucketMilestoneCOS } = this.state;
  //   const {
  //     _cost,
  //     _sectorId,
  //     displayCabinetMilestoneButton,
  //     sponsoredByCategory,
  //     _implementationMode
  //   } = this.props;

  //   const validateAndProceed = () => {
  //     const { bucketMilestoneCOS } = this.state;

  //     const cabinetBuckets = bucketMilestoneCOS.filter(
  //       item => item.bucketName === "Cabinet Milestone"
  //     );
  //     const pmgBuckets = bucketMilestoneCOS.filter(
  //       item => item.bucketName !== "Cabinet Milestone"
  //     );

  //     const isPmgValid = this.validateMilestones(pmgBuckets, false);

  //     const isCabinetValid = cabinetBuckets.length
  //       ? this.validateMilestones(cabinetBuckets, false)
  //       : true;

  //     const isValid = isPmgValid && isCabinetValid;

  //     this.setState(prevState => ({
  //       isMilestoneTableValidated: isValid,
  //       error: {
  //         ...prevState.error,
  //         milestoneMandatoryFields: {
  //           error: !isPmgValid,
  //           message: !isPmgValid ? "Mandatory fields are missing" : ""
  //         },
  //         cabinetMilestoneMandatoryFields: {
  //           error: !isCabinetValid,
  //           message: !isCabinetValid ? "Mandatory fields are missing" : ""
  //         }
  //       }
  //     }));

  //     if (isValid) {
  //       this.onMilestoneUpdate(PROJECT_STATUS.EDIT_MILESTONE);
  //     } else {
  //       toast.error(
  //         <p className="toast-text-alignment">Mandatory fields are missing</p>,
  //         errorToastStyle
  //       );
  //     }
  //   };

  //   if (sponsoredByCategory == "CENTRAL" && _implementationMode != "PRIVATE") {
  //     const updatedData1 = bucketMilestoneCOS.filter(
  //       item => item.bucketName === "Cabinet Milestone"
  //     );
  //     const filterData = bucketMilestoneCOS.filter(
  //       item => item.bucketName !== "Cabinet Milestone"
  //     );
  //     const cabinetFromData = filterData.every(item => item.disabled === true);

  //     const cabinetBucket = updatedData1[0];
  //     const hasCabinetData = this.hasCabinetMilestoneData(cabinetBucket);

  //     // If cost >= 1000 and sector is 872 or 879, never disable/remove the Cabinet Milestone bucket
  //     const preventCabinetDisable = _cost >= 1000;

  //     // FIX: an empty milestoneDataCOS array should only auto-remove the
  //     // Cabinet Milestone bucket when the user hasn't explicitly turned the
  //     // section on via displayCabinetMilestones(). If they've turned it on,
  //     // an empty bucket must be left in place and caught by validation
  //     // instead of being silently deleted.
  //     const shouldDisableCabinet =
  //       !preventCabinetDisable &&
  //       ((!hasCabinetData && !displayCabinetMilestones) ||
  //         (!displayCabinetMilestones && cabinetBucket.disabled == true) ||
  //         (_cost < 1000 &&
  //           !displayCabinetMilestones &&
  //           !displayCabinetMilestoneButton &&
  //           cabinetFromData &&
  //           cabinetBucket.disabled == false) ||
  //         (!displayCabinetMilestones &&
  //           (!isValidArray(
  //             cabinetBucket.milestoneTableDataCOS[0].milestoneDataCOS
  //           ) ||
  //             cabinetBucket.milestoneTableDataCOS[0].milestoneDataCOS.length ==
  //               0)));

  //     if (shouldDisableCabinet) {
  //       this.setState(
  //         prevState => ({
  //           bucketMilestoneCOS: prevState.bucketMilestoneCOS.filter(
  //             item => item.bucketName !== "Cabinet Milestone"
  //           )
  //         }),
  //         validateAndProceed
  //       );
  //     } else {
  //       validateAndProceed();
  //     }
  //   } else {
  //     validateAndProceed();
  //   }
  // };

  // Returns true if a single milestone row has any meaningful data entered
  // on it — dates, authority, dependency, reason, completed, or a real
  // disable reason.
  hasMilestoneEnteredData = milestone => {
    if (!milestone) return false;
    return (
      milestone.originalScheduledStartDate != null ||
      milestone.revisedScheduledStartDate != null ||
      milestone.originalScheduledFinishDate != null ||
      milestone.revisedScheduledFinishDate != null ||
      milestone.responsibleAuthorityId != null ||
      milestone.responsibleAuthorityName != null ||
      milestone.otherResponsibleAuthority != null ||
      milestone.dependencyType != null ||
      milestone.reasonForDelay != null ||
      milestone.dependentOnId != null ||
      milestone.dependentOnName != null ||
      milestone.completed === true ||
      (milestone.disabled === true && !!milestone.disableReason)
    );
  };

  // Checks if a Cabinet Milestone bucket is "empty" for payload purposes:
  //  - milestoneDataCOS is empty across all tables, OR
  //  - every milestone present is predefined AND untouched
  // Custom (non-predefined) milestones always count as "has data".
  isCabinetBucketEmptyForPayload = cabinetBucket => {
    if (!cabinetBucket || !isValidArray(cabinetBucket.milestoneTableDataCOS)) {
      return true;
    }

    let allMilestoneDataCOS = [];
    cabinetBucket.milestoneTableDataCOS.forEach(table => {
      if (isValidArray(table.milestoneDataCOS)) {
        allMilestoneDataCOS = allMilestoneDataCOS.concat(
          table.milestoneDataCOS
        );
      }
    });

    if (allMilestoneDataCOS.length === 0) {
      return true;
    }

    const hasRealData = allMilestoneDataCOS.some(milestone => {
      const isPredefined = get(milestone, "milestone.predefined") === true;
      if (!isPredefined) return true;
      return this.hasMilestoneEnteredData(milestone);
    });

    return !hasRealData;
  };
  onUpadateOfMilestone = () => {
    const { displayCabinetMilestones, bucketMilestoneCOS } = this.state;

    const {
      _cost,
      _sectorId,
      displayCabinetMilestoneButton,
      sponsoredByCategory,
      _implementationMode
    } = this.props;

    const cabinetBucketHasMilestoneData = item => {
      if (
        !item ||
        !item.milestoneTableDataCOS ||
        !Array.isArray(item.milestoneTableDataCOS)
      ) {
        return false;
      }

      return item.milestoneTableDataCOS.some(
        table =>
          table &&
          Array.isArray(table.milestoneDataCOS) &&
          table.milestoneDataCOS.length > 0
      );
    };
    const shouldStripCabinetBucketFromPayload = cabinetBucket => {
      if (!cabinetBucket) return false;
      if (cabinetBucket.disabled === true) return true;
      return this.isCabinetBucketEmptyForPayload(cabinetBucket);
    };

    const proceedWithMilestoneUpdate = () => {
      const validateAndProceed = () => {
        const { bucketMilestoneCOS } = this.state;

        const cabinetBuckets = bucketMilestoneCOS.filter(
          item => item.bucketName === "Cabinet Milestone"
        );

        const pmgBuckets = bucketMilestoneCOS.filter(
          item => item.bucketName !== "Cabinet Milestone"
        );

        const isPmgValid = this.validateMilestones(pmgBuckets, false);

        const isCabinetValid = this.isCabinetMilestoneMandatoryExemptEdit()
          ? cabinetBuckets.length &&
            cabinetBuckets.some(this.cabinetBucketHasData)
            ? this.validateMilestones(cabinetBuckets, false)
            : true
          : cabinetBuckets.length
          ? this.validateMilestones(cabinetBuckets, false)
          : true;

        const isValid = isPmgValid && isCabinetValid;

        this.setState(prevState => ({
          isMilestoneTableValidated: isValid,
          error: {
            ...prevState.error,
            milestoneMandatoryFields: {
              error: !isPmgValid,
              message: !isPmgValid ? "Mandatory fields are missing" : ""
            },
            cabinetMilestoneMandatoryFields: {
              error: !isCabinetValid,
              message: !isCabinetValid ? "Mandatory fields are missing" : ""
            }
          }
        }));

        if (isValid) {
          const cabinetBucket = bucketMilestoneCOS.find(
            item => item.bucketName === "Cabinet Milestone"
          );

          if (shouldStripCabinetBucketFromPayload(cabinetBucket)) {
            this.setState(
              prevState => ({
                bucketMilestoneCOS: prevState.bucketMilestoneCOS.filter(
                  item => item.bucketName !== "Cabinet Milestone"
                )
              }),
              () => {
                this.onMilestoneUpdate(PROJECT_STATUS.EDIT_MILESTONE);
              }
            );
          } else {
            this.onMilestoneUpdate(PROJECT_STATUS.EDIT_MILESTONE);
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              Mandatory fields are missing
            </p>,
            errorToastStyle
          );
        }
      };

      // ============================================================
      // CABINET MILESTONE EXEMPT LOGIC
      // ============================================================
      if (this.isCabinetMilestoneMandatoryExemptEdit()) {
        validateAndProceed();
        return;
      }

      // ============================================================
      // EXISTING CENTRAL LOGIC
      // ============================================================
      if (
        sponsoredByCategory == "CENTRAL" &&
        _implementationMode != "PRIVATE"
      ) {
        const { bucketMilestoneCOS } = this.state;

        const updatedData1 = bucketMilestoneCOS.filter(
          item => item.bucketName === "Cabinet Milestone"
        );

        const filterData = bucketMilestoneCOS.filter(
          item => item.bucketName !== "Cabinet Milestone"
        );

        const cabinetFromData = filterData.every(
          item => item.disabled === true
        );

        const cabinetBucket = updatedData1[0];

        if (!cabinetBucket) {
          validateAndProceed();
          return;
        }

        const hasCabinetData = this.hasCabinetMilestoneData(cabinetBucket);

        const preventCabinetDisable = _cost >= 1000;

        const hasMilestoneData = cabinetBucketHasMilestoneData(cabinetBucket);

        const shouldDisableCabinet =
          !preventCabinetDisable &&
          ((!hasCabinetData && !displayCabinetMilestones) ||
            (!displayCabinetMilestones && cabinetBucket.disabled == true) ||
            (_cost < 1000 &&
              !displayCabinetMilestones &&
              !displayCabinetMilestoneButton &&
              cabinetFromData &&
              cabinetBucket.disabled == false) ||
            (!displayCabinetMilestones && !hasMilestoneData));

        if (shouldDisableCabinet) {
          this.setState(
            prevState => ({
              bucketMilestoneCOS: prevState.bucketMilestoneCOS.filter(
                item => item.bucketName !== "Cabinet Milestone"
              )
            }),
            validateAndProceed
          );
        } else {
          validateAndProceed();
        }
      } else {
        validateAndProceed();
      }
    };

    proceedWithMilestoneUpdate();
  };
  onClickOfUpdateButton = isMilstoneUpdated => {
    if (typeof isMilstoneUpdated === "boolean") {
      this.onUpadateOfMilestone();
    }
  };

  onClickOfSaveAsDraft = () => {
    this.onMilestoneUpdate(PROJECT_STATUS.DRAFT_MILESTONE);
  };

  handleStateWiseData = (data, index) => {
    this.setState(prev => ({
      stateWiseData: {
        ...prev.stateWiseData,
        [index]: data
      }
    }));
  };

  deleteStateWiseData = index => {
    this.setState(prev => {
      const stateWiseData = { ...(prev.stateWiseData || {}) };

      delete stateWiseData[index];

      return { stateWiseData };
    });
  };

  getState = async row => {
    if (
      row.stateOrUT ||
      (row.districtList &&
        Array.isArray(row.districtList) &&
        row.districtList.length > 0)
    ) {
      return row.stateOrUT || row.districtList[0].stateName;
    }

    try {
      const resp = await this.props.getDistrictListForLocation(
        undefined,
        row.id
      );

      if (resp && Array.isArray(resp.data) && resp.data.length > 0) {
        return resp.data[0].stateName;
      }
    } catch (e) {}

    return "";
  };

  altLocation = async data => {
    if (!Array.isArray(data) || !data.length) return;

    const normalizeRow = () => ({
      totalLocationsUncovered: "",
      totalLocationsConnected: "",
      totalOFCPlanned: "",
      totalOFCInstalled: "",
      totalProjectCost: "",
      implementationAgency: "",
      physicalProgressPercentage: ""
    });

    const smallIdSet = new Set(
      data.map(item => normalizeId(item.id)).filter(Boolean)
    );
    const filteredBigArray = this.props.pageDetail.state.filter(item => {
      const id = normalizeId(item.id);
      const state = item.name;
      return state && smallIdSet.has(id);
    });
    const stateNames = filteredBigArray.map(item => item.name).filter(Boolean);

    this.setState(prevState => {
      const prevStateWiseData = prevState.stateWiseData || {};
      const HEADER_KEYS = [
        "totalLocationsUncoveredHeader",
        "totalLocationsConnectedHeader",
        "totalOFCPlannedHeader",
        "totalOFCInstalledHeader"
      ];

      const updatedStateWiseData = {};

      const phaseIndexes = Object.keys(prevStateWiseData).length
        ? Object.keys(prevStateWiseData)
        : ["0"];

      phaseIndexes.forEach(phaseIndex => {
        const prevRows = Array.isArray(prevStateWiseData[phaseIndex])
          ? prevStateWiseData[phaseIndex]
          : [];

        const prevRowMap = {};
        prevRows.forEach(row => {
          if (row.stateOrUT) prevRowMap[row.stateOrUT] = { ...row };
        });

        const headerSource =
          prevRows.find(row =>
            HEADER_KEYS.some(k => row[k] && row[k] !== "Select")
          ) || {};
        const headersToCopy = HEADER_KEYS.reduce((acc, k) => {
          if (headerSource[k]) acc[k] = headerSource[k];
          return acc;
        }, {});

        const mergedRows = stateNames.map(state => {
          return prevRowMap[state]
            ? {
                ...prevRowMap[state],
                ...headersToCopy,
                active: true,
                tableIndex: phaseIndex
              }
            : {
                stateOrUT: state,
                ...headersToCopy,
                ...normalizeRow(),
                tableIndex: phaseIndex,
                active: true
              };
        });

        updatedStateWiseData[phaseIndex] = mergedRows;
      });

      return {
        stateWiseData: updatedStateWiseData,
        alterLoc: data
      };
    });
  };

  updatedCall = (updated, index) => {
    this.setState(prev => ({
      updated: {
        ...prev.updated,
        [index]: updated
      }
    }));
  };

  render() {
    const { onSelectStatus } = this;
    const {
      isImageUpLoading,
      isLoading,
      pageDetail,
      isApiLoading: apiStatus,
      isEdit,
      previewData,
      getDistrictListForLocation,
      getCircleListForLocation,
      districtListForLocation,
      projectStatusWithRespectToIssueStatus,
      history,
      draftedProjectDetailsStatus,
      location,
      getBucketsWithMilestonesBySectorData,
      getBucketsWithMilestonesBySectorStatus,
      getResponsibleAuthorityData,
      getResponsibleAuthorityStatus,
      createMilestoneAction,
      newMilestoneStatus,
      saveNewMilestoneAction,
      deleteNewMilestoneAction,
      _updateDraftedMilestones,
      openMilestoneEdit,
      editProjectMilestoneStatus,
      onShowDetailsClick,
      onHideUpdate,
      bucketMilestoneCOS: projectDetailBucketMilestoneCOS,
      checkIssueBeforeDeletion,
      projectData,
      checkIssueBeforeDisable,
      bucketDisableIssueCheck,
      isBucketIssueExiststatus,
      isIssueDisableExiststatus,
      isIssueDeleteExiststatus,
      projectMilestoneStatus,
      projectPPList,
      editMilestoneOriginalDate,
      permission,
      apiData,
      march24DTO,
      sponsoredByCategory,
      _implementationMode,
      _cost,
      _sectorId,
      displayCabinetMilestoneButton,
      onCloseModel
    } = this.props;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    const isUserPP = userInfo.groupCategory === "PP";
    const isStateUser = userInfo.groupCategory === "STATE";
    const isStatePMG = userInfo.groupCategory === "STATE_PMG";
    const isUserCentral = userInfo.groupCategory === "CENTRAL";
    const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
    const proponenetGroupID = get(userInfo, "groupId");
    const isBiharProjects =
      this.state.groupId == 82 && this.state.projectCategoryId == "STATE";
    const {
      autoSuggestValue,
      autoSuggestApiLoading,
      projectCategoryId,
      name,
      description,
      cin,
      displayId,
      cost,
      cinInfo,
      locations,
      projectBankInfoActualDate,
      projectBankInfoExpectedDate,
      projectImplementationStartDate,
      projectImplementationSanctionDate,
      projectImplementationSecretaryReviewDate,
      projectImplementationStartState,
      projectImplementationClassification,
      projectImplementationAnticipatedDate,
      error,
      costAndDistance,
      projectImplementationInDirectEmployment,
      projectImplementationDirectEmployment,
      groupCategoryList,
      subSectorList,
      schemesList,
      arSchemesList,
      isApiLoading,
      resetForm,
      status,
      showAlert,
      showSectorChangeAlert,
      options,
      displayAutocomplete,
      defaultSelected,
      projectCompletionDTO,
      revisedTargetCompletionDate,
      revisedCost,
      stateCost,
      centralCost,
      groupId,
      selectedOptionImageUrl,
      otherBankName,
      dataUnsaved,
      previewClicked,
      isConfirmModalVisible,
      stateMinimumCost,
      projectNameTitle,
      pragatiReviewDates,
      otherPP,
      userID,
      createdBy,
      milestoneDataCOS,
      selectedBucketId,
      bucketMilestoneCOS,
      sectorTempObj,
      isMilestoneTableValidated,
      districtList,
      divisionList,
      implementationMode,
      iigPayload,
      showModalForVerifyingProject,
      comment,
      showModalForRejectingProject,
      iigProjectStatus,
      projectId,
      isIIGProjectEdit,
      implMode,
      iigMappingdetails,
      pli,
      iigProjectReferenceId,
      originalLocations,
      userGroupInfo,
      geoCoordinates,
      populationBenefitted,
      projectExtensionFiles,
      march24,
      showPhaseOnBucketComplete,
      pmFoundationStoneId,
      fundReleaseCost,
      executingAgency,
      sponsoringAgencyList,
      districtErrormessage,
      stateErrormessage,
      geoCordinateError,
      projectExtensionFilesErr,
      sponsoringDeptARdata,
      schemeForAr,
      displayBendept,
      stateMinimumCostAP,
      projectCosterror,
      projectrevisedCosterror,
      projectCreatedFrom,
      redBorder,
      ["groupId"]: currentValue,
      displayCabinetMilestones,
      cabinetBucketIds,
      sectorId
    } = this.state;
    const isCostBasedGroup = CABINET_MILESTONE_COST_BASED_GROUP_IDS.includes(
      groupId || this.props.groupId
    );
    const effectiveCost =
      revisedCost != null && revisedCost !== "" ? revisedCost : cost;
    const iigProjectCommonId = get(iigPayload, "commonId");
    const {
      cin: cinBool,
      bank = [],
      state = [],
      projectClassification = [],
      implementationStart = []
    } = pageDetail || {};
    const {
      projectCategoryId: projectCategoryIdErr,
      name: nameErr,
      description: descrErr,
      cin: cinErr,
      cost: costErr,
      fundReleaseCost: fundReleaseCostErr,
      executingAgency: executingErr,
      centralCost: centralCostErr,
      stateCost: stateCostErr,
      locations: locationsErr,
      groupId: groupIdErr,
      projectImplementationClassification: classificationErr,
      projectImplementationStartState: startStateErr,
      projectCompletionDTO: projectCompletionDTOErr,
      percentage: percentageErr,
      financialPercentage: financialPercentageErr,
      date: dateErr,
      progressAsof: progressAsofDateErr,
      milestoneMandatoryFields: milestoneError,
      cabinetMilestoneMandatoryFields: cabinetMilestoneError,
      schemeForAr: schemeForArErr
    } = error;
    let pliData = "";
    let url = window.location.pathname;
    if (
      isLoading === STATUS.SUCCESS &&
      url === PATHS.CREATE_PROJECT &&
      !isEdit &&
      (!get(permission, "createCentralProject") &&
        !get(permission, "createStateProject"))
    ) {
      return (
        <Redirect
          to={{
            pathname: PATHS.PROJECT_LIST
          }}
        />
      );
    }
    if (
      isEdit &&
      implementationMode === "PRIVATE" &&
      projectCategoryId === GROUP_KEYS.CENTRAL
    ) {
      pliData = projectData["data"]["pliDTO"]["pli"];
    } else {
      pliData = false;
    }
    let portConnectivityData = false;
    let coalConnectivityData = false;
    let esamikshaData = false;
    let march24Data = false;

    let isPortConnectivityDTO = false;
    let iscoalConnectivityDTO = false;
    let isesamikshaDTO = false;
    let isMarch24DTO = false;

    if (apiData) {
      isPortConnectivityDTO = apiData["portConnectivityDTO"] !== null;
      iscoalConnectivityDTO = apiData["coalConnectivityDTO"] !== null;
      isesamikshaDTO = apiData["esamikshaDTO"] !== null;
      isMarch24DTO = march24DTO !== null;
    }

    if (isEdit && projectData && projectData.data) {
      portConnectivityData =
        projectData["data"]["portConnectivityDTO"]["portConnectivity"];
      coalConnectivityData =
        projectData["data"]["coalConnectivityDTO"]["coalConnectivity"];
      esamikshaData = projectData["data"]["esamikshaDTO"]["esamiksha"];
      march24Data = projectData["data"]["march24DTO"]["march24"];
    }
    const _selectedBucketData =
      bucketMilestoneCOS &&
      bucketMilestoneCOS.find(item => item.bucketId === selectedBucketId);
    const _selectedBucketCabinet =
      bucketMilestoneCOS &&
      bucketMilestoneCOS.find(item => item.bucketName === "Cabinet Milestone");
    // Whether Cabinet Milestone should currently be treated as mandatory in the UI.
    // True when: ministry is cost-gated (not exempt), OR ministry is exempt but
    // the user has already entered data in the Cabinet Milestone bucket.
    const cabinetBucketsForCheck = (bucketMilestoneCOS || []).filter(
      item => item.bucketName === "Cabinet Milestone"
    );
    const isCabinetExemptEdit = this.isCabinetMilestoneMandatoryExemptEdit();
    const cabinetHasDataEdit = cabinetBucketsForCheck.some(
      this.cabinetBucketHasData
    );
    const isCabinetMandatoryActiveEdit =
      !isCabinetExemptEdit || cabinetHasDataEdit;

    const isCabinetExempt = this.isCabinetMilestoneMandatoryExempt();
    const cabinetHasData = cabinetBucketsForCheck.some(
      this.cabinetBucketHasData
    );
    const isCabinetMandatoryActive = !isCabinetExempt || cabinetHasData;

    console.log(bucketMilestoneCOS, _selectedBucketCabinet);

    const data =
      _selectedBucketData &&
      _selectedBucketData.milestoneTableDataCOS &&
      _selectedBucketData.milestoneTableDataCOS.length
        ? _selectedBucketData.milestoneTableDataCOS
        : [{}];

    const Cabinetdata =
      _selectedBucketCabinet &&
      _selectedBucketCabinet.milestoneTableDataCOS &&
      _selectedBucketCabinet.milestoneTableDataCOS.length
        ? _selectedBucketCabinet.milestoneTableDataCOS
        : [{}];
    const costTooltipContent = (
      <>
        Project with the investment of &#8377;{stateMinimumCost}Cr. and above
        will be entertained
      </>
    );
    const costTooltipContentforAP = (
      <>
        Project with the investment of &#8377;{stateMinimumCostAP} Cr. and above
        will be considered
      </>
    );
    const centralCostTooltip = <>Budgetary support from Central Government</>;
    const stateCostTooltip = <>Budgetary support from State Government</>;

    const isIIGDraft = status === "CRIP_DRAFT";
    const hasIIGProjectReferenceId = iigProjectReferenceId !== null;
    const editWithCentral =
      (isIIGDraft || isEdit) && projectCategoryId === GROUP_KEYS.CENTRAL;
    const editWithState =
      (isIIGDraft || isEdit) && projectCategoryId === GROUP_KEYS.STATE;
    const editProjectExtension =
      isEdit && !STATE_DEPARTMENT_KEYS.includes(groupId);

    const disableCentralProjectOption =
      !isEdit && !get(permission, "createCentralProject");
    const disableStateProjectOption =
      !isEdit && !get(permission, "createStateProject");
    const _projectCategoryId = projectCategoryId
      ? projectCategoryId
      : previewData && previewData.projectCategoryId;

    const isFormTypeNotDefault =
      isEdit && get(previewData, "formType") !== "DEFAULT";

    let _draftedProject = getLocalstorage("draftedProject");
    let isDraftedProject = false;
    let makeChangesClicked = false;
    if (((location && location.state) || _draftedProject) && !previewData) {
      let draftedProject;
      if (location && location.state) {
        draftedProject = location.state.draftedProject;
      }
      let _draftedProject = getLocalstorage("draftedProject");
      if (draftedProject || _draftedProject) {
        isDraftedProject = true;
      } else {
        isDraftedProject = false;
      }
    }
    if (location && location.state) {
      makeChangesClicked = location.state.makeChangesClicked;
    }

    let showAnticipatedMandatory = isEdit
      ? (isFormTypeNotDefault &&
          !get(previewData, "projectImplementationAnticipatedDate")) ||
        (get(previewData, "formType") === "DEFAULT" &&
          get(previewData, "status") === "UNDER_VERIFICATION" &&
          projectImplementationStartState !== "COMPLETED")
      : true;

    showAnticipatedMandatory = pli ? false : showStartDateMandatory;

    let showStartDateMandatory = isEdit
      ? get(previewData, "formType") === "DEFAULT" &&
        get(previewData, "status") === "UNDER_VERIFICATION" &&
        projectImplementationStartState !== "COMPLETED"
      : true;

    showStartDateMandatory = pli ? false : showStartDateMandatory;

    let sectorValue, sectorKey, sectorOption;
    if (sectorTempObj) {
      sectorValue = sectorTempObj.value;
      sectorKey = sectorTempObj.key;
      sectorOption = sectorTempObj.options;
    }

    const isSuperAdmin =
      this.props !== null &&
      this.props.pageDetail !== null &&
      this.props.pageDetail !== undefined &&
      this.props.pageDetail.superAdmin;

    if (
      !isEdit &&
      !isIIGDraft &&
      projectCategoryId === GROUP_KEYS.STATE &&
      !this.state.defaultCentralSelected
    ) {
      this.onChange(GROUP_KEYS.STATE, "projectCategoryId");
      this.setState({ defaultCentralSelected: true });
    }

    if (
      !isEdit &&
      !isIIGDraft &&
      projectCategoryId === GROUP_KEYS.CENTRAL &&
      !this.state.defaultStateSelected
    ) {
      this.onChange(GROUP_KEYS.CENTRAL, "projectCategoryId");
      this.setState({ defaultStateSelected: true });
    }
    const isMilestoneEdit =
      projectData && projectData.data && projectData.data.editMilestone;

    const targetDate = this.state.createdDate;
    const dateAfterCrip = new Date("2026-07-08").getTime();

    return openMilestoneEdit ? (
      <React.Fragment>
        <Prompt
          when={dataUnsaved && !previewClicked}
          message={location => {
            return location.pathname === history.location.pathname
              ? true
              : "You have unsaved changes, are you sure you want to leave?";
          }}
        />
        {getBucketsWithMilestonesBySectorData &&
        getBucketsWithMilestonesBySectorData.data &&
        getBucketsWithMilestonesBySectorData.data.length ? (
          <React.Fragment>
            <LoaderPage
              loading={
                isImageUpLoading === STATUS.LOADING ||
                isLoading === STATUS.LOADING ||
                apiStatus === STATUS.LOADING ||
                draftedProjectDetailsStatus === STATUS.LOADING ||
                getBucketsWithMilestonesBySectorStatus === STATUS.LOADING ||
                getResponsibleAuthorityStatus === STATUS.LOADING ||
                newMilestoneStatus === STATUS.LOADING ||
                editProjectMilestoneStatus === STATUS.LOADING ||
                isApiLoading ||
                isBucketIssueExiststatus === STATUS.LOADING ||
                isIssueDisableExiststatus === STATUS.LOADING ||
                isIssueDeleteExiststatus === STATUS.LOADING
              }
            />
            <Form
              className="create-project-form milestone-update-form"
              style={{ marginBottom: isEdit && milestoneError ? 20 : null }}
            >
              <div className="fieldset-heading">
                <h2 className="update-project-milestone">
                  Update Project Milestones
                </h2>
                <div className="action-wrapper">
                  <div className="detail-btn" onClick={onShowDetailsClick}>
                    Back to Project Milestone
                  </div>
                  <div className="hide-btn" onClick={onHideUpdate}>
                    HIDE
                  </div>
                </div>
              </div>

              {/* {displayCabinetMilestones ? (
                <>
                  <div class="pmg-heading-container">
                    <div class="left-border" />
                    <h2>Cabinet milestones</h2>
                  </div>
                  <CabinetMilestonesTable />
                </>
              ) : null} */}
              <div
                className="cabinet_milestones_btn"
                onClick={this.displayCabinetMilestones}
                style={{
                  display:
                    (isCostBasedGroup && _cost >= 1000) ||
                    _implementationMode == "PRIVATE" ||
                    sponsoredByCategory == "STATE" ||
                    displayCabinetMilestoneButton
                      ? "none"
                      : null,
                  marginBottom: displayCabinetMilestones ? 0 : 50
                }}
              >
                <Image
                  src={
                    displayCabinetMilestones
                      ? IconDelete
                      : cabinet_milestones_btn
                  }
                />
              </div>
              {displayCabinetMilestones ||
              (_implementationMode != "PRIVATE" &&
                displayCabinetMilestoneButton) ||
              (isCostBasedGroup &&
                _cost >= 1000 &&
                bucketMilestoneCOS.some(
                  item => item.bucketName === "Cabinet Milestone"
                ) &&
                _implementationMode != "PRIVATE" &&
                sponsoredByCategory == "CENTRAL") ? (
                <>
                  <div
                    class="pmg-heading-container"
                    style={{ marginBottom: -15 }}
                  >
                    <div class="left-border" />
                    <h2>CABINET MILESTONES</h2>
                  </div>
                  <Bucket
                    draftLocation={this.state.draftLocation}
                    onStateWisePhaseChange={this.onStateWisePhaseChange}
                    pageDetail={
                      window.location.pathname == "/create-project"
                        ? pageDetail && pageDetail.state
                        : this.props.locations
                    }
                    onChange={this.onBucketChangesCabinet}
                    cabinetbucketId={
                      (_selectedBucketCabinet &&
                        _selectedBucketCabinet.bucketId) ||
                      null
                    }
                    bucketMilestoneCOS={bucketMilestoneCOS
                      .filter(item => item.bucketName === "Cabinet Milestone")
                      .slice(-1)}
                    sponsoredByCategory={sponsoredByCategory == "CENTRAL"}
                    milestoneData={sortBy(
                      getBucketsWithMilestonesBySectorData.data
                        .filter(
                          item => item.bucket.name === "Cabinet Milestone"
                        )
                        .slice(-1),
                      "bucket.id"
                    )}
                    isEdit={isEdit}
                    milestoneTableDataCOS={Cabinetdata}
                    milestoneDataCOS={milestoneDataCOS}
                    cabinetMilestone={true}
                    responsibleAuthority={getResponsibleAuthorityData.data}
                    _selectedBucketData={_selectedBucketCabinet}
                    createMilestoneAction={createMilestoneAction}
                    saveNewMilestoneAction={saveNewMilestoneAction}
                    deleteNewMilestoneAction={deleteNewMilestoneAction}
                    milestoneError={
                      isCabinetMandatoryActiveEdit
                        ? cabinetMilestoneError
                        : null
                    }
                    handleTableOrder={this.handleTableOrderCabinet}
                    isCabinetMilestoneMandatoryExempt={
                      isEdit
                        ? this.isCabinetMilestoneMandatoryExempt()
                        : !isCabinetMandatoryActive
                    }
                    draftMilestoneAction={_updateDraftedMilestones}
                    projectMilestoneStatus={projectMilestoneStatus}
                    projectId={
                      get(projectData, "data.id", null) ||
                      this.state.draftProjectId
                    }
                    userID={userID}
                    userInfo={userInfo}
                    createdBy={createdBy}
                    isMilestoneTableValidated={isMilestoneTableValidated}
                    showPhaseOnBucketComplete={showPhaseOnBucketComplete}
                    isMilestoneEdit={isMilestoneEdit}
                    onClickOfSaveAsDraft={this.onClickOfSaveAsDraft}
                    idOfProject={this.props.projectId}
                    locations={
                      this.state.locations.length > this.state.alterLoc.length
                        ? this.state.locations
                        : this.state.alterLoc
                    }
                    handleStateWiseData={this.handleStateWiseData}
                    deleteStateWiseData={this.deleteStateWiseData}
                    stateWiseData={this.state.stateWiseData}
                    costDistributionData={this.props.costDistributionData}
                    groupId={groupId || this.props.groupId}
                    updatedCall={this.updatedCall}
                    ZIndex={this.ZIndex}
                  />

                  <hr className="cabinet-create-project-hr" />
                </>
              ) : null}
              <div class="pmg-heading-container">
                <div class="left-border" />
                <h2>PMG MILESTONES</h2>
              </div>

              <Bucket
                draftLocation={this.state.draftLocation}
                onStateWisePhaseChange={this.onStateWisePhaseChange}
                pageDetail={
                  window.location.pathname == "/create-project"
                    ? pageDetail.state
                    : this.props.locations
                }
                onChange={this.onBucketChanges}
                bucketId={selectedBucketId}
                bucketMilestoneCOS={bucketMilestoneCOS}
                sponsoredByCategory={sponsoredByCategory == "CENTRAL"}
                milestoneData={sortBy(
                  getBucketsWithMilestonesBySectorData.data,
                  "bucket.id"
                )}
                milestoneTableDataCOS={data}
                milestoneDataCOS={milestoneDataCOS}
                responsibleAuthority={getResponsibleAuthorityData.data}
                _selectedBucketData={_selectedBucketData}
                createMilestoneAction={createMilestoneAction}
                saveNewMilestoneAction={saveNewMilestoneAction}
                deleteNewMilestoneAction={deleteNewMilestoneAction}
                milestoneError={milestoneError}
                handleTableOrder={this.handleTableOrder}
                draftMilestoneAction={_updateDraftedMilestones}
                openMilestoneEdit={openMilestoneEdit}
                projectDetailBucketMilestoneCOS={
                  projectDetailBucketMilestoneCOS
                }
                checkIssueBeforeDeletion={checkIssueBeforeDeletion}
                projectId={
                  get(projectData, "data.id", null) || this.state.draftProjectId
                }
                checkIssueBeforeDisable={checkIssueBeforeDisable}
                bucketDisableIssueCheck={bucketDisableIssueCheck}
                userID={userID}
                userInfo={userInfo}
                projectPPList={projectPPList}
                isMilestoneTableValidated={isMilestoneTableValidated}
                editMilestoneOriginalDate={editMilestoneOriginalDate}
                showPhaseOnBucketComplete={showPhaseOnBucketComplete}
                onClickOfUpdateButton={this.onClickOfUpdateButton}
                isMilestoneEdit={isMilestoneEdit}
                projectMilestoneStatus={projectMilestoneStatus}
                onClickOfSaveAsDraft={this.onClickOfSaveAsDraft}
                idOfProject={this.props.projectId}
                locations={
                  window.location.pathname == "/detail-project"
                    ? this.props.locations
                    : this.state.locations.length > this.state.alterLoc.length
                    ? this.state.locations
                    : this.state.alterLoc
                }
                handleStateWiseData={this.handleStateWiseData}
                deleteStateWiseData={this.deleteStateWiseData}
                stateWiseData={this.state.stateWiseData}
                costDistributionData={this.props.costDistributionData}
                groupId={groupId || this.props.groupId}
                updatedCall={this.updatedCall}
                ZIndex={this.ZIndex}
              />
            </Form>
            {(() => {
              const showSubmit =
                _selectedBucketData && !_selectedBucketData.completed;
              const showSaveAsDraft =
                projectMilestoneStatus === "DRAFT" &&
                _selectedBucketData &&
                !_selectedBucketData.completed;
              const showBothButtons = showSubmit && showSaveAsDraft;

              return (
                <div className="d-flex milestone-update-button">
                  {showSubmit && (
                    <Button
                      className="btn-orange btn-mobo"
                      style={{
                        marginLeft: "auto"
                        // marginRight: showBothButtons ? 0 : 0
                      }}
                      onClick={() => this.onUpadateOfMilestone()}
                    >
                      {projectMilestoneStatus === "DRAFT" ||
                      (projectDetailBucketMilestoneCOS &&
                        !projectDetailBucketMilestoneCOS.length)
                        ? "Submit"
                        : "Update"}
                    </Button>
                  )}
                  {showSaveAsDraft && (
                    <Button
                      className="btn-orange-invert btn-mobo btn-draft-milestone"
                      style={!showSubmit ? { marginLeft: "auto" } : {}}
                      onClick={() =>
                        this.onMilestoneUpdate(PROJECT_STATUS.DRAFT_MILESTONE)
                      }
                    >
                      Save as Draft
                    </Button>
                  )}
                </div>
              );
            })()}
          </React.Fragment>
        ) : null}
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Prompt
          when={dataUnsaved && !previewClicked}
          message={location => {
            return location.pathname === history.location.pathname
              ? true
              : "You have unsaved changes, are you sure you want to leave?";
          }}
        />
        <LoaderPage
          loading={
            isImageUpLoading === STATUS.LOADING ||
            isLoading === STATUS.LOADING ||
            apiStatus === STATUS.LOADING ||
            draftedProjectDetailsStatus === STATUS.LOADING ||
            getBucketsWithMilestonesBySectorStatus === STATUS.LOADING ||
            getResponsibleAuthorityStatus === STATUS.LOADING ||
            newMilestoneStatus === STATUS.LOADING ||
            isApiLoading
          }
        />
        <ConfirmationComponent
          show={showAlert}
          modalClass={"confirmation-modal"}
          saveHandler={this.onSubmitPopUp}
          closeHandler={this.openConfirmationAlert}
        />
        {!isIIGDraft && (
          <ConfirmationComponent
            show={showSectorChangeAlert}
            modalClass={"confirmation-modal"}
            saveHandler={() => {
              this.onSelect(sectorValue, sectorKey, sectorOption);
              this.openSectorChangeConfirmationAlert();
            }}
            closeHandler={this.openSectorChangeConfirmationAlert}
            content={
              "Changing the sector will result in loss of milestone data. Are you sure you want to do this?"
            }
          />
        )}
        <Row>
          <Col xs={8}>
            {isIIGDraft && (
              <div className="d-flex">
                {iigPayload !== null && iigProjectCommonId && (
                  <div>
                    <p class="project-id border-right pr-2">
                      COMMON PROJECT ID{" "}
                      <span className="text-primary">
                        <a
                          href={
                            iigBaseUrl +
                            IIG_PATHS.IIG_PROJECT_DETAIL +
                            "?iigProject=" +
                            iigProjectReferenceId
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          #{iigProjectCommonId}
                        </a>
                      </span>
                    </p>
                  </div>
                )}
                <div>
                  <p class="project-id ml-2">
                    PMG PROJECT ID{" "}
                    <span className="text-primary">#{displayId}</span>
                  </p>
                </div>
              </div>
            )}

            {status && (
              <h1 className="page-heading" data-test="form-type-heading">
                {(isEdit && "Edit") ||
                  (status == "CRIP_DRAFT" && targetDate >= dateAfterCrip
                    ? "CRIP Draft"
                    : "IIG Draft") ||
                  (status == "DRAFT" && "Draft") ||
                  "Create"}{" "}
                Project
              </h1>
            )}
          </Col>
          <Col xs={4} className="mandatory-text-wrapper">
            {isFormTypeNotDefault ? null : (
              <div className="mandatory-text">
                <span className="required">*</span>Mandatory Fields
              </div>
            )}
          </Col>
          <p className="page-subline">
            {status == "CRIP_DRAFT" && "DRAFT"
              ? "This project has been created through " +
                (targetDate >= dateAfterCrip ? "CRIP" : "IIG") +
                ". Review all the information carefully before verifying the project."
              : null}
            {projectCategoryId == "STATE" && isFormTypeNotDefault
              ? null
              : "Fill the information carefully as Sponsoring Ministry/State will review and verify your project."}
          </p>
          {!isFormTypeNotDefault ? null : (
            <p
              className="page-subline"
              style={{
                display: projectCategoryId == "STATE" ? "none" : null
              }}
            >
              To update any uneditable project details kindly write to
              pmg@investindia.org.in.
            </p>
          )}
        </Row>
        {isFormTypeNotDefault ? (
          <Form className="create-project-form">
            <Form.Group className="field-cost">
              <div className="form-field">
                <div className="popup-wrapper-new revisedCost">
                  <div
                    className="row"
                    style={{
                      display: projectCategoryId == "STATE" ? null : "none"
                    }}
                  >
                    <div className="col-md-6">
                      <Form.Label data-test="label-revised-cost">
                        Original Cost<span className="required">*</span>
                      </Form.Label>
                      <span className="symbol-field-left">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          style={{ width: 240, paddingTop: "4%" }}
                          disabled
                          value={cost}
                        />
                        <span style={{ right: 45 }}>Cr.</span>
                      </span>
                    </div>
                    <div className="col-md-6">
                      <Form.Label data-test="label-revised-cost">
                        Revised Cost
                      </Form.Label>
                      <span className="symbol-field-left">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          style={{ width: 236, paddingTop: "4%" }}
                          //disabled={march24DTO.march24 != false} //Based on Task 168
                          disabled={projectCreatedFrom == "UP"}
                          value={revisedCost}
                          isInvalid={get(error, "revisedCost.error")}
                          onChange={e =>
                            this.onChange(e.target.value, "revisedCost")
                          }
                          onBlur={e =>
                            this.onBlur(e.target.value, "revisedCost")
                          }
                        />
                        <span style={{ right: 45 }}>Cr.</span>
                        <Form.Control.Feedback type="invalid">
                          {get(error, "revisedCost.message")}
                        </Form.Control.Feedback>
                      </span>
                    </div>
                  </div>
                  <Form.Label
                    data-test="label-revised-cost"
                    style={{
                      display: projectCategoryId == "STATE" ? "none" : null
                    }}
                  >
                    Revised Cost
                  </Form.Label>
                  <span
                    className="symbol-field-left"
                    style={{
                      display: projectCategoryId == "STATE" ? "none" : null
                    }}
                  >
                    <Form.Control
                      data-test="revised-cost"
                      type="text"
                      //disabled={march24DTO.march24 != false} //Based on Task 168
                      disabled={projectCreatedFrom == "UP"}
                      value={revisedCost}
                      isInvalid={get(error, "revisedCost.error")}
                      onChange={e =>
                        this.onChange(e.target.value, "revisedCost")
                      }
                      onBlur={e => this.onBlur(e.target.value, "revisedCost")}
                    />
                    <span>Cr.</span>
                    <Form.Control.Feedback type="invalid">
                      {get(error, "revisedCost.message")}
                    </Form.Control.Feedback>
                  </span>
                  {/* {march24DTO.march24 == null ||
                  march24DTO.march24 == false ? null : (
                    <>
                      <TooltipComponent
                        classes="create_project_tolltip"
                        content={
                          !isUserPMG && projectCategoryId === GROUP_KEYS.CENTRAL
                            ? "Please write to pmg@investindia.org.in for updating the Revised Cost"
                            : costTooltipContent
                        }
                      />
                    </>
                  )} //Based on Task 168 */}
                </div>
              </div>
            </Form.Group>
            <Form.Group
              className="field-cost"
              style={{
                display:
                  projectCategoryId == "STATE" && groupId == 78 ? null : "none"
              }}
            >
              <div className="form-field">
                <div className="popup-wrapper-new revisedCost">
                  <div className="row">
                    <div className="col-md-12">
                      <Form.Label data-test="label-revised-cost">
                        Funds released to the Executing Agency
                        <span className="required">*</span>
                      </Form.Label>
                      <span className="symbol-field-left">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          value={fundReleaseCost}
                          isInvalid={get(fundReleaseCostErr, "error")}
                          onChange={e =>
                            this.onChange(e.target.value, "fundReleaseCost")
                          }
                          style={{ width: "25.2em", paddingTop: "4%" }}
                          onBlur={e =>
                            this.onBlur(e.target.value, "fundReleaseCost")
                          }
                          min={0}
                        />
                        <span style={{ right: "-16em" }}>Cr.</span>
                        <Form.Control.Feedback type="invalid">
                          {get(fundReleaseCostErr, "message")}
                        </Form.Control.Feedback>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Form.Group>
            <Form.Group
              className="field-cost"
              style={{
                display:
                  projectCategoryId == "CENTRAL" || projectCategoryId == null
                    ? "none"
                    : null
              }}
            >
              <div className="form-field">
                <div className="popup-wrapper-new revisedCost">
                  <span className="project-cost-share-text">
                    Project Cost Share
                  </span>
                  <span
                    className="required"
                    style={{
                      display:
                        (groupId == 78 && projectCategoryId == "STATE") ||
                        (groupId == 170 && projectCategoryId == "STATE")
                          ? null
                          : "none"
                    }}
                  >
                    *
                  </span>{" "}
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Label data-test="label-revised-cost">
                        Central Share
                        <span
                          className="required"
                          style={{
                            display:
                              groupId == 78 || groupId == 170 ? null : "none"
                          }}
                        >
                          *
                        </span>
                      </Form.Label>
                      <span className="symbol-field-left">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          style={{ width: 240, paddingTop: "4%" }}
                          value={centralCost}
                          isInvalid={get(centralCostErr, "error")}
                          onChange={e =>
                            this.onChange(e.target.value, "centralCost")
                          }
                          onBlur={e =>
                            this.onBlur(e.target.value, "centralCost")
                          }
                        />
                        <span style={{ right: 45 }}>Cr.</span>
                        <Form.Control.Feedback type="invalid">
                          {get(centralCostErr, "message")}
                        </Form.Control.Feedback>
                      </span>
                    </div>
                    <div className="col-md-6">
                      <Form.Label data-test="label-revised-cost">
                        State Share
                        <span
                          className="required"
                          style={{
                            display:
                              groupId == 78 || groupId == 170 ? null : "none"
                          }}
                        >
                          *
                        </span>
                      </Form.Label>
                      <span className="symbol-field-left">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          style={{ width: 236, paddingTop: "4%" }}
                          value={stateCost}
                          isInvalid={get(stateCostErr, "error")}
                          onChange={e =>
                            this.onChange(e.target.value, "stateCost")
                          }
                          onBlur={e => this.onBlur(e.target.value, "stateCost")}
                        />
                        <span style={{ right: 45 }}>Cr.</span>
                        <Form.Control.Feedback type="invalid">
                          {get(stateCostErr, "message")}
                        </Form.Control.Feedback>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Form.Group>
            <Form.Group className="field-checkbox field-implementation-started">
              <Form.Label data-test="label-implementation-started">
                Project Stage
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                <div
                  className={`form-field-data ${get(startStateErr, "error") &&
                    "error-field"}`}
                >
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[1]
                        ? "checked"
                        : projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="checkbox-no"
                      type="checkbox"
                      name="started_implementation"
                      //disabled={projectCreatedFrom=="UP"}
                    />
                    <Form.Text
                      style={{ textTransform: "none", fontSize: 13 }}
                      data-test="label-no"
                      className={`form-checkbox-label ${
                        get(previewData, "projectImplementationStartState") ===
                        implementationStart[2]
                          ? "disable-box"
                          : ""
                      }`}
                      onClick={
                        get(previewData, "projectImplementationStartState") ===
                          implementationStart[2] || projectCreatedFrom == "UP"
                          ? null
                          : () => {
                              this.onBlur(
                                implementationStart[1],
                                "projectImplementationStartState"
                              );
                            }
                      }
                    >
                      &nbsp;Implementation Not Started
                    </Form.Text>
                  </Form.Check>
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[0]
                        ? "checked"
                        : projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="checkbox-yes"
                      type="checkbox"
                      name="started_implementation"
                    />
                    <Form.Text
                      style={{ textTransform: "none", fontSize: 13 }}
                      data-test="label-yes"
                      className={`form-checkbox-label ${
                        get(previewData, "projectImplementationStartState") ===
                        implementationStart[2]
                          ? "disable-box"
                          : ""
                      }`}
                      onClick={
                        get(previewData, "projectImplementationStartState") ===
                          implementationStart[2] || projectCreatedFrom == "UP"
                          ? null
                          : () => {
                              this.onBlur(
                                implementationStart[0],
                                "projectImplementationStartState"
                              );
                            }
                      }
                    >
                      &nbsp;Under Implementation
                    </Form.Text>
                  </Form.Check>

                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[2]
                        ? "checked"
                        : projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="checkbox-completed"
                      type="checkbox"
                      name="started_implementation"
                    />
                    <Form.Text
                      style={{ textTransform: "none", fontSize: 13 }}
                      data-test="label-completed"
                      className="form-checkbox-label"
                      onClick={() => {
                        (isEdit &&
                          projectStatusWithRespectToIssueStatus === "OPEN") ||
                        projectCreatedFrom == "UP"
                          ? this.setState({ isConfirmModalVisible: true })
                          : this.onBlur(
                              implementationStart[2],
                              "projectImplementationStartState"
                            );
                      }}
                    >
                      Completed
                    </Form.Text>
                  </Form.Check>
                </div>
                <Form.Control.Feedback type="invalid">
                  {get(startStateErr, "message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            {projectImplementationStartState === "UNDER_IMPLEMENTATION" &&
            this.state.groupId == 37 ? (
              <Status
                options={[
                  {
                    "data-test": "under-construction",
                    label: "Under Construction",
                    value: "underConstruction",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked:
                      (projectCompletionDTO &&
                        /Construction/gi.test(projectCompletionDTO.status)) ||
                      false,
                    name: "statusfields"
                  },
                  {
                    "data-test": "partially-commissioned",
                    label: "Provisionally Commissioned",
                    value: "provisionallyCommissioned",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId,
                    checked:
                      (projectCompletionDTO &&
                        /provisionally/gi.test(projectCompletionDTO.status)) ||
                      false,
                    type: "radio",
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                onChange={onSelectStatus}
                error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                financialPercentageErr={financialPercentageErr}
                isEdit={isEdit}
                dateErr={dateErr}
                isUPproject={projectCreatedFrom == "UP"}
                //isRequired={!pli}
                progressAsofDateErr={progressAsofDateErr}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isFormTypeNotDefault={isFormTypeNotDefault}
                projectCategoryId={projectCategoryId}
              />
            ) : null}
            {projectImplementationStartState === "UNDER_IMPLEMENTATION" &&
            this.state.groupId != 37 ? (
              <Status
                options={[
                  {
                    "data-test": "under-construction",
                    label: "Under Construction",
                    value: "underConstruction",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked:
                      (projectCompletionDTO &&
                        /Construction/gi.test(projectCompletionDTO.status)) ||
                      false,
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                isUPproject={projectCreatedFrom == "UP"}
                onChange={onSelectStatus}
                //error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                financialPercentageErr={financialPercentageErr}
                isEdit={isEdit}
                dateErr={dateErr}
                //isRequired={!pli}
                progressAsofDateErr={progressAsofDateErr}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isFormTypeNotDefault={isFormTypeNotDefault}
                projectCategoryId={projectCategoryId}
              />
            ) : null}
            {projectImplementationStartState ===
            "IMPLEMENTATION_NOT_STARTED" ? (
              <Status
                options={[
                  {
                    "data-test": "under-development",
                    label: "Under Development",
                    value: "underDelopment",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked: true,
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                onChange={onSelectStatus}
                type="hidden"
                error={projectCompletionDTOErr}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                financialPercentageErr={financialPercentageErr}
                isEdit={isEdit}
                dateErr={dateErr}
                isUPproject={projectCreatedFrom == "UP"}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isFormTypeNotDefault={isFormTypeNotDefault}
                projectCategoryId={projectCategoryId}
              />
            ) : null}

            {projectImplementationStartState === "COMPLETED" &&
            groupId == 37 ? (
              <>
                <Status
                  options={[
                    {
                      "data-test": "under-construction",
                      label: "Physically Completed/CC Under Issue",
                      value: "projectPhysicallyCompleted",
                      type: "radio",
                      disabled:
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP",
                      checked:
                        (projectCompletionDTO &&
                          /Physically/gi.test(projectCompletionDTO.status)) ||
                        false,
                      name: "statusfields"
                    },

                    {
                      "data-test": "partially-commissioned",
                      label: "Commissioned",
                      value: "commissioned",
                      disabled:
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId,
                      checked:
                        (projectCompletionDTO &&
                          /Commissioned/gi.test(projectCompletionDTO.status)) ||
                        false,
                      type: "radio",
                      name: "statusfields"
                    }
                  ]}
                  projectCompletionDTO={projectCompletionDTO}
                  projectStatus={status}
                  onChange={onSelectStatus}
                  projectImplementationStartState={
                    projectImplementationStartState
                  }
                  disabledFields={{ date: false, percentage: true }}
                  error={projectCompletionDTOErr}
                  updateParentStateError={this.updateParentStateError}
                  percentageErr={percentageErr}
                  financialPercentageErr={financialPercentageErr}
                  progressAsofDateErr={progressAsofDateErr}
                  dateErr={dateErr}
                  isEdit={isEdit}
                  isRequired={!pli}
                  isIIGProjectEdit={isIIGProjectEdit}
                  iigProjectReferenceId={iigProjectReferenceId}
                  projectstageerror={this.state.projectstageerror}
                  isFormTypeNotDefault={isFormTypeNotDefault}
                  projectCategoryId={projectCategoryId}
                  isUPproject={projectCreatedFrom == "UP"}
                />
                {this.state.projectstageerror == "This field is required." &&
                isFormTypeNotDefault == true ? (
                  <div
                    className="error-field error-message"
                    style={{
                      marginTop: isEdit == true ? "-2%" : "-1%",
                      marginBottom: "1%",
                      color: "#fc192e",
                      fontSize: 11,
                      fontWeight: "bold"
                    }}
                  >
                    <i>{this.state.projectstageerror}</i>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : null}
            {projectImplementationStartState === "COMPLETED" &&
            groupId != 37 ? (
              <Status
                options={[
                  {
                    "data-test": "commissioned",
                    label: "Commissioned",
                    value: "commissioned",
                    checked: true,
                    type: "radio",
                    name: "statusfields",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                onChange={onSelectStatus}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                disabledFields={{ date: false, percentage: true }}
                error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                financialPercentageErr={financialPercentageErr}
                dateErr={dateErr}
                isEdit={isEdit}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isFormTypeNotDefault={isFormTypeNotDefault}
                projectCategoryId={projectCategoryId}
                isUPproject={projectCreatedFrom == "UP"}
              />
            ) : null}
            {(projectImplementationStartState === implementationStart[0] ||
              projectImplementationStartState === implementationStart[1] ||
              projectImplementationStartState === implementationStart[2]) && (
              <Form.Group className="field-datepicker">
                <div className="form-field">
                  <div className="popup-wrapper revisedCost">
                    <Form.Label
                      data-test="label-project-sanction-date"
                      className="popup-wrapper-sanction-date"
                    >
                      Sanction Date
                      {(!isEdit || (!isUserPMG && !isStatePMG)) && (
                        <span className="required">*</span>
                      )}
                      <TooltipComponent
                        classes="create_project_tolltip sanction_date_tooltip"
                        placement="right"
                        content={
                          <div className="sanction-tooltip-table">
                            <table className="sanction-table">
                              <thead className="sanction-table__head">
                                <tr>
                                  <th className="sanction-table__header">
                                    Project Cost
                                  </th>
                                  <th className="sanction-table__header">
                                    Sanction Date
                                  </th>
                                </tr>
                              </thead>

                              <tbody className="sanction-table__body">
                                <tr className="sanction-table__row">
                                  <td className="sanction-table__cell">
                                    Up to ₹100 crore
                                  </td>
                                  <td className="sanction-table__cell">
                                    Date of the Secretary’s sanction/approval
                                  </td>
                                </tr>

                                <tr className="sanction-table__row">
                                  <td className="sanction-table__cell">
                                    Above ₹100 crore to ₹500 crore
                                  </td>
                                  <td className="sanction-table__cell">
                                    Date of the Minister's signature
                                  </td>
                                </tr>

                                <tr className="sanction-table__row">
                                  <td className="sanction-table__cell">
                                    Above ₹500 crore to ₹1,000 crore
                                  </td>
                                  <td className="sanction-table__cell">
                                    Date of the final required approval, i.e.
                                    Finance Minister's signature date
                                  </td>
                                </tr>

                                <tr className="sanction-table__row">
                                  <td className="sanction-table__cell">
                                    Above ₹1,000 crore
                                  </td>
                                  <td className="sanction-table__cell">
                                    Date of the Cabinet Sanction Letter/
                                    <br />
                                    communication issued after Cabinet approval
                                  </td>
                                </tr>
                                <tr className="sanction-table__row">
                                  <td className="sanction-table__cell">
                                    PSU Projects
                                  </td>
                                  <td className="sanction-table__cell">
                                    Date of approval by the Competent authority
                                    <br />
                                    (Head of PSU/ Board of Directors etc.)
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        }
                      />
                    </Form.Label>

                    <span className="anticipated-not-default mr-2">
                      <DatePicker
                        data-test="project-sanction-date"
                        selected={projectImplementationSanctionDate}
                        disabled={
                          (projectData.data.projectSanctionDate !== null &&
                            isEdit !== undefined) ||
                          projectCreatedFrom == "UP"
                        }
                        onChange={value => {
                          this.onChange(
                            value,
                            "projectImplementationSanctionDate"
                          );
                        }}
                        value={projectImplementationSanctionDate}
                        isInvalid={get(
                          error,
                          "projectImplementationSanctionDate.error"
                        )}
                        isClearable={
                          !(
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            iigProjectReferenceId === null &&
                            projectData.data.projectSanctionDate !== null &&
                            isEdit !== undefined &&
                            projectCreatedFrom == "UP"
                          )
                        }
                        className={`data-test-class-sanction-date ${
                          get(
                            error,
                            "projectImplementationSanctionDate.error"
                          ) &&
                          (!isEdit || (!isUserPMG && !isStatePMG))
                            ? "error-field-set"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      (get(error, "projectImplementationSanctionDate.error") &&
                        !isEdit) ||
                      !isUserPMG
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationSanctionDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            )}

            {get(previewData, "projectImplementationAnticipatedDate") &&
            (projectImplementationStartState === "IMPLEMENTATION_NOT_STARTED" ||
              projectImplementationStartState === "UNDER_IMPLEMENTATION" ||
              this.state.revisedtargetfielddisplay == true ||
              projectCompletionDTO.status == "projectPhysicallyCompleted" ||
              projectCompletionDTO.status ==
                "PHYSICALLY COMPLETED/CC UNDER ISSUE") ? (
              <Form.Group className="field-datepicker">
                <div className="form-field">
                  <div className="popup-wrapper revisedCost">
                    <Form.Label data-test="label-revised-target-date-of-completion">
                      Revised Target Date of Completion
                    </Form.Label>
                    <span className="anticipated-not-default mr-2">
                      <DatePicker
                        isClearable={projectCreatedFrom != "UP"}
                        selected={revisedTargetCompletionDate}
                        value={revisedTargetCompletionDate}
                        onChange={value => {
                          this.onChange(value, "revisedTargetCompletionDate");
                        }}
                        className="data-test-class-revised-targeted-date-of-completion status-date-box"
                        disabled={projectCreatedFrom == "UP"}
                      />
                    </span>
                    {/* {march24DTO.march24 != false ? (
                      <>
                        {" "}
                        <TooltipComponent
                          classes="create_project_tolltip"
                          content={
                            "Please write to pmg@investindia.org.in for updating the Revised Target Date of Completion"
                          }
                        />
                      </>
                    ) : null} //Based on Task 168  */}
                  </div>
                </div>
              </Form.Group>
            ) : null}

            {(projectImplementationStartState === implementationStart[0] ||
              projectImplementationStartState === implementationStart[1] ||
              projectImplementationStartState === implementationStart[2]) &&
              projectCategoryId === GROUP_KEYS.CENTRAL && (
                <Form.Group className="field-datepicker field-select">
                  <Form.Label data-test="label-secretary-review-date">
                    Secretary Review Date
                  </Form.Label>
                  <div className="form-field">
                    <SecretaryReviewDate
                      projectImplementationSecretaryReviewDate={
                        projectImplementationSecretaryReviewDate
                      }
                      resetForm={resetForm}
                      updateParentState={this.updateParentState}
                      updateParentStateError={this.updateParentStateError}
                      isFormTypeNotDefault={isFormTypeNotDefault}
                      disabled={projectCreatedFrom == "UP"}
                    />
                  </div>
                </Form.Group>
              )}

            {!get(previewData, "projectImplementationAnticipatedDate") &&
            (projectImplementationStartState === "IMPLEMENTATION_NOT_STARTED" ||
              projectImplementationStartState === "UNDER_IMPLEMENTATION") ? (
              <Form.Group className="field-datepicker">
                <Form.Label data-test="label-original-date-of-completion">
                  Original Date Of Completion
                  {!isSuperAdmin && (showAnticipatedMandatory || !pli) && (
                    <span className="required">*</span>
                  )}
                </Form.Label>
                <div>
                  <div className="form-field">
                    <DatePicker
                      isClearable={
                        projectImplementationAnticipatedDate &&
                        !isIIGDraft &&
                        !isIIGProjectEdit &&
                        projectCreatedFrom != "UP"
                      }
                      selected={projectImplementationAnticipatedDate}
                      value={projectImplementationAnticipatedDate}
                      className={`data-test-class-original-date-of-completion ${
                        get(error, "projectImplementationAnticipatedDate.error")
                          ? "error-field-set"
                          : ""
                      } anticipated-for-pp status-date-box`}
                      onChange={value => {
                        this.onChange(
                          value,
                          "projectImplementationAnticipatedDate"
                        );
                      }}
                      isInvalid={get(
                        error,
                        "projectImplementationAnticipatedDate.error"
                      )}
                      disabled={projectCreatedFrom == "UP"}
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "projectImplementationAnticipatedDate.error")
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationAnticipatedDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            ) : null}

            {this.renderProjectBriefDescriptionField()}

            {this.renderProjectMapField()}

            {(isEdit && get(previewData, "edit") && (
              <div
                className="submission-btns-wrapper"
                style={{ float: "right", marginRight: -20 }}
              >
                <Button
                  data-test="cancel-button"
                  className="btn-orange-invert no-padding btn-cancel btn btn-primary"
                  onClick={() => onCloseModel()}
                >
                  Cancel
                </Button>
                <Button
                  data-test="update-button"
                  className="btn-orange btn-desk update-btn"
                  onClick={this.onValidateForm.bind(this, status)}
                >
                  Update
                </Button>
              </div>
            )) ||
              null}
          </Form>
        ) : (
          <Form className="create-project-form">
            <div className="fieldset-heading save-draft-icon">
              <h2 data-test="section-label-project-details">Project Details</h2>
              <Link to={"#"}>
                <Image
                  src={IconSave}
                  alt="Save as Draft"
                  title="Save as Draft"
                />
              </Link>
            </div>
            <DisplayByPermission display={true}>
              <Form.Group className="field-checkbox project-awarded-by">
                <Form.Label>
                  <span
                    className="popup-wrapper project-awarded"
                    data-test="label-project-awarded-by"
                  >
                    Project Awarded by
                    <span className="required">*</span>
                    <TooltipComponent
                      classes="create_project_tolltip"
                      content={
                        <>
                          {groupId == 77 ? (
                            <>
                              Project with the investment of &#8377;
                              {stateMinimumCostAP} Cr. and above will be
                              considered
                            </>
                          ) : (
                            <>
                              Project with the investment of &#8377;
                              {stateMinimumCost}
                              Cr. and above will be entertained
                            </>
                          )}
                        </>
                      }
                    />
                  </span>
                </Form.Label>
                <div className="form-field">
                  <div
                    className={`form-field-data form-field-mobile ${get(
                      projectCategoryIdErr,
                      "error"
                    ) && "error-field"}`}
                  >
                    <Form.Check
                      className={`form-checkbox ${
                        this.state.userCanOnlyCreateCentralProject ||
                        projectCategoryId === GROUP_KEYS.CENTRAL
                          ? "checked"
                          : ""
                      } ${
                        disableCentralProjectOption ? "disable-project" : ""
                      }`}
                    >
                      <Form.Check.Input
                        data-test="central-govt-projects-radio-button"
                        type="radio"
                        name="project"
                      />
                      <Form.Text
                        data-test="checkbox-central-govt-projects"
                        className={`form-checkbox-label position-relative ${
                          editWithState ? "disabled" : null
                        }`}
                        onClick={() => {
                          iigProjectReferenceId === null &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !disableCentralProjectOption &&
                            this.onChange(
                              GROUP_KEYS.CENTRAL,
                              "projectCategoryId"
                            );
                        }}
                      >
                        {disableCentralProjectOption && (
                          <div className="text-center position-absolute disable-project-text">
                            PMG portal has been integrated with the IIG Portal.
                            Going forward, all Centrally Sponsored projects{" "}
                            <br /> must be created through IIG portal only.
                            <br />
                            Projects created on IIG will automatically get
                            created on the PMG portal.
                          </div>
                        )}
                        <div
                          className={`${
                            disableCentralProjectOption
                              ? "disable-project-content"
                              : ""
                          } checkbox-image`}
                        >
                          <Image src={IndiaEmblem} alt="India Emblem" />
                        </div>

                        <div
                          className={`${
                            disableCentralProjectOption
                              ? "disable-project-content"
                              : ""
                          } checkbox-text`}
                        >
                          <div
                            className="checkbox-label"
                            data-test="checkbox-central-govt-project"
                          >
                            Govt. Of India
                          </div>
                          <div className="checkbox-sublabel">
                            Central Govt. Projects
                          </div>
                        </div>
                      </Form.Text>
                    </Form.Check>
                    <Form.Check
                      className={`form-checkbox ${(this.state
                        .userCanOnlyCreateStateProject ||
                        projectCategoryId === GROUP_KEYS.STATE) &&
                        "checked"} ${
                        disableStateProjectOption ? "disable-project" : ""
                      }`}
                    >
                      <Form.Check.Input
                        data-test="state-govt-projects-radio-button"
                        type="radio"
                        name="project"
                      />
                      <Form.Text
                        data-test="checkbox-state-govt-projects"
                        className={`form-checkbox-label position-relative ${
                          editWithCentral
                            ? "disabled state-sponsored-project"
                            : null
                        }`}
                        onClick={() => {
                          !editWithState &&
                            iigProjectReferenceId === null &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !disableStateProjectOption &&
                            this.onChange(
                              GROUP_KEYS.STATE,
                              "projectCategoryId"
                            );
                        }}
                      >
                        {disableStateProjectOption && (
                          <div
                            data-test="dont-have-permission-to-create-state-sponsored-projects"
                            className="text-center position-absolute disable-project-text"
                          >
                            You don't have permission to create State Sponsored
                            projects.
                          </div>
                        )}
                        <div
                          className={`${
                            disableStateProjectOption
                              ? "disable-project-content"
                              : ""
                          } checkbox-image`}
                        >
                          <Image src={IndiaMap} alt="India Map" />
                        </div>
                        <div
                          className={`${
                            disableStateProjectOption
                              ? "disable-project-content"
                              : ""
                          } checkbox-text`}
                        >
                          <div
                            className="checkbox-label"
                            data-test="checkbox-state-govt-project"
                          >
                            State Of India
                          </div>
                          <div className="checkbox-sublabel">
                            State Govt. Projects
                          </div>
                        </div>
                      </Form.Text>
                    </Form.Check>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {get(projectCategoryIdErr, "message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </DisplayByPermission>
            {(isValidArray(groupCategoryList) &&
              (projectCategoryId === GROUP_KEYS.CENTRAL ||
                projectCategoryId === GROUP_KEYS.STATE) && (
                <Form.Group className="field-select">
                  <Form.Label data-test="label-sponsoring-ministry-or-state">
                    Sponsoring {transformProjectCategoryId(projectCategoryId)}
                    <span className="required">*</span>
                  </Form.Label>
                  <div className="form-field">
                    {/* <CustomDropdown
                      options={[
                        {
                          value: `- Select ${transformProjectCategoryId(
                            projectCategoryId
                          )} Name -`,
                          label: `- Select ${transformProjectCategoryId(
                            projectCategoryId
                          )} Name -`,
                          id: ""
                        },
                        ...(groupCategoryList || []).map(item => ({
                          value: item.id,
                          label: item.name,
                          id: item.id
                        }))
                      ]}
                      value={
                        (
                          (groupCategoryList || []).find(
                            i => i.id === currentValue
                          ) || {}
                        ).name || null
                      }
                      onChange={value =>
                        this.onSelect(value, "groupId", groupCategoryList)
                      }
                      width="100%"
                      height="43px"
                      className="dashboard create-project-dropdown"
                      page="create-project-select-ministry"
                      menuClassName="selectMonitoringMenu"
                    /> */}
                    {this.createTemplateFromState(
                      "groupCategoryList",
                      `Select ${transformProjectCategoryId(
                        projectCategoryId
                      )} Name`,
                      "groupId",
                      editWithState
                    )}
                    <Form.Control.Feedback type="invalid">
                      {get(groupIdErr, "message")}
                    </Form.Control.Feedback>

                    {iigPayload !== null && (
                      <p className="remaining-char iig-sector-id">
                        Sponsoring Ministry from{" "}
                        {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}
                        :&nbsp;
                        {iigMappingdetails.sponsoringMinistry != null
                          ? iigMappingdetails.sponsoringMinistry
                          : "N/A"}
                      </p>
                    )}
                  </div>
                </Form.Group>
              )) ||
              null}
            {(isValidArray(sponsoringDeptARdata) && (
              <Form.Group
                className="field-select"
                style={{ display: displayBendept ? null : "none" }}
              >
                <Form.Label data-test="label-sponsoring-ministry-or-state">
                  {groupId == 78
                    ? "Beneficiary Department"
                    : " Sponsoring Department"}
                  <span
                    className="required"
                    style={{
                      display:
                        groupId == 78 ||
                        ((get(permission, "createStateProject") &&
                          this.state.projectCategoryId == "STATE") ||
                          (get(permission, "createStateProject") &&
                            this.state.projectCategoryId == "STATE" &&
                            isEdit))
                          ? null
                          : "none"
                    }}
                  >
                    *
                  </span>
                </Form.Label>
                <div className="form-field">
                  {this.createTemplateFromState(
                    "sponsoringDeptARdata",
                    `Select ${
                      groupId == 78 ? "Beneficiary" : "Sponsoring"
                    } Department`,
                    "sponsoringDepartmentId"
                    //editWithState && editProjectExtension
                  )}
                </div>
              </Form.Group>
            )) ||
              null}
            {(isValidArray(districtList) &&
              (projectCategoryId === GROUP_KEYS.CENTRAL ||
                (projectCategoryId === GROUP_KEYS.STATE && groupId != 78)) && (
                <Form.Group className="field-select">
                  <Form.Label data-test="label-sponsoring-district-or-department">
                    {projectFormLabel(
                      groupId,
                      "department",
                      "Sponsoring Department"
                    )}
                    {get(permission, "createStateProject") &&
                    this.state.projectCategoryId == "STATE" ? (
                      <span className="required">*</span>
                    ) : (
                      ""
                    )}
                  </Form.Label>
                  <div className="form-field">
                    {this.createTemplateFromState(
                      "districtList",
                      `Select ${projectFormLabel(
                        groupId,
                        "department",
                        "Sponsoring Department"
                      )}`,
                      "sponsoringDepartmentId",
                      editWithState && editProjectExtension
                    )}
                  </div>
                </Form.Group>
              )) ||
              null}
            {(isValidArray(divisionList) && (
              <Form.Group className="field-select">
                <Form.Label data-test="label-division">
                  Division/Zone
                </Form.Label>
                <div className="form-field">
                  {/* <CustomDropdown
                    options={divisionList.map(item => ({
                      value: item.id,
                      label: item.name
                    }))}
                    onChange={value =>
                      this.onSelect(value, "divisionId", divisionList)
                    }
                    width="100%"
                    height="43px"
                    className="dashboard create-project-dropdown"
                    // className="custom-dropdown"
                    page="create-project-select-division"
                    menuClassName="selectMonitoringMenu"
                  /> */}
                  {this.createTemplateFromState(
                    "divisionList",
                    `Select Division/Zone`,
                    "divisionId",
                    editWithState && editProjectExtension
                  )}
                </div>
              </Form.Group>
            )) ||
              null}
            <Form.Group style={{ display: displayBendept ? null : "none" }}>
              <Form.Label data-test="label-project-name">
                {projectFormLabel(groupId, "name", projectNameTitle)}
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                <Form.Control
                  data-test="project-name"
                  type="text"
                  maxLength="185"
                  className={`${
                    /[\u0900-\u097F]/.test(name)
                      ? "hindi-text-wrap-comment"
                      : ""
                  }`}
                  placeholder={`Enter ${projectFormLabel(
                    groupId,
                    "name",
                    projectNameTitle
                  )}`}
                  onChange={e => {
                    this.onChange(e.target.value, "name");
                  }}
                  onBlur={e => {
                    this.onBlur(e.target.value, "name");
                  }}
                  value={name}
                  disabled={
                    isIIGDraft ||
                    isIIGProjectEdit ||
                    hasIIGProjectReferenceId ||
                    projectCreatedFrom == "UP"
                  }
                  isInvalid={get(nameErr, "error")}
                />
                {!isIIGDraft &&
                  !isIIGProjectEdit &&
                  iigProjectReferenceId === null && (
                    <span className="remaining-char">
                      Remaining characters :{" "}
                      {this.maxNameFieldLength - name.length}
                    </span>
                  )}
                <Form.Control.Feedback type="invalid">
                  {get(nameErr, "message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            {this.renderProjectBriefDescriptionField()}
            <Form.Group
              className={`field-cin-number ${cinInfo && "valid-cin"}`}
            >
              <Form.Label>
                <span className="popup-wrapper" data-test="label-cin-number">
                  CIN Number
                  {cinBool && <span className="required">*</span>}
                  <TooltipComponent
                    classes="create_project_tolltip"
                    content={
                      "21 digit Corporate Identification Number e.g. U91100DL2009NPL197064"
                    }
                  />
                </span>
              </Form.Label>
              <div className="form-field">
                <Form.Control
                  data-test="cin-number"
                  type="text"
                  placeholder="Enter CIN Number"
                  onChange={e => this.onChange(e.target.value, "cin")}
                  onBlur={e => this.onBlur(e.target.value, "cin")}
                  value={cin}
                  isInvalid={get(cinErr, "error")}
                />
                {cin && (
                  <span
                    className="validate-cin"
                    data-test="validate-cin"
                    onClick={this.validateCIN}
                  >
                    Validate
                  </span>
                )}
                {cinInfo && (
                  <Container fluid className="cin-desc">
                    <Row>
                      <Col lg={4}>CIN Number</Col>
                      <Col lg={8}>{cinInfo.number}</Col>
                    </Row>
                    <Row>
                      <Col lg={4}>Company Name</Col>
                      <Col lg={8}>{cinInfo.companyName}</Col>
                    </Row>
                    <Row>
                      <Col lg={4}>Incorporation Date</Col>
                      <Col lg={8}>{dateFormat(cinInfo.date)}</Col>
                    </Row>
                  </Container>
                )}
                <Form.Control.Feedback type="invalid">
                  {get(cinErr, "message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            <Form.Group className="field-select field-project-sector">
              <Form.Label data-test="label-project-sector">
                Project Sector
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                {this.createTemplatesFromPageDetail(
                  "sector",
                  "Select Sector",
                  "sectorId"
                )}
                {(isValidArray(subSectorList) &&
                  this.createTemplateFromState(
                    "subSectorList",
                    "Select Sub-Sector",
                    "subSectorId"
                  )) ||
                  null}
              </div>
            </Form.Group>
            {(isValidArray(schemesList) && (
              <Form.Group
                className="field-select"
                style={{ display: groupId == 78 ? "none" : null }}
              >
                <Form.Label data-test="label-project-schemes">
                  Project Schemes
                </Form.Label>
                <div className="form-field">
                  {this.createTemplateFromState(
                    "schemesList",
                    "Select Scheme",
                    "schemeId"
                  )}
                </div>
              </Form.Group>
            )) ||
              null}
            <Form.Group className="field-cost">
              <Form.Label
                className="project-cost-title"
                data-test="label-project-cost"
              >
                Project Cost (in crores)
                {!isSuperAdmin && <span className="required">*</span>}
              </Form.Label>
              <div className="form-field">
                <div className="popup-wrapper cost">
                  <Form.Label data-test="label-original-cost">
                    Original Cost
                    {!isSuperAdmin && <span className="required">*</span>}
                  </Form.Label>
                  <span className="symbol-field-left original-cost">
                    <Form.Control
                      data-test="original-cost"
                      type="text"
                      value={cost}
                      isInvalid={get(costErr, "error") || projectCosterror}
                      onChange={e => this.onChange(e.target.value, "cost")}
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                      onBlur={e => this.onBlur(e.target.value, "cost")}
                      min={0}
                    />
                    <span>Cr.</span>
                    {projectCosterror ? (
                      <>
                        <div class="invalid-feedback">
                          Minimum Project Cost: ₹{stateMinimumCostAP} Cr.
                        </div>
                      </>
                    ) : (
                      <Form.Control.Feedback type="invalid">
                        {get(costErr, "message")}
                      </Form.Control.Feedback>
                    )}
                  </span>
                  <TooltipComponent
                    classes="create_project_tolltip"
                    content={
                      groupId == 77
                        ? costTooltipContentforAP
                        : costTooltipContent
                    }
                  />
                </div>
                <div className="popup-wrapper revisedCost">
                  <Form.Label data-test="label-revised-cost">
                    Revised Cost{" "}
                    <span>
                      {isIIGDraft
                        ? "(" + iigPayload.revisedCost == null && "" + ")"
                        : ""}
                    </span>
                  </Form.Label>
                  <span className="symbol-field-left">
                    <Form.Control
                      data-test="revised-cost"
                      type="text"
                      value={revisedCost}
                      isInvalid={
                        get(error, "revisedCost.error") ||
                        projectrevisedCosterror
                      }
                      onChange={e =>
                        this.onChange(e.target.value, "revisedCost")
                      }
                      onBlur={e => this.onBlur(e.target.value, "revisedCost")}
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                    />
                    <span>Cr.</span>
                    {projectrevisedCosterror ? (
                      <div class="invalid-feedback">
                        Minimum Project Cost: ₹{stateMinimumCostAP} Cr.
                      </div>
                    ) : (
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: groupId == 77 ? "none" : null }}
                      >
                        {get(error, "revisedCost.message")}
                      </Form.Control.Feedback>
                    )}
                  </span>
                  <TooltipComponent
                    classes="create_project_tolltip"
                    content={
                      groupId == 77
                        ? costTooltipContentforAP
                        : costTooltipContent
                    }
                  />
                </div>
              </div>
            </Form.Group>
            {groupId == 78 ? (
              <>
                <Form.Group className="field-cost">
                  <Form.Label
                    className="project-cost-title"
                    data-test="label-project-cost"
                    style={{ marginTop: -2 }}
                  >
                    Funds released to the Executing Agency
                    <span className="required">*</span>
                    {isEdit ? <br /> : null} (in crores)
                  </Form.Label>
                  <div className="form-field">
                    <div className="popup-wrapper cost">
                      <span className="symbol-field-left original-cost">
                        <Form.Control
                          data-test="revised-cost"
                          type="text"
                          value={fundReleaseCost}
                          isInvalid={get(fundReleaseCostErr, "error")}
                          onChange={e =>
                            this.onChange(e.target.value, "fundReleaseCost")
                          }
                          onBlur={e =>
                            this.onBlur(e.target.value, "fundReleaseCost")
                          }
                          min={0}
                        />
                        <span>Cr.</span>
                        <Form.Control.Feedback type="invalid">
                          {get(fundReleaseCostErr, "message")}
                        </Form.Control.Feedback>
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </>
            ) : null}
            <Form.Group className="field-select field-location">
              <Form.Label data-test="label-location">
                Location
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                {groupId == 78 ? (
                  <CreateProjectCircle
                    options={state}
                    error={locationsErr}
                    locations={locations}
                    status={status}
                    groupId={groupId}
                    originalLocations={originalLocations}
                    iigPayload={iigPayload}
                    iigMappingdetails={iigMappingdetails}
                    resetForm={resetForm}
                    isEdit={isEdit}
                    updateParentState={this.updateParentState}
                    updateParentStateError={this.updateParentStateError}
                    projectCost={cost}
                    previewData={previewData}
                    getDistrictListForLocation={getDistrictListForLocation}
                    getCircleListForLocation={getCircleListForLocation}
                    districtListForLocation={districtListForLocation}
                    districtErrormessage={districtErrormessage}
                    stateErrormessage={stateErrormessage}
                    onDistricterrorChange={this.handleDistrictError}
                    onStateerrorChange={this.handleStateError}
                    disabled={
                      (isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId) && {
                        location: true,
                        addMore: true,
                        district: true
                      }
                    }
                    {...costAndDistance}
                    iigProjectReferenceId={iigProjectReferenceId}
                  />
                ) : (
                  <CreateProjectLocation
                    options={state}
                    altLocation={this.altLocation}
                    error={locationsErr}
                    locations={locations}
                    groupId={groupId}
                    originalLocations={originalLocations}
                    iigPayload={iigPayload}
                    iigMappingdetails={iigMappingdetails}
                    resetForm={resetForm}
                    updateParentState={this.updateParentState}
                    updateParentStateError={this.updateParentStateError}
                    projectCost={cost}
                    getDistrictListForLocation={getDistrictListForLocation}
                    districtListForLocation={districtListForLocation}
                    stateErrormessage={stateErrormessage}
                    onStateerrorChange={this.handleStateError}
                    isUPproject={projectCreatedFrom == "UP"}
                    disabled={
                      (isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP") && {
                        location: true,
                        addMore: true,
                        district: true
                      }
                    }
                    {...costAndDistance}
                    iigProjectReferenceId={iigProjectReferenceId}
                    createdDate={this.state.createdDate}
                    isEdit={isEdit}
                  />
                )}
              </div>
            </Form.Group>
            {groupId == 78 ? (
              <>
                <Form.Group>
                  <Form.Label data-test="label-project-name">
                    Executing Agency Name
                    <span className="required">*</span>
                  </Form.Label>
                  <div className="form-field">
                    <Form.Control
                      data-test="project-name"
                      type="text"
                      placeholder={`Enter Executing Agency Name`}
                      onChange={e => {
                        this.onChange(e.target.value, "executingAgency");
                      }}
                      onBlur={e => {
                        this.onBlur(e.target.value, "executingAgency");
                      }}
                      value={executingAgency}
                      isInvalid={get(executingErr, "error")}
                    />
                    <Form.Control.Feedback type="invalid">
                      {get(executingErr, "message")}
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>
              </>
            ) : null}
            <Form.Group className="field-select">
              <Form.Label data-test="label-implementation-mode">
                Implementation Mode
                <span
                  className="required"
                  style={{ display: groupId == 78 ? "none" : null }}
                >
                  *
                </span>
              </Form.Label>
              <div className="form-field">
                {hasIIGProjectReferenceId ? (
                  <>
                    {this.createTemplatesFromPageDetail(
                      "implementationMode",
                      "Select Mode",
                      "implementationMode",
                      true
                    )}
                    {hasIIGProjectReferenceId && (
                      <p className="remaining-char iig-sector-id">
                        Implementation Mode from{" "}
                        {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}
                        :&nbsp;
                        {iigMappingdetails.implementationMode !== null
                          ? iigMappingdetails.implementationMode
                          : "N/A"}
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    {previewData == null && status != "DRAFT" ? (
                      <>
                        <CustomDropdown
                          options={[
                            {
                              value: "- Select Mode -",
                              label: "- Select Mode -"
                            },
                            ...(isValidArray(
                              pageDetail && pageDetail.implementationMode
                            )
                              ? pageDetail.implementationMode
                              : []
                            ).map(item => ({
                              value: item,
                              label: item
                            }))
                          ]}
                          height={"40px"}
                          //   width={"834.75px"}
                          className={"implementation-mode"}
                          page={"implementation-mode"}
                          menuClassName={"impmodeMenu"}
                          isEdit={isEdit}
                          value={implementationMode}
                          onChange={this.onChange}
                          error={get(error.implementationMode, "message")}
                        />

                        {get(error.implementationMode, "message") ? (
                          <div class="district-mandatory-text mt-2">
                            This field is required
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <>
                        {this.createTemplatesFromPageDetail(
                          "implementationMode",
                          "Select Mode",
                          "implementationMode",
                          true
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </Form.Group>
            {!isEdit &&
              implementationMode === "PRIVATE" &&
              projectCategoryId === GROUP_KEYS.CENTRAL && (
                <>
                  <Form.Group className="field-mscb plitags">
                    <Form.Label data-test="label-production-linked-incentives(pli)">
                      Production Linked Incentives (PLI)
                    </Form.Label>
                    <Form.Check
                      data-test="pli-yes-radio-button"
                      classname="plitagsyes"
                      type="radio"
                      label="Yes"
                      name="pli"
                      defaultChecked={get(this.state, "pli") === true}
                      value="true"
                      onChange={() => {
                        this.onChange(true, "pli");
                      }}
                    />
                    <Form.Check
                      data-test="pli-no-radio-button"
                      type="radio"
                      label="No"
                      name="pli"
                      defaultChecked={get(this.state, "pli") === false}
                      value="false"
                      onChange={() => {
                        this.onChange(false, "pli");
                      }}
                    />
                  </Form.Group>
                </>
              )}
            <DisplayByPermission
              display={
                displayAutocomplete ||
                (get(pageDetail, "displayAutocomplete") &&
                  status == "CRIP_DRAFT") ||
                (get(pageDetail, "displayAutocomplete") &&
                  status == undefined &&
                  isUserPMG) ||
                (get(pageDetail, "displayAutocomplete") &&
                  status == undefined &&
                  isStatePMG) ||
                (get(pageDetail, "displayAutocomplete") &&
                  status == undefined &&
                  isUserCentral) ||
                (proponenetGroupID == this.state.sponsoringDepartmentId &&
                  isStateDepartment)
              }
            >
              <Form.Group className="field-mscb">
                <Form.Label
                  data-test="label-proponent"
                  style={{ marginRight: "7px" }}
                >
                  Proponent
                  <span class="required">*</span>
                </Form.Label>
                <div class="d-flex flex-column proponent-container">
                  <AutoSuggestSelect
                    isLoading={autoSuggestApiLoading}
                    defaultSelected={defaultSelected}
                    name="projectAutoSuggest"
                    options={options}
                    onChange={
                      isStateDepartment || isStatePMG
                        ? this.onAutoSuggestChangeUsers
                        : this.onAutoSuggestChange
                    }
                    onOptionClick={
                      isStateDepartment || isStatePMG
                        ? this.onOptionClickForStatePMG
                        : this.onOptionClick
                    }
                    isInvalid={get(error, "defaultSelected.error")}
                    isStateDepartment={isStateDepartment}
                    isStatePMG={isStatePMG}
                    redBorder={redBorder}
                    onBlur={this.proponentBlur}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "defaultSelected.error") ? "error-show" : ""
                    }`}
                  >
                    {get(error, "defaultSelected.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </DisplayByPermission>
            <DisplayByPermission
              display={
                this.state.hasOwnProperty("showOtherPP") &&
                this.state.showOtherPP
              }
            >
              <Form.Group className="field-select field-location">
                <Form.Label>Additional Project Proponent</Form.Label>
                <div className="form-field">
                  <OtherPP
                    otherPP={otherPP}
                    projectId={get(this.state, "id")}
                    resetForm={resetForm}
                    updateParentState={this.updateParentState}
                    updateParentStateError={this.updateParentStateError}
                    isStateDepartment={isStateDepartment}
                    isStatePMG={isStatePMG}
                    OtherPPBlur={this.OtherPPBlur}
                    additionalPP={true}
                  />
                </div>
              </Form.Group>
            </DisplayByPermission>
            <CreateProjectExtension
              groupId={groupId}
              fieldName={"geo_coordinates"}
              onChange={(value, key) => {
                this.onChange(value, key);
              }}
              onBlur={(value, key) => {
                this.onBlur(value, key);
              }}
              geoCoordinates={geoCoordinates}
              projectCategoryId={projectCategoryId}
              geoCordinateError={geoCordinateError}
              isUPproject={projectCreatedFrom == "UP"}
            />

            <CreateProjectExtension
              groupId={groupId}
              fieldName={"geo_coordinated_attachment"}
              onFilesChange={file => {
                this.onProjectExtensionFilesChange(file);
              }}
              onFilesError={file => {
                this.onProjectExtensionFilesError(file);
              }}
              createFileTemplate={this.createProjectExtensionFilesTemplate}
              projectExtensionFiles={projectExtensionFiles}
              projectCategoryId={projectCategoryId}
            />

            {this.renderProjectMapField()}
            {this.renderIIGUserDetails()}
            <DisplayByPermission
              display={
                this.state.hasOwnProperty("pragatiReview") &&
                this.state.hasOwnProperty("pragatiReviewDates") &&
                !isIIGDraft &&
                this.state.projectCategoryId == "CENTRAL"
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-pragati">Pragati</h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label data-test="label-pragati-review">
                  Pragati Review
                </Form.Label>
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="pragatiReview"
                  checked={get(this.state, "pragatiReview") === true}
                  value={get(this.state, "pragatiReview")}
                  onChange={() => {
                    this.onChange(true, "pragatiReview");
                  }}
                  //disabled={get(this.state, "pragatiPipeline") === true}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="pragatiReview"
                  checked={get(this.state, "pragatiReview") === false}
                  value={get(this.state, "pragatiReview")}
                  onChange={() => {
                    this.onChange(false, "pragatiReview");
                  }}
                  className="pragati-review-check"
                  //disabled={get(this.state, "pragatiPipeline") === true}
                />
              </Form.Group>

              <Form.Group
                className="field-datepicker field-select field-location"
                style={{
                  display:
                    get(this.state, "pragatiReview") === false ? "none" : null
                }}
              >
                <Form.Label data-test="label-pragati-review-dates">
                  Pragati Review Dates
                  {get(this.state, "pragatiReview") === true && (
                    <span className="required">*</span>
                  )}
                </Form.Label>
                <div
                  className={`form-field ${
                    get(error, "pragatiReviewDates.error")
                      ? "error-field-set"
                      : ""
                  }`}
                >
                  <PragatiReviewDates
                    pragatiReviewDates={pragatiReviewDates}
                    resetForm={resetForm}
                    updateParentState={this.updateParentState}
                    updateParentStateError={this.updateParentStateError}
                    //disabled={get(this.state, "pragatiPipeline") === true}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "pragatiReviewDates.error") ? "error-show" : ""
                    }`}
                  >
                    {get(error, "pragatiReviewDates.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </DisplayByPermission>
            <DisplayByPermission
              display={
                this.state.hasOwnProperty("pragatiPipeline") &&
                this.state.hasOwnProperty("pragatiCycleDate") &&
                !isIIGDraft &&
                this.state.projectCategoryId == "CENTRAL" &&
                isUserPMG
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-pragati">Pragati Pipeline</h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label data-test="label-pragati-review">
                  Pragati Pipeline
                </Form.Label>
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="pragatiPipeline"
                  checked={get(this.state, "pragatiPipeline") === true}
                  value={get(this.state, "pragatiPipeline")}
                  onChange={() => {
                    this.onChange(true, "pragatiPipeline");
                  }}
                  //disabled={get(this.state, "pragatiReview") === true}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="pragatiPipeline"
                  checked={get(this.state, "pragatiPipeline") === false}
                  value={get(this.state, "pragatiPipeline")}
                  onChange={() => {
                    this.onChange(false, "pragatiPipeline");
                  }}
                  className="pragati-review-check"
                  //disabled={get(this.state, "pragatiReview") === true}
                />
              </Form.Group>

              <Form.Group
                className="field-datepicker field-mscb"
                style={{
                  display:
                    get(this.state, "pragatiPipeline") === false ? "none" : null
                }}
              >
                <Form.Label>
                  <span data-test="nip-inclusion-date">Pragati Cycle Date</span>

                  <span className="required">*</span>
                </Form.Label>
                <div>
                  <DatePicker
                    className={`${
                      get(error, "pragatiCycleDate.error")
                        ? "error-field-set"
                        : ""
                    }`}
                    onChange={value => this.onChange(value, "pragatiCycleDate")}
                    selected={get(this.state, "pragatiCycleDate")}
                    value={get(this.state, "pragatiCycleDate")}
                    //disabled={get(this.state, "pragatiReview") === true}
                    isClearable={get(this.state, "pragatiCycleDate")}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "pragatiCycleDate.error") ? "error-show" : ""
                    }`}
                  >
                    {get(error, "pragatiCycleDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </DisplayByPermission>
            <DisplayByPermission
              display={
                (this.state.hasOwnProperty("nipReview") &&
                  this.state.hasOwnProperty("nipReviewDate")) ||
                isIIGDraft
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-national-infrastructure-pipeline">
                  National Infrastructure Pipeline (NIP)
                </h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label>
                  <span data-test="label-nip">NIP</span>
                  {(isIIGDraft || isIIGProjectEdit) && (
                    <span className="required">*</span>
                  )}
                </Form.Label>
                <div class="d-flex flex-column align-items-start">
                  <div class="d-flex">
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="nipReview"
                      checked={get(this.state, "nipReview") === true}
                      value={get(this.state, "nipReview")}
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId
                      }
                      onChange={() => {
                        this.onChange(true, "nipReview");
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="nipReview"
                      checked={get(this.state, "nipReview") === false}
                      value={get(this.state, "nipReview")}
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId
                      }
                      onChange={() => {
                        this.onChange(false, "nipReview");
                      }}
                      className="pragati-review-check"
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "nipReview.error") ? "error-show" : ""
                    }`}
                  >
                    {get(error, "nipReview.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Form.Group className="field-datepicker field-mscb">
                <Form.Label>
                  <span data-test="nip-inclusion-date">NIP Inclusion Date</span>
                  {(isIIGDraft || isIIGProjectEdit) && (
                    <span className="required">*</span>
                  )}
                </Form.Label>
                <div>
                  <DatePicker
                    className={`${
                      get(error, "nipReviewDate.error") ? "error-field-set" : ""
                    }`}
                    onChange={value => this.onChange(value, "nipReviewDate")}
                    selected={get(this.state, "nipReviewDate")}
                    value={get(this.state, "nipReviewDate")}
                    disabled={
                      isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    }
                    isClearable={
                      !isIIGDraft &&
                      !isIIGProjectEdit &&
                      get(this.state, "nipReviewDate")
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "nipReviewDate.error") ? "error-show" : ""
                    }`}
                  >
                    {get(error, "nipReviewDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </DisplayByPermission>

            <DisplayByPermission
              display={
                this.state.hasOwnProperty("pmFoundationStone") &&
                this.state.hasOwnProperty("pmFoundationStoneDate") &&
                !isIIGDraft
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-pm-foundation-stone">
                  PM Foundation Stone
                </h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label data-test="label-pm-foundation-stone">
                  PM Foundation Stone
                </Form.Label>
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="pmFoundationStone"
                  checked={get(this.state, "pmFoundationStone") === true}
                  value={get(this.state, "pmFoundationStone")}
                  onChange={() => {
                    this.onChange(true, "pmFoundationStone");
                  }}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="pmFoundationStone"
                  checked={get(this.state, "pmFoundationStone") === false}
                  value={get(this.state, "pmFoundationStone")}
                  onChange={() => {
                    this.onChange(false, "pmFoundationStone");
                  }}
                  className="pragati-review-check"
                />
              </Form.Group>

              {get(this.state, "pmFoundationStone") == true && (
                <Form.Group>
                  <Form.Label>
                    <span>PM Foundation Stone ID</span>
                    {/* <span className="required">*</span> */}
                  </Form.Label>
                  <div className="" style={{ width: "24%" }}>
                    <InputGroup className="custom-override">
                      <InputGroup.Text className="label-pm-foundation">
                        FS-
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        value={
                          pmFoundationStoneId != null
                            ? pmFoundationStoneId.replace("FS-", "")
                            : ""
                        }
                        onChange={e =>
                          this.onChange(e.target.value, "pmFoundationStoneId")
                        }
                        placeholder="Enter PMFS ID"
                      />
                    </InputGroup>
                  </div>
                </Form.Group>
              )}

              <Form.Group className="field-datepicker field-mscb">
                <Form.Label data-test="label-pm-foundation-stone-date">
                  PM Foundation Stone Date
                </Form.Label>
                <DatePicker
                  onChange={value =>
                    this.onChange(value, "pmFoundationStoneDate")
                  }
                  selected={get(this.state, "pmFoundationStoneDate")}
                  value={get(this.state, "pmFoundationStoneDate")}
                  isClearable={get(this.state, "pmFoundationStoneDate")}
                  className="pragati-date"
                />
              </Form.Group>
            </DisplayByPermission>
            {/*CR 825 Code Starts */}
            <DisplayByPermission
              display={
                this.state.hasOwnProperty("cmPragatiYatra") &&
                this.state.hasOwnProperty("cmPragatiYatraDate") &&
                isBiharProjects
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-pm-foundation-stone">
                  CM PRAGATI Yatra
                </h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label data-test="label-pm-foundation-stone">
                  CM PRAGATI Yatra
                </Form.Label>
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="cmPragatiYatra"
                  checked={get(this.state, "cmPragatiYatra") === true}
                  value={get(this.state, "cmPragatiYatra")}
                  onChange={() => {
                    this.onChange(true, "cmPragatiYatra");
                  }}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="cmPragatiYatra"
                  checked={get(this.state, "cmPragatiYatra") === false}
                  value={get(this.state, "cmPragatiYatra")}
                  onChange={() => {
                    this.onChange(false, "cmPragatiYatra");
                  }}
                  className="pragati-review-check"
                />
              </Form.Group>

              <Form.Group className="field-datepicker field-mscb">
                <Form.Label data-test="label-pm-foundation-stone-date">
                  CM PRAGATI Yatra Date
                </Form.Label>
                <DatePicker
                  onChange={value => this.onChange(value, "cmPragatiYatraDate")}
                  selected={get(this.state, "cmPragatiYatraDate")}
                  value={get(this.state, "cmPragatiYatraDate")}
                  isClearable={get(this.state, "cmPragatiYatraDate")}
                  className="pragati-date"
                />
              </Form.Group>
            </DisplayByPermission>
            <DisplayByPermission
              display={
                this.state.hasOwnProperty("cmFoundationStone") &&
                this.state.hasOwnProperty("cmFoundationStoneDate") &&
                isBiharProjects
              }
            >
              <div className="fieldset-heading">
                <h2 data-test="section-label-pm-foundation-stone">
                  CM Foundation Stone
                </h2>
              </div>
              <Form.Group className="field-mscb">
                <Form.Label data-test="label-pm-foundation-stone">
                  CM Foundation Stone
                </Form.Label>
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="cmFoundationStone"
                  checked={get(this.state, "cmFoundationStone") === true}
                  value={get(this.state, "cmFoundationStone")}
                  onChange={() => {
                    this.onChange(true, "cmFoundationStone");
                  }}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="cmFoundationStone"
                  checked={get(this.state, "cmFoundationStone") === false}
                  value={get(this.state, "cmFoundationStone")}
                  onChange={() => {
                    this.onChange(false, "cmFoundationStone");
                  }}
                  className="pragati-review-check"
                />
              </Form.Group>

              <Form.Group className="field-datepicker field-mscb">
                <Form.Label data-test="label-pm-foundation-stone-date">
                  CM Foundation Stone Date
                </Form.Label>
                <DatePicker
                  onChange={value =>
                    this.onChange(value, "cmFoundationStoneDate")
                  }
                  selected={get(this.state, "cmFoundationStoneDate")}
                  value={get(this.state, "cmFoundationStoneDate")}
                  isClearable={get(this.state, "cmFoundationStoneDate")}
                  className="pragati-date"
                />
              </Form.Group>
            </DisplayByPermission>
            {projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={
                  this.state.hasOwnProperty("pmGatiShakti") || isIIGDraft
                }
              >
                <div className="fieldset-heading">
                  <h2 data-test="section-label-pm-gatishakti">PM Gatishakti</h2>
                </div>
                <Form.Group className="field-mscb">
                  <Form.Label data-test="label-pm-gatishakti">
                    PM Gatishakti
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    label="Yes"
                    name="pmGatiShakti"
                    checked={get(this.state, "pmGatiShakti") === true}
                    value={get(this.state, "pmGatiShakti")}
                    onChange={() => {
                      this.onChange(true, "pmGatiShakti");
                    }}
                    disabled={
                      isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    }
                  />
                  <Form.Check
                    type="radio"
                    label="No"
                    name="pmGatiShakti"
                    checked={get(this.state, "pmGatiShakti") === false}
                    value={get(this.state, "pmGatiShakti")}
                    onChange={() => {
                      this.onChange(false, "pmGatiShakti");
                    }}
                    className="pragati-review-check"
                    disabled={
                      isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    }
                  />
                </Form.Group>
              </DisplayByPermission>
            )}
            {projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={
                  (this.state.hasOwnProperty("pmgsHip") &&
                    this.state.hasOwnProperty("pmgsHipDate")) ||
                  isIIGDraft
                }
              >
                <div className="fieldset-heading">
                  <h2 data-test="section-label-pm-gatishakti">
                    PM Gatishakti (NPG)
                  </h2>
                </div>
                <Form.Group className="field-mscb">
                  <Form.Label data-test="label-pm-gatishakti">
                    PM Gatishakti (NPG)
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    label="Yes"
                    name="PmgsHip"
                    checked={get(this.state, "pmgsHip") === true}
                    //checked="true"
                    value={get(this.state, "pmgsHip")}
                    onChange={() => {
                      this.onChange(true, "pmgsHip");
                    }}
                    // disabled={
                    //   isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    // }
                  />
                  <Form.Check
                    type="radio"
                    label="No"
                    name="pmgsHip"
                    checked={get(this.state, "pmgsHip") === false}
                    value={get(this.state, "pmgsHip")}
                    onChange={() => {
                      this.onChange(false, "pmgsHip");
                    }}
                    className="pragati-review-check"
                    // disabled={
                    //   isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    // }
                  />
                </Form.Group>

                <Form.Group className="field-datepicker field-mscb">
                  <Form.Label data-test="label-pm-gatishakti-date">
                    PM Gatishakti (NPG) Date
                  </Form.Label>
                  <DatePicker
                    onChange={value => this.onChange(value, "pmgsHipDate")}
                    selected={get(this.state, "pmgsHipDate")}
                    value={get(this.state, "pmgsHipDate")}
                    // isClearable={
                    //   !isIIGDraft &&
                    //   !isIIGProjectEdit &&
                    //   iigProjectReferenceId === null &&
                    //   get(this.state, "pmgsHipDate")
                    // }
                    isClearable={get(this.state, "pmgsHipDate")}
                    className="pragati-date"
                    // disabled={
                    //   isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    // }
                  />
                </Form.Group>
              </DisplayByPermission>
            )}
            {((isEdit &&
              implementationMode === "PRIVATE" &&
              projectCategoryId === GROUP_KEYS.CENTRAL) ||
              projectData.status == "CRIP_DRAFT") && (
              <>
                <div className="fieldset-heading">
                  <h2 data-test="section-label-production-linked-incentives(pli)">
                    Production Linked Incentives (PLI)
                  </h2>
                </div>
                <Form.Group className="field-mscb">
                  <Form.Label data-test="label-pli">PLI</Form.Label>
                  <Form.Check
                    type="radio"
                    label="Yes"
                    name="pli"
                    checked={get(this.state, "pli") === true}
                    value={pliData}
                    onChange={() => {
                      this.onChange(true, "pli");
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="No"
                    name="pli"
                    checked={get(this.state, "pli") === false}
                    value={pliData}
                    onChange={() => {
                      this.onChange(false, "pli");
                    }}
                    className="pragati-review-check"
                  />
                </Form.Group>
              </>
            )}
            {isEdit && projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={
                  isPortConnectivityDTO &&
                  this.state.hasOwnProperty("portConnectivity")
                }
              >
                <>
                  <div className="fieldset-heading">
                    <h2 data-test="section-label-port-connectivity">
                      Port Connectivity
                    </h2>
                  </div>
                  <Form.Group className="field-mscb">
                    <Form.Label data-test="label-port-connectivity">
                      Port Connectivity
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="port"
                      defaultChecked={portConnectivityData}
                      value={portConnectivityData}
                      onChange={() => {
                        this.onChange(true, "portConnectivity");
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="port"
                      defaultChecked={!portConnectivityData}
                      value={portConnectivityData}
                      onChange={() => {
                        this.onChange(false, "portConnectivity");
                      }}
                      className="pragati-review-check"
                    />
                  </Form.Group>
                </>
              </DisplayByPermission>
            )}
            {isEdit && projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={
                  iscoalConnectivityDTO &&
                  this.state.hasOwnProperty("coalConnectivity")
                }
              >
                <>
                  <div className="fieldset-heading">
                    <h2 data-test="section-label-coal-evacuation">
                      Coal Evacuation
                    </h2>
                  </div>
                  <Form.Group className="field-mscb">
                    <Form.Label data-test="label-coal-evacuation">
                      Coal Evacuation
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="coal"
                      defaultChecked={coalConnectivityData}
                      value={coalConnectivityData}
                      onChange={() => {
                        this.onChange(true, "coalConnectivity");
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="coal"
                      defaultChecked={!coalConnectivityData}
                      value={coalConnectivityData}
                      onChange={() => {
                        this.onChange(false, "coalConnectivity");
                      }}
                      className="pragati-review-check"
                    />
                  </Form.Group>
                </>
              </DisplayByPermission>
            )}
            {isEdit && projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={
                  isesamikshaDTO && this.state.hasOwnProperty("esamiksha")
                }
              >
                <>
                  <div className="fieldset-heading">
                    <h2 data-test="section-label-esamiksha">eSamikSha</h2>
                  </div>
                  <Form.Group className="field-mscb">
                    <Form.Label data-test="label-esamiksha">
                      eSamikSha
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="esamiksha"
                      defaultChecked={esamikshaData}
                      value={esamikshaData}
                      onChange={() => {
                        this.onChange(true, "esamiksha");
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="esamiksha"
                      defaultChecked={!esamikshaData}
                      value={esamikshaData}
                      onChange={() => {
                        this.onChange(false, "esamiksha");
                      }}
                      className="pragati-review-check"
                    />
                  </Form.Group>
                </>
              </DisplayByPermission>
            )}
            {isEdit && projectCategoryId === GROUP_KEYS.CENTRAL && (
              <DisplayByPermission
                display={isMarch24DTO && this.state.hasOwnProperty("march24")}
              >
                <>
                  <div className="fieldset-heading">
                    <h2 data-test="section-label-march24">March'24</h2>
                  </div>
                  <Form.Group className="field-mscb">
                    <Form.Label data-test="label-march24">March'24</Form.Label>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="march24"
                      defaultChecked={march24Data}
                      value={march24Data}
                      onChange={() => {
                        this.onChange(true, "march24");
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="march24"
                      defaultChecked={!march24Data}
                      value={march24Data}
                      onChange={() => {
                        this.onChange(false, "march24");
                      }}
                      className="pragati-review-check"
                    />
                  </Form.Group>
                </>
              </DisplayByPermission>
            )}
            <div className="fieldset-heading">
              <h2 data-test="section-label-project-finance-details">
                Project Finance Details
              </h2>
            </div>
            <Form.Group
              className="field-cost"
              style={{
                display:
                  projectCategoryId == "CENTRAL" || projectCategoryId == null
                    ? "none"
                    : null
              }}
            >
              <Form.Label
                className="project-cost-title"
                data-test="label-project-cost"
              >
                Project Cost Share
                <span
                  className="required"
                  style={{
                    display:
                      (groupId == 78 && projectCategoryId == "STATE") ||
                      (groupId == 170 && projectCategoryId == "STATE")
                        ? null
                        : "none"
                  }}
                >
                  *
                </span>{" "}
                (in crores)
              </Form.Label>
              <div className="form-field">
                <div className="popup-wrapper cost">
                  <Form.Label data-test="label-original-cost">
                    Central Share
                    <span
                      className="required"
                      style={{
                        display: groupId == 78 || groupId == 170 ? null : "none"
                      }}
                    >
                      *
                    </span>
                  </Form.Label>

                  <span className="symbol-field-left original-cost">
                    <Form.Control
                      data-test="original-cost"
                      type="text"
                      value={centralCost}
                      isInvalid={get(centralCostErr, "error")}
                      onChange={e =>
                        this.onChange(e.target.value, "centralCost")
                      }
                      onBlur={e => this.onBlur(e.target.value, "centralCost")}
                      min={0}
                    />

                    <span>Cr.</span>
                    <Form.Control.Feedback type="invalid">
                      {get(centralCostErr, "message")}
                    </Form.Control.Feedback>
                  </span>
                  <TooltipComponent
                    classes="create_project_tolltip"
                    content={centralCostTooltip}
                  />
                </div>
                <div className="popup-wrapper revisedCost">
                  <Form.Label data-test="label-revised-cost">
                    State Share
                    <span
                      className="required"
                      style={{
                        display: groupId == 78 || groupId == 170 ? null : "none"
                      }}
                    >
                      *
                    </span>
                  </Form.Label>
                  <span className="symbol-field-left">
                    <Form.Control
                      data-test="original-cost"
                      type="text"
                      value={stateCost == null ? null : stateCost}
                      isInvalid={get(stateCostErr, "error")}
                      onChange={e => this.onChange(e.target.value, "stateCost")}
                      onBlur={e => this.onBlur(e.target.value, "stateCost")}
                      min={0}
                    />

                    <span>Cr.</span>
                    <Form.Control.Feedback type="invalid">
                      {get(stateCostErr, "message")}
                    </Form.Control.Feedback>
                  </span>
                  <TooltipComponent
                    classes="create_project_tolltip"
                    content={stateCostTooltip}
                  />
                </div>
              </div>
            </Form.Group>
            {(isValidArray(arSchemesList) && (
              <Form.Group
                className="field-select"
                style={{ display: groupId == 78 ? null : "none" }}
              >
                <Form.Label data-test="label-project-schemes">
                  Project Scheme<span className="required">*</span>
                </Form.Label>
                <div className="form-field">
                  <Form.Control
                    type="text"
                    placeholder="Enter Project Scheme Name"
                    onChange={e => this.onChange(e.target.value, "schemeForAr")}
                    onBlur={e => this.onBlur(e.target.value, "schemeForAr")}
                    value={schemeForAr}
                    isInvalid={get(schemeForArErr, "error")}
                  />
                  <Form.Control.Feedback type="invalid">
                    {get(schemeForArErr, "message")}
                  </Form.Control.Feedback>
                </div>

                {/* <div className="form-field">
                  {this.createTemplateFromState(
                    "arSchemesList",
                    "Select Scheme",
                    "schemeId"
                  )}
                </div> */}
              </Form.Group>
            )) ||
              null}
            {(isValidArray(sponsoringAgencyList) && (
              <Form.Group
                className="field-select"
                style={{ display: groupId == 78 ? null : "none" }}
              >
                <Form.Label data-test="label-project-schemes">
                  Sponsoring Agency<span className="required">*</span>
                </Form.Label>
                <div className="form-field">
                  {this.createTemplateFromState(
                    "sponsoringAgencyList",
                    "Select Sponsoring Agency",
                    "sponsoringAgency"
                  )}
                </div>
              </Form.Group>
            )) ||
              null}
            <Form.Group
              className="field-mscb"
              style={{ display: groupId == 78 ? "none" : null }}
            >
              <Form.Label data-test="label-sponsoring-bank-nbfc-name">
                Sponsoring Bank / NBFC Name
              </Form.Label>
              <div className="form-field">
                <div className="field-mscb-search">
                  <Form.Control
                    data-test="search-sponsoring-bank"
                    type="text"
                    placeholder="Search"
                    onChange={this.onSearchBanks}
                  />
                  <PerfectScrollbar
                    data-test="bank-list-container"
                    className="field-mscb-scroll"
                    containerRef={ref => {
                      this._scrollRef = ref;
                    }}
                  >
                    <div className={`field-mscb-wrapper ${this.extraMargin}`}>
                      {this.createBankTemplate(bank)}
                    </div>
                  </PerfectScrollbar>
                </div>
                {this.activeBanksTemplate()}
              </div>
            </Form.Group>
            <Form.Group className="field-datepicker">
              <Form.Label data-test="label-date-of-financial-closure-expected">
                Date of Financial Closure Expected
              </Form.Label>
              <div className="form-field">
                <DatePicker
                  onChange={value =>
                    this.onChange(value, "projectBankInfoExpectedDate")
                  }
                  selected={projectBankInfoExpectedDate}
                  value={projectBankInfoExpectedDate}
                  isClearable={
                    !isIIGDraft &&
                    !isIIGProjectEdit &&
                    iigProjectReferenceId === null &&
                    projectBankInfoExpectedDate
                  }
                  disabled={
                    isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                  }
                  className="data-test-class-date-of-financial-closure-expected"
                />
              </div>
            </Form.Group>
            <Form.Group className="field-datepicker">
              <Form.Label data-test="label-date-of-financial-closure-actual">
                Date of Financial Closure Actual
              </Form.Label>
              <div className="form-field">
                <DatePicker
                  onChange={value =>
                    this.onChange(value, "projectBankInfoActualDate")
                  }
                  selected={projectBankInfoActualDate}
                  value={projectBankInfoActualDate}
                  minDate={projectBankInfoActualDate}
                  isClearable={
                    !isIIGDraft &&
                    !isIIGProjectEdit &&
                    iigProjectReferenceId === null &&
                    projectBankInfoActualDate
                  }
                  disabled={
                    isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                  }
                  className="data-test-class-date-of-financial-closure-actual"
                />
              </div>
            </Form.Group>
            <div className="fieldset-heading">
              <h2 data-test="section-label-implementation-details">
                Implementation Details
              </h2>
            </div>
            <Form.Group className="field-checkbox field-project-clasification">
              <Form.Label data-test="label-project-classification">
                Project Classification
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                <div
                  className={`form-field-data ${get(
                    classificationErr,
                    "error"
                  ) && "error-field"}`}
                >
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationClassification ===
                      projectClassification[0]
                        ? "checked"
                        : isIIGDraft ||
                          isIIGProjectEdit ||
                          hasIIGProjectReferenceId ||
                          projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input type="radio" name="classification" />
                    <Form.Text
                      data-test="brown-field-radio-button"
                      className="form-checkbox-label"
                      onClick={() => {
                        !isIIGDraft &&
                          !isIIGProjectEdit &&
                          iigProjectReferenceId === null &&
                          this.onBlur(
                            projectClassification[0],
                            "projectImplementationClassification"
                          );
                      }}
                    >
                      <div className="checkbox-image">
                        <Image src={BrownField} alt="Brown Field" />
                      </div>
                      <div
                        className="checkbox-text"
                        data-test="label-brown-field"
                      >
                        Brown Field
                      </div>
                    </Form.Text>
                  </Form.Check>
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationClassification ===
                      projectClassification[1]
                        ? "checked"
                        : isIIGDraft ||
                          isIIGProjectEdit ||
                          hasIIGProjectReferenceId ||
                          projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input type="radio" name="classification" />
                    <Form.Text
                      data-test="green-field-radio-button"
                      className="form-checkbox-label"
                      onClick={() => {
                        !isIIGDraft &&
                          !isIIGProjectEdit &&
                          iigProjectReferenceId === null &&
                          this.onBlur(
                            projectClassification[1],
                            "projectImplementationClassification"
                          );
                      }}
                    >
                      <div className="checkbox-image">
                        <Image src={GreenField} alt="Green Field" />
                      </div>
                      <div
                        className="checkbox-text"
                        data-test="label-green-field"
                      >
                        Green Field
                      </div>
                    </Form.Text>
                  </Form.Check>
                </div>
                <Form.Control.Feedback type="invalid">
                  {get(classificationErr, "message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            <Form.Group className="field-checkbox field-implementation-started">
              <Form.Label data-test="label-implementation-started">
                Project Stage
                <span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                <div
                  className={`form-field-data ${get(startStateErr, "error") &&
                    "error-field"}`}
                >
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[1]
                        ? "checked"
                        : isIIGDraft ||
                          isIIGProjectEdit ||
                          hasIIGProjectReferenceId ||
                          projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="implementation-no"
                      type="checkbox"
                      name="started_implementation"
                    />
                    <Form.Text
                      data-test="label-no"
                      className="form-checkbox-label"
                      style={{ textTransform: "none", fontSize: 13 }}
                      onClick={() => {
                        !isIIGDraft &&
                          !isIIGProjectEdit &&
                          iigProjectReferenceId === null &&
                          this.onBlur(
                            implementationStart[1],
                            "projectImplementationStartState"
                          );
                      }}
                    >
                      Implementation Not Started
                    </Form.Text>
                  </Form.Check>
                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[0]
                        ? "checked"
                        : isIIGDraft ||
                          isIIGProjectEdit ||
                          hasIIGProjectReferenceId ||
                          projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="implementation-yes"
                      type="checkbox"
                      name="started_implementation"
                    />
                    <Form.Text
                      data-test="label-yes"
                      className="form-checkbox-label"
                      style={{ textTransform: "none", fontSize: 13 }}
                      onClick={() => {
                        !isIIGDraft &&
                          !isIIGProjectEdit &&
                          iigProjectReferenceId === null &&
                          this.onBlur(
                            implementationStart[0],
                            "projectImplementationStartState"
                          );
                      }}
                    >
                      &nbsp;Under Implementation
                    </Form.Text>
                  </Form.Check>

                  <Form.Check
                    className={`form-checkbox ${
                      projectImplementationStartState === implementationStart[2]
                        ? "checked"
                        : isIIGDraft ||
                          isIIGProjectEdit ||
                          hasIIGProjectReferenceId ||
                          projectCreatedFrom == "UP"
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <Form.Check.Input
                      data-test="implementation-completed"
                      type="checkbox"
                      name="started_implementation"
                    />
                    <Form.Text
                      data-test="label-completed"
                      className="form-checkbox-label"
                      style={{ textTransform: "none", fontSize: 13 }}
                      onClick={() => {
                        isEdit &&
                        projectStatusWithRespectToIssueStatus === "OPEN"
                          ? this.setState({ isConfirmModalVisible: true })
                          : !isIIGDraft &&
                            !isIIGProjectEdit &&
                            iigProjectReferenceId === null &&
                            this.onBlur(
                              implementationStart[2],
                              "projectImplementationStartState"
                            );
                      }}
                    >
                      Completed
                    </Form.Text>
                  </Form.Check>
                </div>
                {hasIIGProjectReferenceId && (
                  <p className="remaining-char iig-sector-id">
                    Project Stage from{" "}
                    {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}
                    :&nbsp;
                    {iigMappingdetails.projectStage !== null
                      ? iigMappingdetails.projectStage
                      : " N/A"}
                  </p>
                )}
                <Form.Control.Feedback type="invalid">
                  {get(startStateErr, "message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            {projectImplementationStartState === "UNDER_IMPLEMENTATION" &&
            this.state.groupId == 37 ? (
              <Status
                options={[
                  {
                    "data-test": "under-construction",
                    label: "Under Construction",
                    value: "underConstruction",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked:
                      (projectCompletionDTO &&
                        /Construction/gi.test(projectCompletionDTO.status)) ||
                      false,
                    name: "statusfields"
                  },
                  {
                    "data-test": "partially-commissioned",
                    label: "Provisionally Commissioned",
                    value: "provisionallyCommissioned",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId,
                    checked:
                      (projectCompletionDTO &&
                        /provisionally/gi.test(projectCompletionDTO.status)) ||
                      false,
                    type: "radio",
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                onChange={onSelectStatus}
                //error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                financialPercentageErr={financialPercentageErr}
                isEdit={isEdit}
                dateErr={dateErr}
                isRequired={!pli}
                progressAsofDateErr={progressAsofDateErr}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isUPproject={projectCreatedFrom == "UP"}
              />
            ) : null}
            {projectImplementationStartState === "UNDER_IMPLEMENTATION" &&
            this.state.groupId != 37 ? (
              <Status
                options={[
                  {
                    "data-test": "under-construction",
                    label: "Under Construction",
                    value: "underConstruction",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked:
                      (projectCompletionDTO &&
                        /Construction/gi.test(projectCompletionDTO.status)) ||
                      false,
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                onChange={onSelectStatus}
                //error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                financialPercentageErr={financialPercentageErr}
                isEdit={isEdit}
                dateErr={dateErr}
                isRequired={!pli}
                progressAsofDateErr={progressAsofDateErr}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isUPproject={projectCreatedFrom == "UP"}
              />
            ) : null}
            {(isIIGDraft || hasIIGProjectReferenceId) && (
              <Form.Group className="form-group">
                <Form.Label>
                  <span>
                    {targetDate >= dateAfterCrip || isEdit ? "CRIP" : "IIG"}{" "}
                    Project Status
                  </span>
                  <span className="required">*</span>
                </Form.Label>
                <div className="form-field">
                  <Form.Control
                    type="text"
                    value={iigProjectStatus}
                    disabled={true}
                  />
                </div>
              </Form.Group>
            )}
            {projectImplementationStartState ===
            "IMPLEMENTATION_NOT_STARTED" ? (
              <Status
                options={[
                  {
                    "data-test": "under-development",
                    label: "Under Development",
                    value: "underDelopment",
                    type: "radio",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP",
                    checked: true,
                    name: "statusfields"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                onChange={onSelectStatus}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                disabledFields={{ date: false, percentage: true }}
                error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                financialPercentageErr={financialPercentageErr}
                dateErr={dateErr}
                isEdit={isEdit}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isUPproject={projectCreatedFrom == "UP"}
              />
            ) : null}
            {projectImplementationStartState === "COMPLETED" &&
            groupId == 37 ? (
              <>
                <Status
                  options={[
                    {
                      "data-test": "under-construction",
                      label: "Physically Completed/CC Under Issue",
                      value: "projectPhysicallyCompleted",
                      type: "radio",
                      disabled:
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP",
                      checked:
                        (projectCompletionDTO &&
                          /Physically/gi.test(projectCompletionDTO.status)) ||
                        false,
                      name: "statusfields"
                    },

                    {
                      "data-test": "partially-commissioned",
                      label: "Commissioned",
                      value: "commissioned",
                      disabled:
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP",
                      checked:
                        (projectCompletionDTO &&
                          /Commissioned/gi.test(projectCompletionDTO.status)) ||
                        false,
                      type: "radio",
                      name: "statusfields"
                    }
                  ]}
                  projectCompletionDTO={projectCompletionDTO}
                  projectStatus={status}
                  onChange={onSelectStatus}
                  projectImplementationStartState={
                    projectImplementationStartState
                  }
                  disabledFields={{ date: false, percentage: true }}
                  error={projectCompletionDTOErr}
                  updateParentStateError={this.updateParentStateError}
                  percentageErr={percentageErr}
                  financialPercentageErr={financialPercentageErr}
                  progressAsofDateErr={progressAsofDateErr}
                  dateErr={dateErr}
                  isEdit={isEdit}
                  isRequired={!pli}
                  isIIGProjectEdit={isIIGProjectEdit}
                  iigProjectReferenceId={iigProjectReferenceId}
                  projectstageerror={this.state.projectstageerror}
                  isUPproject={projectCreatedFrom == "UP"}
                />

                {isUserPMG == true &&
                isEdit == true &&
                projectCompletionDTOErr.error == true ? (
                  <>
                    <div
                      className="error-field error-message"
                      style={{
                        marginTop: isEdit == true ? "-2%" : "-1%",
                        marginBottom: "1%",
                        color: "#fc192e",
                        fontSize: 11,
                        fontWeight: "bold",
                        marginLeft: "32%"
                      }}
                    >
                      <i>This field is required.</i>
                    </div>
                  </>
                ) : null}
              </>
            ) : null}
            {projectImplementationStartState === "COMPLETED" &&
            groupId != 37 ? (
              <Status
                options={[
                  {
                    "data-test": "commissioned",
                    label: "Commissioned",
                    value: "commissioned",
                    checked: true,
                    type: "radio",
                    name: "statusfields",
                    disabled:
                      isIIGDraft ||
                      isIIGProjectEdit ||
                      hasIIGProjectReferenceId ||
                      projectCreatedFrom == "UP"
                  }
                ]}
                projectCompletionDTO={projectCompletionDTO}
                projectStatus={status}
                onChange={onSelectStatus}
                projectImplementationStartState={
                  projectImplementationStartState
                }
                disabledFields={{ date: false, percentage: true }}
                error={projectCompletionDTOErr}
                updateParentStateError={this.updateParentStateError}
                percentageErr={percentageErr}
                financialPercentageErr={financialPercentageErr}
                dateErr={dateErr}
                isEdit={isEdit}
                isIIGProjectEdit={isIIGProjectEdit}
                iigProjectReferenceId={iigProjectReferenceId}
                isUPproject={projectCreatedFrom == "UP"}
              />
            ) : null}
            {(projectImplementationStartState === implementationStart[0] ||
              projectImplementationStartState === implementationStart[1] ||
              projectImplementationStartState === implementationStart[2]) && (
              <Form.Group className="field-datepicker">
                <Form.Label
                  data-test="label-project-sanction-date"
                  style={{ marginRight: "9px" }}
                  className="popup-wrapper-sanction-date"
                >
                  Sanction Date
                  {(!isEdit || (!isUserPMG && !isStatePMG)) && !isIIGDraft && (
                    <span className="required">*</span>
                  )}
                  <TooltipComponent
                    classes="create_project_tolltip sanction_date_tooltip"
                    placement="right"
                    content={
                      <div className="sanction-tooltip-table">
                        <table className="sanction-table">
                          <thead className="sanction-table__head">
                            <tr>
                              <th className="sanction-table__header">
                                Project Cost
                              </th>
                              <th className="sanction-table__header">
                                Sanction Date
                              </th>
                            </tr>
                          </thead>

                          <tbody className="sanction-table__body">
                            <tr className="sanction-table__row">
                              <td className="sanction-table__cell">
                                Up to ₹100 crore
                              </td>
                              <td className="sanction-table__cell">
                                Date of the Secretary’s sanction/approval
                              </td>
                            </tr>

                            <tr className="sanction-table__row">
                              <td className="sanction-table__cell">
                                Above ₹100 crore to ₹500 crore
                              </td>
                              <td className="sanction-table__cell">
                                Date of the Minister's signature
                              </td>
                            </tr>

                            <tr className="sanction-table__row">
                              <td className="sanction-table__cell">
                                Above ₹500 crore to ₹1,000 crore
                              </td>
                              <td className="sanction-table__cell">
                                Date of the final required approval, i.e.
                                Finance Minister's signature date
                              </td>
                            </tr>

                            <tr className="sanction-table__row">
                              <td className="sanction-table__cell">
                                Above ₹1,000 crore
                              </td>
                              <td className="sanction-table__cell">
                                Date of the Cabinet Sanction Letter/
                                <br />
                                communication issued after Cabinet approval
                              </td>
                            </tr>
                            <tr className="sanction-table__row">
                              <td className="sanction-table__cell">
                                PSU Projects
                              </td>
                              <td className="sanction-table__cell">
                                Date of approval by the Competent authority
                                <br />
                                (Head of PSU/ Board of Directors etc.)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    }
                  />
                </Form.Label>
                <div>
                  <div className="form-field" style={{ marginLeft: "-1.5%" }}>
                    <DatePicker
                      data-test="project-sanction-date"
                      selected={projectImplementationSanctionDate}
                      disabled={projectCreatedFrom == "UP"}
                      onChange={value => {
                        this.onChange(
                          value,
                          "projectImplementationSanctionDate"
                        );
                      }}
                      value={projectImplementationSanctionDate}
                      isClearable={
                        projectImplementationSanctionDate &&
                        projectCreatedFrom != "UP"
                      }
                      isInvalid={
                        !isIIGDraft
                          ? get(
                              error,
                              "projectImplementationSanctionDate.error"
                            )
                          : false
                      }
                      className={`data-test-class-sanction-date ${
                        get(error, "projectImplementationSanctionDate.error") &&
                        ((!isEdit || (!isUserPMG && !isStatePMG)) &&
                          !isIIGDraft)
                          ? "error-field-set"
                          : ""
                      }`}
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      (get(error, "projectImplementationSanctionDate.error") &&
                        !isEdit) ||
                      !isUserPMG
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationSanctionDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            )}

            {(projectImplementationStartState === implementationStart[0] ||
              projectImplementationStartState === implementationStart[1] ||
              projectImplementationStartState === implementationStart[2]) && (
              <Form.Group className="field-datepicker">
                <Form.Label
                  data-test="label-implementation-start-date"
                  style={{ marginRight: "9px" }}
                >
                  Implementation Start Date
                  {!isIIGDraft &&
                  !isEdit &&
                  (showStartDateMandatory || implementationMode !== "") ? (
                    <span className="required">*</span>
                  ) : null}
                </Form.Label>
                <div>
                  <div className="form-field" style={{ marginLeft: "-1.5%" }}>
                    <DatePicker
                      data-test="implementation-start-date"
                      selected={projectImplementationStartDate}
                      isRequired={!pli}
                      onChange={value => {
                        this.onChange(value, "projectImplementationStartDate");
                      }}
                      value={projectImplementationStartDate}
                      isClearable={
                        !isIIGDraft &&
                        !isIIGProjectEdit &&
                        iigProjectReferenceId === null &&
                        projectImplementationStartDate &&
                        projectCreatedFrom != "UP"
                      }
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                      isInvalid={get(
                        error,
                        "projectImplementationStartDate.error"
                      )}
                      className={`data-test-class-implementation-start-date ${
                        get(error, "projectImplementationStartDate.error") &&
                        !isIIGDraft &&
                        !pli &&
                        !isEdit
                          ? "error-field-set"
                          : ""
                      }`}
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "projectImplementationStartDate.error") &&
                      !isEdit
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationStartDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            )}
            {projectImplementationStartState === "IMPLEMENTATION_NOT_STARTED" ||
            projectImplementationStartState === "COMPLETED" ? (
              <Form.Group className="field-datepicker">
                <Form.Label
                  data-test="label-original-date-of-completion"
                  style={{ marginRight: "9px" }}
                >
                  Original Date Of Completion
                  {!isSuperAdmin && (showAnticipatedMandatory || !pli) && (
                    <span className="required">*</span>
                  )}
                </Form.Label>
                <div>
                  <div className="form-field" style={{ marginLeft: "-1.5%" }}>
                    <DatePicker
                      isClearable={
                        !isIIGDraft &&
                        !isIIGProjectEdit &&
                        iigProjectReferenceId === null &&
                        projectImplementationAnticipatedDate &&
                        projectCreatedFrom != "UP"
                      }
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                      selected={projectImplementationAnticipatedDate}
                      value={projectImplementationAnticipatedDate}
                      onChange={value => {
                        this.onChange(
                          value,
                          "projectImplementationAnticipatedDate"
                        );
                      }}
                      isInvalid={get(
                        error,
                        "projectImplementationAnticipatedDate.error"
                      )}
                      className={`data-test-class-original-date-of-completion ${
                        get(
                          error,
                          "projectImplementationAnticipatedDate.error"
                        ) &&
                        !isSuperAdmin &&
                        (showAnticipatedMandatory || !pli)
                          ? "error-field-set"
                          : ""
                      }`}
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "projectImplementationAnticipatedDate.error")
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationAnticipatedDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            ) : null}
            {projectImplementationStartState === implementationStart[0] && (
              <Form.Group className="field-datepicker">
                <Form.Label
                  data-test="label-original-date-of-completion"
                  style={{ marginRight: "7px" }}
                >
                  Original Date Of Completion
                  {((!isSuperAdmin && (showAnticipatedMandatory || !pli)) ||
                    !isIIGDraft) &&
                    !isUserPMG && <span className="required">*</span>}
                </Form.Label>
                <div>
                  <div className="form-field" style={{ marginLeft: "-1.5%" }}>
                    <DatePicker
                      isClearable={
                        projectImplementationAnticipatedDate &&
                        !isIIGDraft &&
                        iigProjectReferenceId === null &&
                        !isIIGProjectEdit &&
                        projectCreatedFrom != "UP"
                      }
                      selected={projectImplementationAnticipatedDate}
                      value={projectImplementationAnticipatedDate}
                      onChange={value => {
                        this.onChange(
                          value,
                          "projectImplementationAnticipatedDate"
                        );
                      }}
                      isInvalid={get(
                        error,
                        "projectImplementationAnticipatedDate.message"
                      )}
                      className={`data-test-class-original-date-of-completion ${
                        get(
                          error,
                          "projectImplementationAnticipatedDate.error"
                        ) &&
                        !isSuperAdmin &&
                        (showAnticipatedMandatory || !pli)
                          ? "error-field-set"
                          : ""
                      }`}
                      disabled={
                        iigPayload !== null ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                    />
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className={`${
                      get(error, "projectImplementationAnticipatedDate.error")
                        ? "error-show"
                        : ""
                    }`}
                  >
                    {get(error, "projectImplementationAnticipatedDate.message")}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            )}
            {projectImplementationStartState === "IMPLEMENTATION_NOT_STARTED" ||
            projectImplementationStartState === "UNDER_IMPLEMENTATION" ||
            this.state.revisedtargetfielddisplay == true ||
            projectCompletionDTO.status == "projectPhysicallyCompleted" ||
            projectCompletionDTO.status ==
              "PHYSICALLY COMPLETED/CC UNDER ISSUE" ? (
              <Form.Group className="field-datepicker">
                <Form.Label data-test="label-revised-target-date-of-completion">
                  Revised Target Date of Completion
                </Form.Label>
                <div>
                  <div
                    className="form-field"
                    style={{ width: 206, marginLeft: "-1.5%" }}
                  >
                    <DatePicker
                      isClearable={
                        !isIIGDraft &&
                        !isIIGProjectEdit &&
                        iigProjectReferenceId === null &&
                        revisedTargetCompletionDate &&
                        projectCreatedFrom != "UP"
                      }
                      selected={revisedTargetCompletionDate}
                      value={revisedTargetCompletionDate}
                      onChange={value => {
                        this.onChange(value, "revisedTargetCompletionDate");
                      }}
                      disabled={
                        isIIGDraft ||
                        isIIGProjectEdit ||
                        hasIIGProjectReferenceId ||
                        projectCreatedFrom == "UP"
                      }
                      className="data-test-class-revised-targeted-date-of-completion"
                    />
                  </div>
                </div>
              </Form.Group>
            ) : null}
            {(projectImplementationStartState === implementationStart[0] ||
              projectImplementationStartState === implementationStart[1] ||
              projectImplementationStartState === implementationStart[2]) &&
              projectCategoryId === GROUP_KEYS.CENTRAL && (
                <Form.Group className="field-datepicker field-select">
                  <Form.Label data-test="label-secretary-review-date">
                    Secretary Review Date
                  </Form.Label>
                  <div className="form-field">
                    <SecretaryReviewDate
                      projectImplementationSecretaryReviewDate={
                        projectImplementationSecretaryReviewDate
                      }
                      resetForm={resetForm}
                      updateParentState={this.updateParentState}
                      updateParentStateError={this.updateParentStateError}
                      isFormTypeNotDefault={isFormTypeNotDefault}
                    />
                  </div>
                </Form.Group>
              )}
            <Form.Group className="field-employment-generation">
              <Form.Label data-test="label-anticipated-employment-generation">
                Anticipated Employment Generation
              </Form.Label>
              <div className="form-field">
                <div className="form-label-animate">
                  <Form.Control
                    data-test="direct"
                    type="text"
                    onChange={e => {
                      this.onChange(
                        e.target.value,
                        "projectImplementationDirectEmployment"
                      );
                    }}
                    value={projectImplementationDirectEmployment}
                    disabled={
                      isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    }
                  />
                  <label data-test="label-direct">Direct</label>
                </div>
                <div className="form-label-animate">
                  <Form.Control
                    data-test="indirect"
                    type="text"
                    onChange={e => {
                      this.onChange(
                        e.target.value,
                        "projectImplementationInDirectEmployment"
                      );
                    }}
                    value={projectImplementationInDirectEmployment}
                    disabled={
                      isIIGDraft || isIIGProjectEdit || hasIIGProjectReferenceId
                    }
                  />
                  <label data-test="label-indirect">Indirect</label>
                </div>
              </div>
            </Form.Group>

            <CreateProjectExtension
              groupId={groupId}
              fieldName={"population_benefitted"}
              populationBenefitted={populationBenefitted}
              onChange={(value, key) => {
                this.onChange(value, key);
              }}
              onBlur={(value, key) => {
                this.onBlur(value, key);
              }}
            />
            {!isEdit &&
            getBucketsWithMilestonesBySectorData &&
            getBucketsWithMilestonesBySectorData.data &&
            bucketMilestoneCOS.length != 0 &&
            getBucketsWithMilestonesBySectorData.data.length &&
            !isIIGDraft &&
            !isIIGProjectEdit ? (
              <React.Fragment>
                <div
                  className="fieldset-heading"
                  style={{
                    marginBottom: displayCabinetMilestones ? 25 : 20
                  }}
                >
                  <h2 data-test="label-project-milestones">
                    Project Milestones
                  </h2>
                </div>
                {/* <div
                  className="cabinet_milestones_btn"
                  onClick={this.displayCabinetMilestones}
                  style={{
                    display:
                      (revisedCost != null && revisedCost !== ""
                        ? revisedCost
                        : cost) >= 1000 ||
                      // &&
                      // ["872", "879"].includes(sectorId)
                      implementationMode == "PRIVATE" ||
                      projectCategoryId != "CENTRAL"
                        ? "none"
                        : null,
                    marginBottom: displayCabinetMilestones ? 0 : 50
                  }}
                > */}
                <div
                  className="cabinet_milestones_btn"
                  onClick={this.displayCabinetMilestones}
                  style={{
                    display:
                      (isCostBasedGroup && effectiveCost >= 1000) ||
                      implementationMode == "PRIVATE" ||
                      projectCategoryId != "CENTRAL"
                        ? "none"
                        : null,
                    marginBottom: displayCabinetMilestones ? 0 : 50
                  }}
                >
                  <Image
                    src={
                      displayCabinetMilestones
                        ? IconDelete
                        : cabinet_milestones_btn
                    }
                  />
                </div>
                {/* {(displayCabinetMilestones &&
                  bucketMilestoneCOS.some(
                    item =>
                      item.bucketName === "Cabinet Milestone" &&
                      item.disabled === false
                  )) ||
                (projectCategoryId == "CENTRAL" &&
                  (revisedCost != null && revisedCost !== ""
                    ? revisedCost
                    : cost) >= 1000 &&
                  bucketMilestoneCOS.some(
                    item => item.bucketName === "Cabinet Milestone"
                  ) &&
                  //   &&
                  // ["872", "879"].includes(sectorId)
                  implementationMode != "PRIVATE") ? ( */}

                {(displayCabinetMilestones &&
                  bucketMilestoneCOS.some(
                    item =>
                      item.bucketName === "Cabinet Milestone" &&
                      item.disabled === false
                  )) ||
                (projectCategoryId == "CENTRAL" &&
                  isCostBasedGroup &&
                  effectiveCost >= 1000 &&
                  bucketMilestoneCOS.some(
                    item => item.bucketName === "Cabinet Milestone"
                  ) &&
                  implementationMode != "PRIVATE") ? (
                  <>
                    <div
                      class="pmg-heading-container"
                      style={{ marginBottom: -15 }}
                    >
                      <div class="left-border" />
                      <h2>CABINET MILESTONES</h2>
                    </div>
                    <Bucket
                      draftLocation={this.state.draftLocation}
                      onStateWisePhaseChange={this.onStateWisePhaseChange}
                      pageDetail={
                        window.location.pathname == "/create-project"
                          ? pageDetail && pageDetail.state
                          : this.props.locations
                      }
                      sponsoredByCategory={sponsoredByCategory == "CENTRAL"}
                      onChange={this.onBucketChangesCabinet}
                      cabinetbucketId={
                        (_selectedBucketCabinet &&
                          _selectedBucketCabinet.bucketId) ||
                        null
                      }
                      bucketMilestoneCOS={bucketMilestoneCOS
                        .filter(item => item.bucketName === "Cabinet Milestone")
                        .slice(-1)}
                      milestoneData={sortBy(
                        getBucketsWithMilestonesBySectorData.data
                          .filter(
                            item => item.bucket.name === "Cabinet Milestone"
                          )
                          .slice(-1),
                        "bucket.id"
                      )}
                      milestoneTableDataCOS={Cabinetdata}
                      milestoneDataCOS={milestoneDataCOS}
                      cabinetMilestone={true}
                      responsibleAuthority={getResponsibleAuthorityData.data}
                      _selectedBucketData={_selectedBucketCabinet}
                      createMilestoneAction={createMilestoneAction}
                      saveNewMilestoneAction={saveNewMilestoneAction}
                      deleteNewMilestoneAction={deleteNewMilestoneAction}
                      milestoneError={
                        isCabinetMandatoryActive
                          ? isEdit
                            ? cabinetMilestoneError
                            : milestoneError
                          : false
                      }
                      isCabinetMilestoneMandatoryExempt={
                        !isCabinetMandatoryActive
                      }
                      // isCabinetMilestoneMandatoryEditExempt={this.isCabinetMilestoneMandatoryExempt()}
                      handleTableOrder={this.handleTableOrderCabinet}
                      draftMilestoneAction={_updateDraftedMilestones}
                      projectMilestoneStatus={projectMilestoneStatus}
                      projectId={
                        get(projectData, "data.id", null) ||
                        this.state.draftProjectId
                      }
                      userID={userID}
                      userInfo={userInfo}
                      createdBy={createdBy}
                      isMilestoneTableValidated={isMilestoneTableValidated}
                      showPhaseOnBucketComplete={showPhaseOnBucketComplete}
                      isMilestoneEdit={isMilestoneEdit}
                      onClickOfSaveAsDraft={this.onClickOfSaveAsDraft}
                      idOfProject={this.props.projectId}
                      locations={
                        this.state.locations.length > this.state.alterLoc.length
                          ? this.state.locations
                          : this.state.alterLoc
                      }
                      handleStateWiseData={this.handleStateWiseData}
                      deleteStateWiseData={this.deleteStateWiseData}
                      stateWiseData={this.state.stateWiseData}
                      costDistributionData={this.props.costDistributionData}
                      groupId={groupId || this.props.groupId}
                      updatedCall={this.updatedCall}
                      ZIndex={this.ZIndex}
                    />

                    <hr className="cabinet-create-project-hr" />
                  </>
                ) : null}

                <div class="pmg-heading-container mt-4">
                  <div class="left-border" />
                  <h2>PMG MILESTONES</h2>
                </div>
                <Bucket
                  draftLocation={this.state.draftLocation}
                  onStateWisePhaseChange={this.onStateWisePhaseChange}
                  pageDetail={
                    window.location.pathname == "/create-project"
                      ? pageDetail && pageDetail.state
                      : this.props.locations
                  }
                  onChange={this.onBucketChanges}
                  bucketId={selectedBucketId}
                  sponsoredByCategory={sponsoredByCategory == "CENTRAL"}
                  bucketMilestoneCOS={bucketMilestoneCOS.filter(
                    item => item.bucketName !== "Cabinet Milestone"
                  )}
                  milestoneData={sortBy(
                    getBucketsWithMilestonesBySectorData.data.filter(
                      item =>
                        item.bucket && item.bucket.name !== "Cabinet Milestone"
                    ),
                    "bucket.id"
                  )}
                  milestoneTableDataCOS={data}
                  milestoneDataCOS={milestoneDataCOS}
                  responsibleAuthority={getResponsibleAuthorityData.data}
                  _selectedBucketData={_selectedBucketData}
                  createMilestoneAction={createMilestoneAction}
                  saveNewMilestoneAction={saveNewMilestoneAction}
                  deleteNewMilestoneAction={deleteNewMilestoneAction}
                  milestoneError={milestoneError}
                  handleTableOrder={this.handleTableOrder}
                  draftMilestoneAction={_updateDraftedMilestones}
                  projectMilestoneStatus={projectMilestoneStatus}
                  projectId={
                    get(projectData, "data.id", null) ||
                    this.state.draftProjectId
                  }
                  userID={userID}
                  userInfo={userInfo}
                  createdBy={createdBy}
                  isMilestoneTableValidated={isMilestoneTableValidated}
                  showPhaseOnBucketComplete={showPhaseOnBucketComplete}
                  isMilestoneEdit={isMilestoneEdit}
                  onClickOfSaveAsDraft={this.onClickOfSaveAsDraft}
                  idOfProject={this.props.projectId}
                  locations={
                    this.state.locations.length > this.state.alterLoc.length
                      ? this.state.locations
                      : this.state.alterLoc
                  }
                  handleStateWiseData={this.handleStateWiseData}
                  deleteStateWiseData={this.deleteStateWiseData}
                  stateWiseData={this.state.stateWiseData}
                  costDistributionData={this.props.costDistributionData}
                  groupId={groupId || this.props.groupId}
                  updatedCall={this.updatedCall}
                  ZIndex={this.ZIndex}
                />
              </React.Fragment>
            ) : null}
            <div className="fieldset-heading">
              <h2 data-test="section-label-project-supporting-documents">
                Project Supporting Document
              </h2>
              <p>
                Multiple selection of attachment is allowed with max size of
                each attachment as 10 MB. Supported type of files are{" "}
                {DOCUMENT_FORMATS.join(", ")}.
              </p>
            </div>
            <Form.Group className="field-file multiple-attache-file">
              <Files
                className="add-files"
                onChange={this.onFilesChange}
                onError={this.onFilesError}
                multiple={false}
                accepts={DOCUMENT_FORMATS}
                maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                minFileSize={0}
                clickable
                ref={elem => {
                  this.files = elem;
                }}
                data-test="add-files"
              >
                <Image src={IconPlus} alt="Plus Icon" />
                <div className="add-file-text" data-test="label-add-document">
                  Add Document
                </div>
              </Files>
              <div className="uploaded-file-wrapper">
                {this.createFileTemplate()}
              </div>
            </Form.Group>
            {(((isEdit && status === PROJECT_STATUS.DRAFT) || !isEdit) && (
              <div className="submission-btns-wrapper">
                <Button
                  onClick={() => {
                    this.setState(
                      {
                        previewClicked: true
                      },
                      (groupId == 77 && projectCosterror) ||
                        (groupId == 77 && projectrevisedCosterror)
                        ? this.handleCostAPerror
                        : this.onValidateForm.bind(this, "Preview")
                    );
                  }}
                  className="preview-btn"
                  data-test="preview-button"
                >
                  Preview
                </Button>
                {isIIGDraft && (
                  <a
                    href={
                      iigBaseUrl +
                      IIG_PATHS.IIG_PROJECT_UPDATE +
                      // "?updateIIGProject=" +
                      "?iigProject=" +
                      iigProjectReferenceId
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button
                      className="btn-desk save-as-draft-btn btn-green"
                      style={{ "margin-right": "10px" }}
                    >
                      EDIT PROJECT
                    </Button>
                  </a>
                )}
                <Button
                  className="btn-orange-invert btn-desk save-as-draft-btn"
                  onClick={this.onValidateForm.bind(this, PROJECT_STATUS.DRAFT)}
                  data-test="save-as-draft-button"
                >
                  SAVE AS DRAFT
                </Button>
                {isIIGDraft ? (
                  <>
                    {this.loadModalForVerifiedAction()}
                    {this.loadModalForRejectAction()}
                    <Button
                      className="btn-orange btn-desk verification-btn"
                      onClick={this.onValidateForm.bind(this, "verifyIIGDraft")}
                    >
                      VERIFY AND ASSIGN TO PP
                    </Button>
                    <Button
                      className="btn-orange-invert verification-btn preview-btn"
                      onClick={this.handleRejectShow}
                    >
                      REJECT
                    </Button>
                  </>
                ) : (
                  <Button
                    className="btn-orange btn-desk verification-btn"
                    onClick={
                      (groupId == 77 && projectCosterror) ||
                      (groupId == 77 && projectrevisedCosterror)
                        ? this.handleCostAPerror
                        : this.onValidateForm.bind(this, PROJECT_STATUS.UV)
                    }
                    data-test="submit-for-verification-button"
                  >
                    SUBMIT FOR VERIFICATION
                  </Button>
                )}

                <Button
                  className="btn-orange btn-mobo"
                  onClick={this.onValidateForm.bind(this, PROJECT_STATUS.UV)}
                >
                  SUBMIT
                </Button>
              </div>
            )) ||
              null}
            {(isEdit && get(previewData, "edit") && (
              <div
                className="submission-btns-wrapper update-btn"
                style={{ float: "right", marginRight: -20 }}
              >
                <Button
                  data-test="cancel-button"
                  className="btn-orange-invert no-padding btn-cancel btn btn-primary"
                  onClick={() => onCloseModel()}
                >
                  Cancel
                </Button>
                <Button
                  data-test="update-button"
                  className="btn-orange btn-desk"
                  onClick={
                    (groupId == 77 && projectCosterror) ||
                    (groupId == 77 && projectrevisedCosterror)
                      ? this.handleCostAPerror
                      : this.onValidateForm.bind(this, status)
                  }
                >
                  Update
                </Button>
              </div>
            )) ||
              null}
          </Form>
        )}

        <ConfirmationComponent
          show={isConfirmModalVisible}
          content={
            "The project still have unresolved issue(s). Are you sure you want to mark the project as 'COMMISSIONED'?"
          }
          modalClass={"confirmation-modal projectModalBox"}
          saveHandler={() =>
            this.setState({ isConfirmModalVisible: false }, () =>
              this.onBlur(
                implementationStart[2],
                "projectImplementationStartState"
              )
            )
          }
          closeHandler={() => this.setState({ isConfirmModalVisible: false })}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageDetail: state.createProjectReducer.pageDetail,
    isImageUpLoading: state.commonReducer.isImageUpLoading,
    issuesCategoryList: state.commonReducer.issuesList,
    isLoading: state.createProjectReducer.isLoading,
    isApiLoading: state.commonReducer.isApiLoading,
    previewData: state.formReducer.previewData,
    createProjectStatus: state.createProjectReducer.createProjectStatus,
    draftedProjectDetailsStatus:
      state.projectDetailsReducer.draftedProjectDetailsStatus,
    districtListForLocation: state.createProjectReducer.districtListForLocation,
    getBucketsWithMilestonesBySectorData:
      state.createProjectReducer.getBucketsWithMilestonesBySectorData,
    getBucketsWithMilestonesBySectorStatus:
      state.createProjectReducer.getBucketsWithMilestonesBySectorStatus,
    getResponsibleAuthorityData:
      state.createProjectReducer.getResponsibleAuthorityData,
    getResponsibleAuthorityStatus:
      state.createProjectReducer.getResponsibleAuthorityStatus,
    newMilestoneStatus: state.createProjectReducer.newMilestoneStatus,
    editProjectMilestoneStatus:
      state.createProjectReducer.editProjectMilestoneStatus,
    projectData: state.projectDetailsReducer.projectData,
    isBucketIssueExiststatus:
      state.createProjectReducer.isBucketIssueExiststatus,
    isIssueDisableExiststatus:
      state.createProjectReducer.isIssueDisableExiststatus,
    isIssueDeleteExiststatus:
      state.createProjectReducer.isIssueDeleteExiststatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createProjectDispatch: createProjectAction,
      getValidateCinDispatch: getValidateCinAction,
      getSchemesListDispatch: getSchemesListAction,
      getSubSectorListDispatch: getSubSectorListAction,
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction,
      getProjectPageInfoDispatch: getProjectPageInfoAction,
      getCostDistanceDispatch: getCostDistanceAction,
      getIssuesCategoryListAction: getIssuesCategoryListAction,
      getProjectList: getProjectList,
      setProjectDataDispatch: setProjectDataAction,
      getGroupCategoryIdDispatch: getGroupCategoryIdAction,
      getGroupsByCategoryActionDispatch: getGroupsByCategoryAction,
      editProjectDispatch: editProjectAction,
      clearProjectDataDispatch: clearProjectDataAction,
      getDistrictListForLocation: getDistrictListForLocation,
      getCircleListForLocation: getCircleListForLocation,
      getDraftedProjectDetails,
      getBucketsWithMilestonesBySectorAction,
      getResponsibleAuthorityForMilestonesAction,
      createMilestoneAction: createMilestoneAction,
      saveNewMilestoneAction: saveNewMilestoneAction,
      deleteNewMilestoneAction: deleteNewMilestoneAction,
      _updateDraftedMilestones: _updateDraftedMilestones,
      editProjectMilestonesAction,
      checkIssueBeforeDeletion,
      checkIssueBeforeDisable,
      bucketDisableIssueCheck,
      getProjectDetailByIdDispatch: getProjectDetailByIdAction
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CreateProjectForm)
  )
);
